const brand = sessionStorage.getItem('brand');
export const botBuilder = {
  canvas: {
    chatflowBuilderLoading: 'Ngritja e Konstruktorit të Chatflow...',
    slowNetworkDetected: 'Detektuar rrjet i ngadaltë',
    editYourChatFlow: 'Redakto chat flow-in tënd',
    seeHowToUse: 'Shiko si të përdoret',
    help: 'Ndihmë',
    classicBuilder: 'Ndërtuesi Klasik',
    visualiseFlow: 'Visualizo Flow',
    testLiveOnTelegramWeb: 'Testo Live Në Telegram Web',
    testFlow: 'Testo flow-in',
    importTemplate: 'Importo modelin',
    landingPageBotReview: 'Rishiko Botin në Faqen e Ndalimit',
    install: 'Instalo',
    testLiveOnMessengerWeb: 'Testo Live Në Messenger Web',
    testLiveOnWhatsappWeb: 'Testo Live Në WhatsApp Web',
    testLiveOnInstagramWeb: 'Testo Live Në Instagram Web',
    seeAllChatFlow: 'Shiko të gjitha Chat Flows',
    launchDemoModal: 'Nisi modalitetin demo',
    selectATemplateToKickStartYourBot:
      'Zgjidh një model për të nisur botin tënd',
    hireChatBotDesigner: 'Puno me një Dizajnues Chatbot',
    recommendedForYou: 'Rekomanduar për ty',
    useTemplate: 'Përdor modelin',
    exportStatus: 'Statusi i eksportit',
    flowExport: 'Eksporto Flow-in',
    download: 'Shkarko',
    importFlow: 'Importo Flow-in',
    beforeYouStartUploadPleaseMakeSure:
      'Para se të filloni ngarkimin, sigurohuni',
    ponit1: '1. Kufiri maksimal i madhësisë së dosjes për ngarkim është 20MB',
    point2: '2. Format i dosjes duhet të jetë në JSON',
    selectFile: 'Zgjidh Dosjen',
    preview: 'Parashiko',
    test: 'Testo',
    OopsIntegrationAreNotAvailable:
      'Ups! Integrime nuk janë në dispozicion në ',
    pleaseUpgradeTo: ' Ju lutemi përmirësohuni në ',
    planForIntegration: ' për integrime.',
    areYouSure: 'A jeni të sigurt?',
    yesUseTemplate: 'Po, Përdor Modelin!',
    importTemplateDescription:
      'Importimi i këtij modeli do të zëvendësojë chatflow-in ekzistues. Çdo ndryshim i pa ruajtur do të humbasë.',
    placeholders: {
      searchTemplateYouNeed: 'Kërko modelin që të nevojitet',
    },
    noDataFound: {
      botFlow: 'Bot Flow',
      noBotFlowAddedYet: 'Asnjë bot flow i shtuar ende!',
      templates: 'Modelet',
      noTemplatesFound: 'Nuk u gjet asnjë model!',
    },
    appTooltip: {
      exportFlow: 'Eksporto Flow-in',
      importFlow: 'Importo Flow-in',
      clickToViewChatFlow:
        'Kliko për të parë chat flow-in në ndërtuesin "drag and drop"',
      clickToPreviewChatFlow: 'Kliko për të paraparë chat flow-in',
      clickToViewChatFlowAsFlowDiagram:
        'Kliko për të parë chat flow-in si një diagramë fluksi',
      clickToTestChatFlow: 'Kliko për të testuar chat flow-in',
      clickToSelectAndImportTemplate:
        'Kliko për të zgjedhur dhe importuar modelin që përshtatet më mirë biznesit tuaj.',
      clickToInstallYourBotToSelectedPlatform:
        'Kliko për të instaluar botin në platformën e zgjedhur',
      clickToTestDefaultFlowOfTelegramBot: `Kliko për të testuar flow-in e parazgjedhur (aktiv) të botit tënd në Telegram web`,
      clickToTestDefaultFlowOfFacebookBot: `Kliko për të testuar flow-in e parazgjedhur (aktiv) të botit tënd në Facebook web`,
      clickToTestDefaultFlowOfWhatsappBot: `Kliko për të testuar flow-in e parazgjedhur (aktiv) të botit tënd në WhatsApp web`,
      clickToTestDefaultFlowOfInstagramBot: `Kliko për të testuar flow-in e parazgjedhur (aktiv) të botit tënd në Instagram web`,
    },
  },
  createNewBot: {
    createNewBot: 'Krijo Bot të Ri',
    stepOneOfTwo: 'Hapi 1 nga 2',
    selectThePlatform: 'Zgjidh Platformën',
    selectTheBotType: 'Zgjidh Tipin e Botit',
    aiBasedChatbot: 'Chatbot bazuar në AI',
    ruleBasedChatBot: 'Chatbot bazuar në Rregulla',
    webPlatforms: 'Platformat në Internet',
    websiteChatBot: 'Chatbot i Faqes së Internetit',
    withLiveChat: '(Me Chat Live)',
    landingPageBot: 'Bot i Faqes së Ndalur',
    liveChatWidget: 'Widget i Chatit Live',
    onlyLiveChat: '(Vetëm Chat Live)',
    socialPlatforms: 'Platformat Sociale',
    whatsappChatBot: 'WhatsApp Chatbot',
    telegramChatBot: 'Telegram Chatbot',
    facebookChatBot: 'Facebook Chatbot',
    instagramChatBot: 'Instagram Chatbot',
    selectBotType: 'Zgjidh Tipin e Botit',
    selectProblem: 'Zgjidh problemën që dëshiron të zgjidhësh',
    leadGeneration: 'Generim i Ndarëve',
    customerSupport: 'Mbështetje për Klientët',
    appointmentBooking: 'Rezervimi i Takimeve',
    marketingAutomation: 'Automatizimi i Marketingut',
    ecommerceWebsite: 'Faqja e Internetit E-commerce',
    otherUseCase: 'Raste të tjera',
    back: 'Prapa',
    typeDomainUrl: 'Shkruaj URL-në e faqes tënde për verifikim.',
    dataSourceForChatBotTraining:
      'Burimi i të dhënave për trajnimin e Chat Botit',
    upload: 'Ngarko',
    uploadDocuments: 'Ngarko Dokumenta',
    uploadDocument: 'Ngarko Dokument',
    selectFile: 'Zgjidh Dosjen',
    continue: 'Vazhdo',
    websiteUrl: 'Shkruaj URL-në e faqes tënde',
    skipNow: 'Kalo tani',
    completeTheExistingBotSetup: 'Plotëso rregullimin ekzistues të botit',
    youHaveAlreadyCreatedOneWhatsAppBot:
      'Ti tashmë ke krijuar një WhatsApp Bot, Ju lutemi plotësoni rregullimin për të krijuar një të ri.',
    completeSetup: 'Plotëso Rregullimin',
    seeHowToUse: 'Shiko si të përdoret',
    help: 'Ndihmë',
    fbBot: {
      createNewBot: 'Krijo Bot të Ri',
      help: 'Ndihmë',
      back: 'Prapa',
      step: 'Hapi ',
      of3: ' nga 3',
      loginWithFacebook: 'Hyrje me Facebook',
      asPerLatestChangesInFacebookPolicy:
        'Sipas ndryshimeve më të fundit në politikat e Facebook, pronari i botit në Facebook duhet të ketë rolin e "menaxherit" ose më të lartë për të pasur qasje në të gjitha veçoritë e faqes në Facebook.',
      login: 'Hyrje',
      connectFacebookBot: 'Lidh Facebook Botin',
      connectBotWithYourFacebookPagesAnd:
        'Lidh Botin me Faqet e tua në Facebook dhe ',
      exploreTruePowerOfFacebook: 'eksploro fuqinë e vërtetë të Facebook',
      connect: 'Lidh',
      connected: 'I Lidhur',
      createNewPage: 'Krijo Faqe të Re',
      refreshPageList: 'Rifresko Listën e Faqeve',
      thisPageIsSuccessfullyIntegratedWith:
        'Kjo faqe është integruar me sukses me ',
      yourMessagesFromMessengerWillAppearIn:
        '. Mesazhet tuaja nga Messengeri do të shfaqen në ',
      inbox: ' Inbox',
      continueToBotConfiguration: 'Vazhdo në Konfigurimin e Botit',
      welcomeToBrandNameWeAreHereToHelpYou: `Mirë se vini në ${brand}. Ne jemi këtu për t'ju ndihmuar.`,
      letsTryYourBotAndSeeHowItWorks: `Le të provojmë botin tënd dhe shohim si funksionon! Kliko "Testo në Facebook".`,
      howAreYouDoingToday: 'Si jeni sot?',
      thisIsHowSimpleToUseFacebookBot: `Kaq e thjeshtë është të përdoret Facebook Boti`,
      letsCreateYourOwnChatFlowNow: `Le të krijojmë tani chat flow-in tënd`,
    },
    instagramBot: {
      createNewBot: 'Krijo Bot të Ri',
      back: 'Prapa',
      step: 'Hapi ',
      of3: ' nga 3',
      loginWithInstagram: 'Hyrje me Instagram',
      loginToYourInstagramAccount:
        'Hyr në llogarinë tënde në Instagram për të aktivizuar chatbotin në dorëzën tënde.',
      managerLevelDescription:
        'Pronarët e botëve në Instagram duhet të kenë të paktën lejen e nivelit "menaxher" ose më të lartë për të patur qasje në të gjitha veçoritë.',
      login: 'Hyrje',
      connectInstagramBot: 'Lidh Instagram Botin',
      connectBotWithYourInstagramAnd: 'Lidh Botin me Instagramin tënd dhe ',
      exploreTruePowerOfInstagram: ' eksploro fuqinë e vërtetë të Instagramit',
      connected: 'I Lidhur',
      connect: 'Lidh',
      createNewPage: 'Krijo Faqe të Re',
      refreshPageList: 'Rifresko Listën e Faqeve',
      thisPageIsSuccessfullyintegratedWith:
        'Kjo faqe është integruar me sukses me ',
      yourMessagesFromMessengerWillAppearIn:
        '. Mesazhet tuaja nga Messengeri do të shfaqen në ',
      inbox: ' Inbox',
      continueToBotConfiguration: 'Vazhdo në Konfigurimin e Botit',
      welcomeToBrandNameWeAreHereToHelpYou: `Mirë se vini në ${brand}. Ne jemi këtu për t'ju ndihmuar.`,
      letsTryYourBotAndSeeHowItWorks: `Le të provojmë botin tënd dhe shohim si funksionon! Kliko "Testo në Instagram".`,
      howAreYouDoingToday: 'Si jeni sot?',
      thisIsHowSimpleToUseInstagramBot: `Kaq e thjeshtë është të përdoret Instagram Boti`,
      letsCreateYourOwnChatFlowNow: `Le të krijojmë tani chat flow-in tënd`,
    },
    telegramBot: {
      back: 'Prapa',
      step: 'Hapi ',
      of3: ' nga 3',
      seeHowToUse: 'Shiko si të përdoret',
      help: 'Ndihmë',
      loginToYourTelegramAccount: 'Hyr në Llogarinë tënde në Telegram',
      loginToYourAccountToCreateNewBotOrConnectExistingBot:
        'Hyr në llogarinë tënde për të krijuar një bot të ri ose lidh botin ekzistues',
      verificationCodeSentOnRegisteredNumber:
        'Kodi i verifikimit është dërguar në numrin e regjistruar',
      createYourBot: 'Krijo Botin tënd',
      enterYourBotsNameAnd: `Shkruaj emrin e botit tënd, lidh dhe lejo argëtimin me `,
      botUserNameMustEndWithBotAtTheEnd:
        'Emri i përdoruesit i botit duhet të përfundojë me "bot" në fund.',
      terrisBot: 'P.sh. teris_bot ose terisbot',
      botNameAlreadyTaken:
        'Ky emër i botit është tashmë i zënë. Ju lutemi provoni diçka tjetër',
      connect: 'Lidh',
      createBot: 'Krijo Bot',
      codeNotReceivedResend: 'Kodi nuk është marrë? Ritërgykoje!',
      changeNumber: 'Ndrysho Numrin',
      telegramPreview: 'Paraparje e Telegramit',
      worldsFastestMessagingApp: `Aplikacioni më i shpejtë i Mesazheve në Botë dhe është falas!`,
      bot: 'Bot',
      phoneNumber: 'Numri i telefonit',
      userName: 'Emri i përdoruesit',
      none: 'Asnjë',
      bio: 'Bio',
      fewWordsAboutYourself: 'Pak fjalë rreth vetes',
      settings: 'Cilësimet',
      notificationsAndSound: 'Njoftime dhe tinguj',
      privacyAndSecurity: 'Privatësia dhe Siguria',
      dataAndStorage: 'Të dhënat dhe Depozita',
      chatSettings: 'Cilësimet e Bisedës',
      chatFolders: 'Dosjet e Bisedave',
      devices: 'Pajisjet',
      connectYourBot: 'Lidh Botin tënd',
      createNewBotOrConnectWithExistingOne:
        'Krijo një Bot të Ri ose Lidh një Ekzistues',
      createNewBot: 'Krijo Bot të Ri',
      welcomeToBrandNameWeAreHereToHelpYou: `Mirë se vini në ${brand}. Ne jemi këtu për t'ju ndihmuar.`,
      letsTryYourBotAndSeeHowItWorks: `Le të provojmë botin tënd dhe shohim si funksionon! Kliko "Testo në Telegram".`,
      howAreYouDoingToday: 'Si jeni sot?',
      thisIsHowSimpleToUseTelegramBot: `Kaq e thjeshtë është të përdoret Telegram Boti`,
      letsCreateYourOwnChatFlowNow: `Le të krijojmë tani chat flow-in tënd`,
      placeholders: {
        searchCountry: 'Kërko Shtet',
        enterTelegramMobileNumber: 'Shkruaj Numrin e Telefonit në Telegram',
        enterLoginCodeReceived:
          'Shkruaj kodin e hyrjes të pranuar në llogarinë në Telegram *',
        twoFactorAuthentication: '2FA fjalëkalim (opsional)',
        botName: 'Emri i Botit *',
        botUserName: 'Emri i Përdoruesit të Botit *',
      },
    },
    websiteLandingPageLiveChatBot: {
      createNewBot: 'Krijo Bot të Ri',
      seeHowToUse: 'Shiko si të përdoret',
      help: 'Ndihma',
      back: 'Prapa',
      step: 'Hapi ',
      of2: ' nga 2',
      buildA: 'Krijo një ',
      thatMatchesYourBrandPersonality: ` që korrespondon me personalitetin e markës tuaj`,
      chatBotIcon: 'Ikonë e Chatbot ',
      optional: 'Opsionale',
      themeColor: 'Ngjyra e Temës',
      chatBotName: 'Emri i Chatbot',
      botNameIsRequired: 'Kërkohet emri i botit',
      botNameShouldBeLessThan50Characters:
        'Emri i Botit duhet të jetë nën 50 karaktere',
      continue: 'Vazhdo',
      welcomeToBrandNameWeAreHereToHelpYou: `Mirësevini në ${brand}. Ne jemi këtu për t'ju ndihmuar.`,
      whatIsYourEmailAddress: 'Cila është adresa juaj e emailit?',
      invalidEmailAddress: 'Adresa e emailit është e pavlefshme',
      customizeYourLandingPageBotLook:
        'Përshtatni pamjen e botit tuaj të faqes së nisjes',
      customizeYourWidgetLook: 'Përshtatni pamjen e widgetit tuaj',
      customizeYourBotLook: 'Përshtatni pamjen e botit tuaj',
      buildYourLandingPageBotAndAutomateInteraction:
        'Krijo botin tënd të faqes së nisjes dhe automatizo ndërveprimin me klientët duke ndarë linkun e tij',
      useLiveChatBotToConnectToCustomers:
        'Përdorni Live Chat Bot për të lidhur me klientët tuaj në kohë reale',
      connectChatBotToYourWebsiteAndAutomateInteractions:
        'Lidhni ChatBot me faqen tuaj dhe automatizoni ndërveprimet me vizitorët',
      widget: 'widget',
      botInterface: 'faqja e botit',
      mergedBot: 'Website Chatbot, Landing Page Bot, Mobile App Chatbot',
      mergedBotToolTip:
        'Krijo një faqe boti për të kapur vëmendjen e vizitorëve dhe angazhuar ata në biseda.',
      placeholders: {
        typeANameForYourBot: 'Shkruani një emër për botin tuaj të ri',
      },
      appTooltip: {
        TOOLTIP_WEBSITE_BOT_NAME: 'Vendosni emrin e botit tuaj',
        mergedBotToolTip:
          'Krijo një faqe boti për të kapur vëmendjen e vizitorëve dhe angazhuar ata në biseda.',
        TOOLTIP_WEBSITE_BOT_THEME_COLOR:
          'Zgjidhni një ngjyrë teme për dritaren tuaj të bisedës',
        thisLogoWillBeUsedInTheBrandNamePlatformOnly: `Kjo logon do të përdoret vetëm në platformën ${
          brand ? brand : ''
        }. Këshillojmë të zgjidhni logon e kompanisë suaj. Shtoni një imazh të kvadratit PNG ose JPG nën 1 MB.`,
      },
    },
    whatsappBot: {
      back: 'Prapa',
      justAStepAway: 'Vetëm një hap larg',
      seeHowToUse: 'Shiko se si të përdoret',
      help: 'Ndihma',
      createWhatsappChatBot: 'Krijo Chatbot në WhatsApp',
      businessNameIsRequired: 'Emri i Biznesit është i detyrueshëm.',
      maximumLengthForBusinessName40Characters:
        'Gjatësia maksimale për Emrin e Biznesit është 40 karaktere.',
      businessCategory: 'Kategoria e Biznesit',
      categoryIsRequired: 'Kategoria është e detyrueshme.',
      descriptionIsRequired: 'Përshkrimi është i detyrueshëm.',
      maximumLengthForDescription200Characters:
        'Gjatësia maksimale për përshkrim është 200 karaktere.',
      pleaseFillAValidEmailAddress:
        'Ju lutemi plotësoni një adresë të vlefshme të emailit të biznesit.',
      businessEmailIsRequired: 'Emaili i biznesit është i detyrueshëm.',
      phoneNumberShouldHaveMinimum7Digits:
        'Numri i telefonit duhet të ketë të paktën 7 shifra',
      phoneNumberIsRequired: 'Numri i telefonit është i detyrueshëm',
      websiteIsRequired: 'Website është i detyrueshëm.',
      maximumLengthForWebsite40Characters:
        'Gjatësia maksimale për Website është 40 karaktere.',
      maximumLengthForAddress150Characters:
        ' Gjatësia maksimale për adresë është 150 karaktere.',
      doYouHaveWhatsappApiKey: 'A keni çelësin API të WhatsApp?',
      apiProvider: 'Ofruesi i API',
      three60Dialog: '360 Dialog',
      whatsappCloud: 'WhatsApp Cloud',
      netcore: 'Netcore',
      apiKeyIsRequired: 'Çelësi API është i detyrueshëm.',
      whatsappBusinessAccountIdIsRequired:
        'ID e Llogarisë së Biznesit në WhatsApp është e detyrueshme.',
      whatsappPhoneNumberIdIsRequired:
        'ID e Numrit të Telefonit në WhatsApp është e detyrueshme.',
      systemAccessTokenIsRequired:
        'Tokeni i Hyrjes në Sistem është i detyrueshëm.',
      sourceIdIsRequired: 'ID e Burimit është e detyrueshëme.',
      businessName: 'Emri i Biznesit',
      businessAccount: 'Llogaria e Biznesit',
      businessDescription: 'Përshkrimi i Biznesit',
      address: 'Adresa',
      businessEmail: 'Emaili i Biznesit',
      websiteUrl: 'URL-i i Website-it',
      thankYouForYourInterestIn: 'Ju falenderojmë për interesimin tuaj në ',
      whatsappChatBot: ' WhatsApp Chatbot.',
      weHaveReceivedYourInterests:
        'Kemi marrë interesimin tuaj, dhe ekipi ynë i Shitjeve do të jetë në kontakt me ju në 24 orët e ardhshme.',
      theyWillProvideYouWhatsappApiKey: `Ata do t'ju sigurojnë Çelësin API të WhatsApp.`,
      readyToCreateWhatsappBot: `Jam gati për të krijuar WhatsApp Bot`,
      exploreWhatsappFeatures: 'Eksploro karakteristikat e WhatsApp',
      welcomeToBrandNameWeAreHereToHelpYou: `Mirë se vini në ${brand}. Ne jemi këtu për t'ju ndihmuar.`,
      letsTryYourBotAndSeeHowItWorks: `Le të provojmë botin tënd dhe të shohim se si funksionon! Kliko "Testo në WhatsApp".`,
      howAreYouDoingToday: 'Si po kaloni sot?',
      thisIsHowSimpleToUseWhatsappBot: `Kaq e thjeshtë është ta përdorësh botin në WhatsApp`,
      letsCreateYourOwnChatFlowNow: `Le të krijojmë tani rrjedhën tënde të bisedës`,
      connectWhatsAppBot: 'Lidh WhatsApp Botin',
      createtWhatsAppBot: 'Plotësoni Detajet e Biznesit Tuaj',
      proceed: 'Vazhdo',
      whatsApiProvider: 'Ofruesi i WhatsApp API',
      cloudApi: 'Cloud API',
      netcoreApi: 'Netcore API',
      loginWithFacebook: 'Hyr me Facebook për Onboarding në WhatsApp',
      asPerLatestChangesInFacebook:
        'Sipas ndryshimeve të fundit në politikat e Facebook, pronari i botit në Facebook duhet të ketë rolin admin për të patur qasje në të gjitha veçoritë e faqes së Facebook-ut.',
      login: 'Hyrje',
      successWhatsAppOnboarding: 'Sukses! Llogaria në WhatsApp është miratuar!',
      congratulationYourWhatsApp:
        'Urime, numri juaj në WhatsApp është miratuar. Përditësoni metodën tuaj të pagesës për të filluar përdorimin e botit tuaj.',
      sendFirstMessage: 'Dërgo Mesazhin e Parë',
      editYourChatFlow: 'Redakto rrjedhën tënde të bisedës',
      overview: 'Pasqyra',
      oopsErrorOccurred: 'Ups! Ndodhi një gabim gjatë Onboarding',
      oopsSomethingWentWrong:
        'Ups! Diçka shkoi gabim gjatë procesit të Onboarding. Ju lutemi rishikoni informacionin tuaj dhe provoni përsëri. Nëse problemi vazhdon, kontaktoni ekipin tonë të mbështetjes për ndihmë.',
      setupManually: 'Konfiguro Manualisht',
      retryWithAutomatedOnboarding: 'Riprovo me Onboarding automatik',
      placeholders: {
        yourBusinessName: 'Emri i Biznesit Tuaj',
        businessDescription: 'Përshkrimi i Biznesit',
        businessEmail: 'Emaili i Biznesit',
        phone: 'Telefoni*',
        website: 'Website (p.sh. www.shembull.com)',
        address: 'Adresa',
        enterApiKey: 'Vendosni Çelësin API',
        enterWhatsappBusinessAccountId:
          'Vendosni ID e Llogarisë së Biznesit në WhatsApp',
        enterWhatsappPhoneNumberId:
          'Vendosni ID e Numrit të Telefonit në WhatsApp',
        enterSystemAccessToken: 'Vendosni Tokenin e Hyrjes në Sistem',
        enterSourceId: 'Vendosni ID e Burimit',
        businessName: 'Emri i Biznesit',
        businessWebsite: 'Website-i i Biznesit',
        selectWhatsappApiProvider: 'Zgjidh Furnizuesin e WhatsApp API',
      },
      stepFour: {
        chooseYourWhatsAppAPIProvider: 'Zgjidh Furnizuesin e WhatsApp API',
        doYouHaveWhatsAppBusinessAPI: 'A keni WhatsApp Business API?',
        yes: 'Po',
        noIAmNotSure: 'Jo, nuk jam i sigurt',
        selectApiProvider: 'Zgjidh Furnizuesin e API',
        whatsAppCloudAPI: 'WhatsApp Cloud API',
        enterYourPhoneNumberId: 'Vendosni ID e Numrit tuaj të Telefonit',
        phoneNumberId: 'ID e Numrit të Telefonit',
        enterYourWhatsAppBusinessAccountId:
          'Vendosni ID e Llogarisë së Biznesit në WhatsApp',
        whatsAppBusinessAccountId: 'ID e Llogarisë së Biznesit në WhatsApp',
        enterYourSystemUserToken:
          'Vendosni Tokenin tuaj të Përdoruesit të Sistemit',
        systemUserToken: 'Tokeni i Përdoruesit të Sistemit',
        help: 'Ndihma',
        netcoreAPI: 'Netcore API',
        enterYourSourceId: 'Vendosni ID e Burimit tuaj',
        sourceId: 'ID e Burimit',
        enterYourNetcoreApiKey: 'Vendosni Çelësin tuaj të API të Netcore',
        netcoreApiKey: 'Çelësi i API të Netcore',
        submit: 'Dërgo',
        noneOftheAbove: 'Asnjëra nga Më Poshtu',
        next: 'Tjetra',
      },
      stepTwo: {
        legallyRegisteredBusiness: 'Biznes i regjistruar ligjërisht',
        validWebsiteWithDataPrivacyPolicy:
          'Uebsajt i vlefshëm me politikë të privatësisë së të dhënave',
        debit: 'Dëbiti',
        creditCard: 'Kartë krediti',
        gstin: 'GSTIN',
        onlyRequiredForIndianResidents: 'E nevojshme vetëm për banorët indianë',
        onlyRequiredFor: 'E nevojshme vetëm për',
        indianResidents: 'banorët indianë',
        validPaymentMethod: 'Metodë e vlefshme e pagesës',
        enabledWithInternationalPayments: 'Aktivizuar me pagesa ndërkombëtare',
        validUseCaseInComplianceWithWhatsAppCommercePolicy:
          'Rast përdorimi i vlefshëm në përputhje me politikën e tregtisë së WhatsApp',
        PhoneNumberWhichDoesNotHaveActiveWhatsAppAndCapableOfReceivingTheSMS:
          'Numri i telefonit që nuk ka WhatsApp aktiv dhe është në gjendje të marrë SMS',
        discard: 'Hiqe',
        proceed: 'Vazhdo',
        whatsAppBotPrerequisites: 'Kushtet paraprake të WhatsApp Bot',
        letUsGetItDoneForYou: 'Le të kryejmë për ju!',
        ifYouAreFacingSomeIssues: 'Nëse keni disa probleme',
        ourTeamCanHelpYouDoTheSame: `Ekipi ynë mund t'ju ndihmojë të bëni të njëjtën gjë`,
        requestACallbackNow: 'Kërkoni një rikthim tani!',
      },
      stepThree: {
        setupWhatsAppBot: 'Rregullo Botin WhatsApp',
        selectingTheBestBusinessManagerForYourNeeds:
          'Zgjedhja e Menaxherit të Biznesit më të Mirë për Nevojat Tuaja',
        createMetaApp: 'Si të krijoni Meta App',
        createaMetaAppOn: 'Krijoni një Meta App në',
        howToCreate: 'Si të krijosh',
        addWhatsAppNumber: 'Si të shtosh numrin e WhatsApp',
        addYourWhatsAppNumberAndVerifyTheSame:
          'Shtoni numrin tuaj të WhatsApp dhe verifikoni të njëjtën',
        subscribe: 'Abonohu',
        copyAndSubscribeWebhook: 'Kopjo dhe abonohu në Webhook',
        howToSubscribe: 'Si të abonohesh',
        copy: 'Kopjo',
        appSecretId: 'ID e Sekretit të Aplikacionit',
        enterYourAppSecretId: 'Vendos ID e Sekretit të Aplikacionit tuaj',
        enterAppSecret: 'Vendos Sekretin e Aplikacionit',
        phoneNumberId: 'ID e Numrit të Telefonit',
        whatsAppBusinessId: 'ID e Biznesit WhatsApp',
        assignSystemUser: 'Si të Caktoni Përdoruesin e Sistemit',
        assign: 'Cakto',
        createApp: 'Krijo Meta',
        registerAndVerify: 'Regjistrohu dhe Verifikimi',
        add: 'Shto',
        systemUserToken: 'Token i Përdoruesit të Sistemit',
        enterYourSystemUserToken:
          'Vendos Tokenin e Përdoruesit të Sistemit tuaj',
        getAllNecessaryDetails: 'Si të Merrni të Gjitha Detajet e Nevojshme',
        subscribeWhatsAppWebhook: 'Si të abonohesh në WA Webhook',
        configureTheWebhookForWhatsAppAccount:
          'Konfiguro Webhook për llogarinë WhatsApp',
        upadatePaymentMethod: 'Si të përditësoni Metodën e Pagesës',
        assignThePaymentMethodToWhatsAppAccount:
          'Cakto metoden e pagesës për ndonjë llogari WhatsApp',
        grantControlOfWhatsAppBusinessAccountToASystemUser:
          'Cakto kontrollin e llogarisë së biznesit të WhatsApp një përdoruesi sistemi',
        keyDetailsThatYouNeedToCopyFromMetaDashboard:
          'Detajet kyçe që duhet t\'i kopjoni nga Paneli Meta',
        updatePayment: 'Përditëso Pagesën',
        letUsGetItDoneForYou: 'Le të kryejmë për ju!',
        ifYouAreFacingSomeIssues: 'Nëse keni disa probleme',
        ourTeamCanHelpYouDoTheSame:
          'Ekipi ynë mund t\'ju ndihmojë të bëni të njëjtën gjë',
        requestACallbackNow: 'Kërkoni një rikthim tani!',
        update: 'Përditëso',
        connectNow: 'Lidhu Tani',
      },
      stepFive: {
        selectBusinessManager: 'Zgjidh Menaxherin e Biznesit',
        selectingTheBestBusinessManagerForYourNeeds:
          'Zgjedhja e Menaxherit të Biznesit më të Mirë për Nevojat Tuaja',
      },
      stepSix: {
        yourBotIsInstalledAndActive: 'Botsi juaj është i instaluar dhe aktiv',
        youhaveSuccessfullyConnected: 'Keni lidhur me sukses',
        withWhatsApp: 'me WhatsApp',
        youHaveBeenAllocaated100ConversationsPerMonthByDefault:
          'Ju janë caktuar 100 biseda në muaj si parazgjedhje',
        upgradeYourPlanForMore: 'Përmirëso planetë tuaja për më shumë.',
        createChatFlow: 'Krijo Fluksin e Bisedës',
        upgradePlan: 'Përmirëso Planin',
      },
      activeDemoBotStepFive: {
        scanQrOrSendMessageToActivateBot:
          'Skanoni Qr ose dërgoni mesazh për të aktivizuar Botin',
        scanTheQrCodeFrom: 'Skanoni kodin Qr nga',
        yourPhoneWillOpen:
          'Telefoni juaj do të hapë një mesazh të paraplotuar për t\'u dërguar në numrin tonë Sandbox. Shtypni \'Dërgo\' në WhatsApp',
        sendMessageFromYourWhatsAppNumber:
          'Dërgoni mesazhin nga numri juaj i WhatsApp',
        sendUsAWhatsAppMessageOn: 'Dërgoni një mesazh WhatsApp në ',
        bySavingInYourContactsAndMessageShouldStartwith:
          ' duke e ruajtur në kontaktet tuaja dhe mesazhi duhet të fillojë me ',
        send: 'Dërgo',
        or: 'OSE',
      },
      phoneNumberSetup: {
        waPhoneNoSetup: 'Rregullimi i Numrit WhatsApp',
        loginWithFb: 'Hyrje me Facebook për Onboardimin e WhatsApp',
        continueWithFb: 'Vazhdo me Facebook',
        connectAPIKey: 'Lidhu me Çelësin API',
        apiKeyContinue:
          'Nëse keni numrin e verifikuar dhe Çelësin API, atëherë ndiqni hapat e mëposhtëm për të vazhduar rregullimin',
        connectWaNo: 'Lidh Numrin e WhatsApp',
      },
    },
  },
  gettingStarted: {
    hello: 'Tungjatjeta, ',
    upgrade: 'Përmirëso',
    gettingStarted: 'Nisja - ',
    yourFacebookBotToken: 'Tokeni juaj i botit në Facebook ',
    hasBeenExpired: 'ka skaduar',
    isExpiringIn: 'po skadon në ',
    days: ' ditë',
    facebookAuthenticationTokenRemainsFor60Days:
      'Tokeni i autentifikimit në Facebook mbetet i aktive vetëm për 60 ditë',
    kindlyProceedWithTheRenewalOfYourBotToken:
      'Ju lutemi vazhdoni me rinovimin e tokenit të botit tuaj për të siguruar qasje të pa ndërprerë në shërbimet e chatbotit.',
    renewYourBotToken: 'Rinovo tokenin tënd të botit',
    editYourChatFlow: 'Redakto flukset e bisedës tuaj',
    buildConversationEngagingBot:
      'Krijoni fluksa tërheqëse bisede për përdoruesit e botit tuaj.',
    takes5minutes: 'duhen 5 minuta',
    previewYourLiveChatWidget:
      'Shiko paraprakisht widgetin tënd të bisedës në drejtpërdrejtë',
    discoverHowThe: 'Zbulo se si ',
    liveChatFeatureWorks:
      'Funksionon veçoritë e bisedës në drejtpërdrejtë përdorur lojën tonë të bisedës në drejtpërdrejtë',
    takes2minutes: 'duhen 2 minuta',
    takes1minute: 'duhet 1 minutë',
    connected: 'I lidhur',
    customizeYourBotApperance: `Rregullo pamjen dhe funksionet e botit tënd.`,
    takes3minutes: 'duhen 3 minuta',
    thirdPartyAppsIntegration: 'Integrimi i Aplikacioneve të Partive të Treta',
    integrateYourBot:
      'Integro botin tënd me Aplikacione/CRMs të tjerë për të krijuar automatizim biznesi.',
    upgradeYourPlanToReceiveLeadsInEmail:
      'Përmirëso planin tënd për të marrë të dhënat në emailin tënd',
    getStartedWithUs: 'Fillo me ne',
    howToBuildAGoodChatFlow: 'Si të krijojë një fluks bisede të mirë',
    howToUseBotPenguinsInboxAndItsFeatures: `Si të përdorësh Inbox-in e BotPenguin dhe veçoritë e tij`,
    botPenguinsPricing: `Çmimet e BotPenguin: Eksploroni planet dhe veçoritë`,
    openHelpDesk: 'Hap ndihmësinë',
    helpAndSupport: 'Ndihmë dhe mbështetje',
    extensiveGuides:
      'Udhëzime të gjera për të gjitha pyetjet dhe rrjedhat tuaja të punës janë në dispozicion në ',
    resourceCentre: 'Qendër burimore',
    checkoutOurAnswers:
      'Mund të shihni përgjigjet tona për pyetjet e zakonshme më poshtë.',
    createANewBot: 'Krijo një bot të ri',
    installYourBot: 'Instalo botin tënd',
    plansAndPricing: 'Plane dhe Çmimet',
    previewYourLandingPageBot:
      'Shiko paraprakisht botin tënd të faqes së zbarkimit',
    installYourLiveChatWidget:
      'Instalo widgetin tënd të bisedës në drejtpërdrejtë',
    installYourWebsiteBot:
      'Instalo botin tënd në faqen e internetit, aplikacionin mobil ose lancoje si faqe e zbarkuar ose bot të ngulitur',
    integrateBotToLandingPage: 'Integro botin në faqen tënde të zbarkuar',
    installWidgetToWebsite: 'Instalo widgetin në faqen tënde të internetit',
    installBotToWebsite: 'Instalo botin tënd të bisedës',
    whatsappAutomation: 'Automatizimi i WhatsApp',
    facebookAutomation: 'Automatizimi në Facebook',
    telegramBotSettings: 'Cilësimet e Botit në Telegram ',
    liveChatWidgetSettings: 'Cilësimet e Widgetit të Bisedës në Drejtpërdrejtë',
    landingPageBotSettings: 'Cilësimet e Botit në Faqen e Zbarkuar',
    websiteChatBotSettings:
      'Cilësimet e Botit të Bisedës në Faqen e Internetit',
    instagramAutomation: 'Automatizimi në Instagram',
    diveDeeperIntoBotPenguin: 'Përhapuni më thellë në BotPenguin',
    knowWhereWeAreGoing:
      'Dini ku po shkojmë, përditësimet e fundit dhe na ndihmoni të rregullojmë disa gabime.',
    productUpdates: 'Përditësime të Produktit',
    requestAFeature: 'Kërko një veçori',
    reportABug: 'Raporto një gabim',
    prodcutRoadmap: 'Planifikimi i Produktit',
    trainYourChatbot: 'Streho botin tënd të bisedës AI (Baza e njohurive)',
    buildEngagingConversation:
      'Krijoni fluksa tërheqëse bisede për përdoruesit e botit tuaj.',
    previewYourAIBot: 'Shiko paraprakisht botin tënd të AI',
    integrateAIbot: 'Integro botin me botin tënd të AI',
    aiBotSettings: 'Cilësimet e Botit të AI',
    CustomizeAIBot: 'Rregullo pamjen dhe funksionet e botit tënd.',
    gptKeyWarning:
      'Njoftim: Mund të përdorni deri në 100 mesazhe GPT për bot. Për të vazhduar përdorimin përtej kufirit të vendosur, ju lutemi të lidhni çelësin tuaj të veçantë të API GPT nën Konfigurimin e Modelit ChatGPT.',
    whatsappBotSettings: 'Cilësimet e Botit në WhatsApp',
    automateCustomerEngagementWithWhatsApp:
      'Automatizo angazhimin e klientëve me WhatsApp.',
    connectToYourWhatsappNumber: 'Lidhu me numrin tënd të WhatsApp',
    connectYourWhatsappBotWithYourWhatsappNumber:
      'Lidh botin tënd në WhatsApp me numrin tënd të WhatsApp',
    facebookBotSettings: 'Cilësimet e Botit në Facebook',
    automateCustomerEngagementWithTelegram:
      'Automatizo angazhimin e klientëve me Telegram',
    automateCustomerEngagementWithFacebook:
      'Automatizo angazhimin e klientëve me Facebook',
    automateCustomerEngagementWithInstagram:
      'Automatizo angazhimin e klientëve me Instagram',
    telegramAutomation: 'Automatizimi në Telegram',
    limitExhaustMessage: 'Keni arritur kufirin maksimal të 100 mesazheve AI falas për llogarinë. Për të vazhduar përdorimin e shërbimit tonë API të ChatGPT, klikoni butonin \'Shto Çelësin API\' për të vendosur çelësin tuaj API të ChatGPT.',
    addApiKey: 'Shto Çelësin API'
  },
  install: {
    previewYourLandingPageBot:
      'Shihni paraprakisht Botin tuaj të Faqes së Zbarkuar',
    preview: 'Parashiko',
    test: 'Testo',
    squareSpace: 'Squarespace',
    installYourChatBot: 'Instalo Botin tënd të Bisedës',
    seeHowToUse: 'Shiko se si të përdoret',
    help: 'Ndihmë',
    uniqueLinkToLandingPageBot:
      'Këtu është lidhja unike për Botin tuaj të Faqes së Zbarkuar.',
    shareOnSocialMedia:
      'Thjesht ndajeni me përdoruesit tuaj në media sociale, faqe kontakti ose kartat e biznesit.',
    or: 'OSE',
    copyUrl: 'Kopjo URL',
    selectYourWebsiteCms: 'Zgjidhni CMS-in e Faqes tuaj të Internetit',
    selectCms:
      'Zgjidhni CMS/ndërtuesin që keni përdorur për të krijuar faqen tuaj të internetit',
    custom: 'I ndryshueshëm',
    wordpress: 'WordPress',
    shopify: 'Shopify',
    wix: 'Wix',
    zoomla: 'Zoomla',
    otherCms: 'Tjera CMS',
    howWouldYouLikeToInstall: 'Si do të donit ta instaloni?',
    installingWebsiteBot:
      'Zgjidhni ku do të instaloni botin në faqen tuaj të internetit',
    iWillAddMyself: `Do ta shtoj vetë`,
    getChatBotScript:
      'Merrni kodin e skriptit të bisedës më poshtë dhe instaloni të gjitha vetë',
    getWordpressPlugin: 'Merrni Pluginin WordPress API Key',
    getOurOfficialPlugin: 'Merrni pluginin zyrtar tonë ',
    fromWordpressPluginStore: ' nga Dyqani i Pluginit WordPress',
    getPlugin: 'Merr Pluginin',
    quickGuideToInstall: 'Udhëzim i shpejtë për instalim',
    placeApiKeyBelowIn: 'Vendosni çelësin API më poshtë në ',
    afterDownloadingAndActivatingPlugin:
      ' pas shkarkimit dhe aktivizimit të plugin',
    copy: 'Kopjo',
    enterYourWebsite: `Vendosni faqen tuaj të internetit dhe le të shohim se si duket biseda juaj`,
    enterAValidUrl: 'Vendosni një URL të vlefshëm',
    verifyYourInstallation:
      'Verifikoni nëse instalimi juaj është i suksesshëm apo jo?',
    testInstallation: 'Testo instalimin',
    getChatBotScriptCode: 'Merrni kodin e skriptit të bisedës',
    copyThisCodeSnippet:
      'Kopjo këtë fragment kodit dhe vendose atë në HTML të çdo faqeje të internetit ku doni të' +
      ' shfaqni botin ose vendos në këmbë përpara mbylljes së etiketës për të shfaqur në çdo faqe.',
    // copy: 'Kopjo',
    sendCodeToMyDeveloper: 'Dërgoni kodin tek zhvilluesi im',
    sendCodeToMyDevelopmentTeam: 'Dërgoni kodin tek ekipi im i zhvillimit',
    sendEmail: 'Dërgo Email',
    enterAValidEmail: 'Vendosni një email të vlefshëm',
    codeHasBeen: 'Kodi është ',
    toYourDeveloper: ' tek zhvilluesi juaj ',
    resent: 'ri-dërguar',
    sent: 'dërguar',
    resendEmail: 'Ridërgo Email',
    ask: 'Pyet ',
    supportTeamToInstall: ' Ekipin e Ndihmës për të instaluar',
    raiseTheInstallationRequestTo: 'Ngritni kërkesën e instalimit tek ',
    team: ' Ekip',
    helpMeInstallingChatBot: 'Më ndihmoni në instalimin e ChatBot',
    yourBotInstallationIsNotActive: 'Instalimi i botit tuaj nuk është aktive!',
    monthlyMessageLimitExceeded: 'Limiti mujor i mesazheve është tejkaluar',
    exceededMonthlyMessageLimitUpgradeNow:
      'Keni tejkaluar limitin mujor të mesazheve, Përmirëso tani.',
    upgradeNow: 'Përmirëso Tani',
    botInstallationNotActivePleaseFix:
      'Instalimi i botit tuaj nuk është aktive, Ju lutemi ta ndreqni atë. ',
    incorrectBotScript: 'Skripti i pasaktë i Botit',
    installationCodeYouAreVerfiyingNotMatchingOnYourSite: `Skripti i instalimit që po verifikoni nuk përputhet me atë në faqen tuaj.
      Ju lutemi sigurohuni që keni instaluar kodin e saktë për këtë bot.`,
    unableToSee: 'Nuk mund të shihet ',
    codeOnYourWebsite: ' Kodi në faqen tuaj të internetit',
    unableToFindCodePleaseReinstall:
      'Nuk mund të gjejmë kodin në faqen tuaj të internetit, Ju lutemi të ri-instaloni.',
    reinstallBot: 'Ri-instalo botin',
    yourBotIsInstalledAndActive: 'Boti juaj është instaluar dhe është aktiv!',
    noPendingAction:
      'Asnjë veprim në pritje, Boti juaj është instaluar dhe është aktiv',
    youAreAllSet: 'Ju jeni të gatshëm!',
    showMeMyLeads: 'Më tregoni udhëheqësit e mi',
    connectingToYourWebsiteToVerifyInstallation:
      'Po lidhet me faqen tuaj të internetit për të verifikuar instalimin e botit',
    thisMayTakeUpto30Seconds: 'Kjo mund të zgjatë deri në 30 sekonda',
    hereIsTheuniqueAILink: 'Këtu është lidhja unike për botin tuaj AI',
    installHeading: 'Instalo Botin tënd të Bisedës',
    websiteChatbot: 'Chatbot i Faqes së Internetit',
    aiChatBot: 'Chatbot i AI',
    landingPageBot: 'Boti i Faqes së Zbarkuar',
    mobileChatBot: 'Chatbot i Aplikacionit Mobil',
    embeddedBot: 'Bot i Ngulitur',
    selectMobileDevice: 'Zgjidhni pajisjen tuaj mobile',
    mobileDeviceSubheading:
      'Zgjidhni gjuhën amtare që keni përdorur për të krijuar aplikacionin tuaj mobil',
    ios: 'IOS',
    android: 'Android',
    reactNative: 'React Native',
    otherMobileDevice: 'Tjetër',
    copyEmbeddedCodeSnippet:
      'Kopjo këtë fragment kodit dhe vendose atë në HTML të çdo faqeje të internetit ku doni të shfaqni botin.',
    copyMobileCodeSnippet:
      'Kopjo këtë fragment kodit në kodin e aplikacionit tuaj mobil ku doni të shfaqni botin.',
    placeholders: {
      exampleSite: 'https://www.yoursite.com',
      enterDeveloperEmail: 'Vendosni Emailin e Zhvilluesit',
    },
    installGeneral: {
      sendInstructionsToYourDeveloper: 'Dërgoni udhëzimet te zhvilluesi juaj',
      notSureHowToDoIt:
        'Nuk jeni të sigurt se si ta bëni? Zhvilluesit tuaj mund ta bëjnë këtë shpejt.',
      developersEmail: `Email i Zhvilluesit`,
      emailIsRequired: 'Email është e nevojshme',
      subject: 'Subjekti',
      message: 'Mesazhi',
      send: 'Dërgo',
      placeholders: {
        enterYourWorkEmail: 'Vendosni emailin tuaj të punës',
        createBotUsingBotPenguin: 'Entuziaste! Krijoni bot përmes BotPenguin',
      },
    },
    platforms: {
      hereIsUniqueLinkToLandingPageBot:
        'Këtu është lidhja unike për Botin tuaj të Faqes së Zbarkuar.',
      shareWithUsersOnSocialMedia:
        'Thjesht ndajeni me përdoruesit tuaj në media sociale, faqe kontakti ose kartat e biznesit.',
      previewMyLandingPageBot: 'Shiko botin tim të Faqes së Zbarkuar',
      or: 'OSE',
      copyUrl: 'Kopjo URL',
      howYouLikeToAddBot:
        'Zgjidhni si do të donit të shtonit kodin tuaj të Botit në faqen tuaj të internetit',
      installTheBotToYourCustomCodedOrWordPressWebsite:
        'Instaloni Botin në faqen tuaj të koduar vetë ose në WordPress duke kopjuar dhe ngjitur një kod të veçantë.',
      name: 'Emri',
      actions: 'Veprimet',
      javascript: 'Javascript',
      install: 'Instalo ',
      onYourCustomCodedWebsite: ' në faqen tuaj të koduar vetë',
      copyAndPaste: 'Kopjo dhe ngjit',
      copyThisCodeSnippet:
        'Kopjo këtë fragment kodit dhe vendose atë në HTML të çdo faqeje të internetit' +
        ' ku doni të shfaqni Widget-in. Për më shumë detaje',
      seeGuide: 'shiko udhëzimet',
      getCode: 'Merr Kodin',
      howToInstall: 'Si ta instaloni?',
      copyCode: 'Kopjo kodin',
      wordpress: 'WordPress',
      // install: 'Instalo ',
      onYourWordPressWebiste: ' në faqen tuaj të internetit WordPress',
      preview: 'Parashiko',
      test: 'Testo',
    },
  },
  liveChatPreview: {
    liveChatPreview: 'Parashikim i Bisedës Live',
    agentWindow: 'Dritare e Agjentit',
    person: 'person',
    inOrderToTestTypeHere: 'Për të testuar, shkruani këtu',
    agentWindowCannotBeCustomized: `Shënim: Dritarja e Agjentit nuk mund të ndryshohet`,
    customerWindow: 'Dritare e Klientit',
    clickHereToChat: 'Kliko këtu për të biseduar',
    customerWillChatHere: 'Klienti do të bisedojë këtu',
    chat: 'Biseda',
    by: 'nga',
    changeYourBotLookFromLeftPanel:
      'Ndryshoni pamjen e botit nga paneli i majtë',
    placeholders: {
      typeYourMessage: 'Shkruani mesazhin tuaj...',
      typeYourAnswer: 'Shkruani përgjigjen tuaj',
    },
  },
  previews: {
    previewYourLiveChatWidget: 'Parashiko widgetin tënd të Bisedës Live',
    install: 'Instalo',
    seeHowToUse: 'Shiko se si të përdoret',
    appTooltip: {
      clickToInstallYourBotToSelectedPlatform:
        'Kliko për të instaluar botin në platformën e zgjedhur',
    },
  },
  trainYourBot: {
    trainYourBot: 'Trajtoni Chatbotin Tuaj të IA',
    knowledgeBase: 'Baza e njohurive',
    faqs: 'FAQ',
    history: 'Historia',
    faqHeading: 'Pyetje të Bëra Së Pari',
    faqSubHeading:
      'Trajtoni chatbotin tuaj në FAQ për të dhënë përgjigje të sakta.',
    knowledgeBaseHeading: 'Trajtoni chatbotin tuaj',
    knowledgeBaseSubheading:
      'Trajtoni Chatbotin Tuaj për Biseda të Përmirësuara',
    websiteLink: 'Linku i Faqes së Internetit',
    uploadFile: 'Ngarko skedarin tënd',
    selectFile: 'Zgjidh Skedarin',
    submit: 'Dërgo',
    searchHere: 'Kërkoni këtu',
    question: 'Pyetje',
    answer: 'Përgjigje',
    questionPlaceholder: 'Shkruani pyetjen tuaj këtu',
    answerPlaceholder: 'Shkruani përgjigjen tuaj këtu',
    save: 'Ruaj',
    discard: 'Hiqe',
    addFaq: 'Shto FAQ',
    createdAt: 'Krijuar më',
    updatedAt: 'Përditësuar së Fundi më',
    actions: 'Veprimet',
    noFaqFound: 'Nuk keni krijuar ende asnjë FAQ',
    noFaqFoundMessage: 'Të gjitha FAQ-të tuaja do të shfaqen këtu',
    historyTitle: 'Historia e Bazës së Njohurive',
    historySubtitle: 'Përgjigje për Pyetjet Tuaja të Trajnimit të Chatbotit',
    fileName: 'Emri i Skedarit',
    status: 'Statusi',
    noHistoryTitle: 'Nuk keni krijuar ende modele të trajnuara',
    noHistoryDescription: 'Të gjitha modelët e trajnuara do të shfaqen këtu',
    fileUpload: 'Ngarkimi i Skedarit',
    files: 'Skedarët',
    fileSubHeading:
      'Ngarko të gjitha skedarët për trajnimin e chatbotit tënd IA.',
    noFileFoundHeading: 'Ende nuk keni ngarkuar asnjë skedar.',
    noFileFoundSubheading: 'Të gjitha skedarët tuaja do të shfaqen këtu',
    uploadYourFiles: 'Ngarko skedarët e tuaj',
    upload: 'Ngarko',
    fileShouldBe: 'Skedari duhet të jetë PDF, DOC, DOCX, PPTX, TXT.',
    uploadStatus: 'Statusi i Ngarkimit',
    uploadStatusSubHeading:
      'Statusi i ngarkimit të skedarëve për trajnimin e botit',
    addFile: 'Shto Skedar',
    otherConfiguration: 'Rregullime të tjera të IA',
    deleteFiles: 'Kliko për të fshirë skedarët',
    websiteURL: 'URL të Faqeve të Internetit',
    websiteUrlSubheading:
      'Shto URL të faqeve të internetit për trajnimin e chatbotit tënd IA.',
    enterWebsiteUrl: 'Vendos URL-in',
    addWebsite: 'Shto Faqe',
    tableWebsiteUrl: 'URL-i i Faqes së Internetit',
    trainingStatus: 'Statusi i Trajnimit',
    lastTrained: 'I trajnuar i Fundit',
    noWebsitesFound: 'Ende nuk ka faqe të skenuara!',
    noWebsitesFoundMessage: 'Të gjitha faqet tuaja do të shfaqen këtu',
    loadMore: 'Ngarko Më Shumë',
    botBehaviour: 'Konfiguro Sjelljen e Botit',
    botBehaviourSubHeading:
      'Konfiguro personalitetin e botit, redakto të dhënat e klientit, menaxho rrjedhën dhe modelin ChatGPT',
    botPersonality: 'Konfiguro personalitetin e botit',
    botPersonalitySubHeading:
      'Menaxho se si duhet të përgjigjet boti në terma të personalitetit',
    selectAnswerLength: 'Zgjidh Gjatësinë e Përgjigjes',
    answerLength: 'Gjatësia e Përgjigjes',
    answerAs: 'Përgjigju si',
    tone: 'Toni',
    language: 'Gjuha',
    answerFormatting: 'Formatimi i Përgjigjes',
    customInstructions: 'Udhëzimet e Personalizuara',
    customerInstructionPlaceholder:
      'Bëhuni të hikur dhe miqësor. Mos përdorni fjalë jargëtuese. Mos përdorni emojis',
    redactCustomerData: 'Mbledh të Dhëna nga Klienti',
    redactDataSubheading:
      'Konfiguroni informacionin e klientit që dëshironi të mbledhni',
    collectName: 'Mbledh Emrin',
    configureQuestion: 'Konfiguro Pyetjen',
    maxCharacterLimit: 'Limiti Maksimal i Karaktereve në Emrin e Dhënë',
    collectEmail: 'Mbledh Email',
    excludeEmail: 'Përjashto Email me Domain',
    collectPhone: 'Mbledh Numrin e Telefonit',
    manageUnusualMessages: 'Menaxho Skenarët e Jashtëzakonshëm të Bisedës',
    unusualMessagesSubheading:
      'Traktoni skenarët e pa-ndërgjegjshëm dhe të tjerë rrallë për botin',
    startConversation: 'Mesazhi për të filluar bisedën',
    configureMessage: 'Mesazh kur bota nuk është në gjendje të përgjigjet',
    profanityMessage:
      'Mesazh për të reaguar ndaj përdorimit të paligjshëm të gjuhës',
    chatGptModel: 'Konfigurimi i Modelit ChatGPT',
    chatGptModelSubheading:
      'Menaxhoni cilin model ChatGPT të përdorni dhe shmangni keqperdorimin',
    chatGptApi: 'Çelësi API i ChatGPT',
    enableDisableRedactData: 'Mbledhja e të Dhënave nga Klienti',
    triggerToCollectData: 'Mbledh detajet e kontaktit pas një seti pyetjesh.',
    train: 'Strehim',
    website: 'Uebsajt',
    analytics: 'Analitikë',
    conversationsHistory: 'Historiku i Bisedave',
    exportCustomerConversation:
      'Eksportoni bisedat e klientit për trajnimin e botit AI.',
    includedSourcesForResponse: 'Burimet e Përfshira për Përgjigjen',
    visibility: 'Dukshmëria',
    yourConversation: 'Biseda Juaj',
    reviewAndSelectConversation:
      'Rishikoni dhe Zgjidhni Bisedat për Eksportin e Trajnimit të Botit',
    exportAiAnalytics: 'Eksportoni analitikat',
    startDate: 'Data e Fillimit',
    endDate: 'Data e Përfundimit',
    userQuestion: 'Pyetja e Përdoruesit',
    botsReply: 'Përgjigja e Botit',
    dateCreated: 'Data e Krijuar',
    noAnalyticsFound: 'Nuk ka biseda për të treguar.',
    noAnalyticsFoundMessage:
      'Të gjitha ndërveprimet tuaja me botin do të shfaqen këtu.',
    detectYourLanguage:
      'Zbuloni gjuhën e përdoruesit dhe përgjigjuni në të njëjtën gjuhë',
    exportData: 'Eksporto të Dhënat',
    exportCompleteAnalyticsData: 'Eksporto të dhënat e plota analitike',
    export: 'Eksporto',
    integrateWithChatGpt: 'Integrohu me ChatGPT',
    integrated: 'Integruar',
    connected: 'Në Lidhje',
    gpt3: 'GPT-3.5 (Çmimi i Ulët, Mesatarja e Saktësisë)',
    gpt4: 'GPT-4 (Çmimi i Lartë, Saktësia e Lartë)',
    gptAssistant: 'Asistentët Beta* (Çmim Premium, Saktësia e Lartë)',
    configure: 'Konfiguro',
    prompt: 'Thirrje',
    vectorResult: 'Rezultati i Vektorit',
    personalizeReplies: 'Personalizoni Përgjigjet me Historinë e Bisedës',
    personalizeRepliesNote:
      'Shënim: Aktivizimi i kësaj funksionaliteti rrit madhësinë e tokens dhe ndikon në kostot e ekzekutimit të ChatGPT.',
    appToolTip: {
      deleteWebsite: 'Fshi uebsajtin',
      knowledgeBase: 'Strehoni botin tuaj me bazën e njohurive',
      faqs: 'Strehoni botin tuaj me FAQ',
      knowledgeHistory: 'Historia e Bazës së Njohurive',
      uploadFaqs: 'Ngarko FAQ',
      addFaqs: 'Klikoni për të shtuar FAQ për trajnimin e botit AI tuaj',
      deleteFaqs: 'Fshi FAQ',
      deleteHistory: 'Fshi historinë',
      uploadFile:
        'Dosja e ngarkuar duhet të jetë pdf, docx, doc ose csv dhe madhësia duhet të jetë maksimumi 1 MB.',
      trainWebsite: 'Strehoni botin tuaj duke përdorur një uebsajt.',
      fileUpload:
        'Strehoni botin tuaj duke përdorur dosje si PDF, TXT, PPTX, DOC dhe DOCX.',
      configureBotBehaviour:
        'Përshtatni personalitetin e botit, menaxhoni rrjedhën dhe rregulloni modelin ChatGPT.',
      clickToAddWebsite:
        'Klikoni për të shtuar URL të uebsajtit për trajnimin e botit AI tuaj.',
      clickToAddFile:
        'Klikoni për të ngarkuar të gjitha dosjet për trajnimin e botit AI tuaj',
      clickToDeleteWebsites: 'Klikoni për të fshirë uebsajtet',
      syncWebsite: 'Sinkronizo Uebsajtin',
      copyUrl: 'Kopjo URL',
      weWillBeFetchingAllTheWebpages:
        'Do të marrim të gjitha faqet dhe do të trajnojmë modelin ChatGPT mbi to.',
    },
    modal: {
      deleteWebsiteUrl: 'Fshi URL të Uebsajtit',
      areYouSureYouWantToDeleteThisWebsiteUrl:
        'A jeni të sigurt se dëshironi të fshini këtë URL të Uebsajtit?',
    },
  },
  configuration: {
    websiteChatbotSetting: 'Cilësimet e Chatbot të Faqes',
    preview: 'Parashiko',
    test: 'Testo',
    install: 'Instalo',
    designHeader: 'Dizajn',
    generalHeader: 'I Përgjithshëm',
    alertsHeader: 'Sinjalizime',
    triggerHeader: 'Përçues',
    userAccessHeader: 'Qasje e Përdoruesit',
    chatWindowHeader: 'Dritare e Bisedës',
    otherConfiguration: 'Cilësimet e Tjera AI',
    appTooltip: {
      clickToInstallYourBotToSelectedPlatform:
        'Kliko për të instaluar botin në platformën e zgjedhur',
      customizeAppearanceOfBot:
        'Rregullo pozicionimin dhe pamjen e ndërfaqes së botit tuaj.',
      configureBotsSettingsWhenAgentUnavailable: `Rregullo cilësimet e botit kur agjenti juaj nuk është i disponueshëm.`,
      configureHowBotWillAlertYou: `Rregullo se si do t'ju njoftojë boti për udhëheqësit e rinj.`,
      makeSureYourBotsPopUpProperlyTimed: `Sigurohu që pop-up-at e botit janë të kohëzgjedhura siç duhet.`,
      customizeWhereYouWantYourBotToAppear:
        'Rregullo ku doni që boti juaj të shfaqet dhe ku jo.',
      enableChatOptionsForVisitorsToTransferChat:
        'Aktivizo opsionet e bisedës për vizitorët për transferim bisede, bisedë në kohë reale dhe rifreskim bisede.',
      configureBotBehaviour:
        'Rregullo personalitetin e botit, menaxho rrjedhën, dhe rregullo modelin e ChatGPT.',
    },
    alerts: {
      configureYourBotsAlertSettings: `Rregullo cilësimet e sinjalizimeve të botit`,
      specifyHowYourBotWillNotify: `Specifiko se si do t'ju njoftojë boti për udhëheqësit e rinj.`,
      subject: 'Subjekti',
      emailNotification: 'Njoftimi me Email',
      emailAddresses: 'Adresat e Email-it',
      leadRevisitNotification: 'Njoftimet e Rizbulimit të Udhëheqjes',
      youHaveSuccessfullyRegisteredWithDesktopNotifications:
        'Ju keni regjistruar me sukses me njoftimet e desktopit',
      youHaveBlockedYourNotificationsOnBrowser:
        'Ju keni bllokuar njoftimet në cilësimet e shfletuesit tuaj.',
      discard: 'Heq dorë',
      saveChanges: 'Ruaj Ndryshimet',
      seeHowToUse: 'Shiko se si të përdoret',
      placeholders: {
        enterSubjectForYourEmail: 'Vendos subjektin për emailin tënd',
        typeYourEmailAddressAndHitEnter:
          'Shtyp adresën tënde të email-it dhe shtyp Enter për të shtuar një tjetër.',
      },
      appTooltip: {
        TOOLTIP_SUBJECTS:
          'Rregullo subjektin e njoftimeve të tua email nga boti',
        TOOLTIP_EMAIL_NOTIFICATION:
          'Aktivizo/inaktivizo njoftimet e botit në emailin tënd për udhëheqësit e rinj',
        TOOLTIP_EMAIL_ADDRESS:
          'Jep adresën e emailit të llogarisë ku dëshiron të marrësh njoftime me email. Mund të shtosh disa adresa email duke shtypur një dhe duke shtypur Enter për të shtuar një tjetër.',
        TOOLTIP_LEAD_REVISIT_NOTIFICATION:
          'Aktivizo/inaktivizo njoftimet e botit në emailin tënd nëse një përdorues i njohur si udhëheqje ndërvepron me botin përsëri.',
      },
    },
    broadcasts: {
      createBroadcastHeading: 'Krijo Transmitim',
      youCanCreateMultipleBroadcasts: 'Mund të krijojësh shumë transmetime',
      broadcastName: 'Emri i Transmitimit',
      broadcastNameIsRequired: 'Kërkohet emri i transmitimit',
      continue: 'Vazhdo',
      manageBroadcasts: 'Menaxho Transmetimet',
      youCanCreateMultipleBroadcastsWithMultipleTemplatesAndSegments:
        'Mund të krijojësh shumë transmetime me shumë' +
        ' shablone të planifikuara për grupe të ndryshme të klientëve.',
      createNewBroadcast: 'Krijo Transmitim të Ri',
      name: 'Emri',
      segment: 'Grupi',
      template: 'Shablloni',
      contacts: 'Kontaktet',
      send: 'Dërgo',
      delivered: 'Dorëzuar',
      read: 'Lexuar',
      failed: 'Dështuar',
      broadcastAt: 'Transmeto Në',
      status: 'Statusi',
      actions: 'Veprimet',
      nA: 'N/A',
      seeHowToUse: 'Shiko se si të përdoret',
      deleteBroadcast: 'Fshi Transmitimin',
      wantToDeleteThisBroadcast:
        'A je i sigurt që dëshiron të fshish këtë Transmitim?',
      placeholders: {
        searchHere: 'Kërko këtu',
        enterBroadcastName: 'Vendos emrin e transmitimit',
      },
      appTooltip: {
        deleteMultipleBroadcasts: 'Fshi shumë transmetime',
        broadcastAnalytics: 'Analiza e Transmitimit',
        deleteBroadcast: 'Fshi Transmitim',
      },
      broadcastAnalytics: {
        broadcastInsights: 'Informacione mbi Transmitimin',
        broadcastStatus: 'Statusi i Transmitimit',
        youCanFindDetailsOfEachContactBelow:
          'Mund të gjeni detaje për çdo kontakt më poshtë dhe eksportoni ato që mund të kenë probleme.',
        filterApplied: 'Filtruar',
        placeholders: {
          searchByPhoneNumber: 'Kërko sipas numrit të telefonit',
          searchByName: 'Kërko sipas emrit',
        },
        appTooltip: {
          filterDataBasedOnStatus: 'Filtro të dhënat sipas statusit',
          exportData: 'Eksporto të dhënat',
        },
        modal: {
          exportData: 'Eksporto të dhënat',
          exportCompleteBroadcastData:
            'Eksporto të dhënat e plota të transmitimit',
          export: 'Eksporto',
        },
      },
      createBroadcast: {
        broadcastName: 'Emri i Transmitimit',
        broadcastNameIsRequired: 'Kërkohet emri i transmitimit',
        template: 'Shablloni',
        segments: 'Grupet',
        whenToSend: 'Kur të dërgohet',
        now: 'TANI',
        later: 'MË VONË',
        selectBroadcastUsing: 'Zgjidh transmitimin duke përdorur',
        usingCsv: 'Duke përdorur CSV',
        usingSegment: 'Duke përdorur Grupin',
        allContacts: 'Të gjitha Kontaktet',
        selectDate: 'Zgjidh Datën',
        selectTimeSlot: 'Zgjidh Intervalin e Kohës',
        assignVariablesToTemplates: 'Cakto variablat për shabllonet ',
        addHeaderMedia: 'Shto Media Kryesore ',
        selectFile: 'Zgjidh Skedarin',
        cancel: 'Anulo',
        createBroadcast: 'Krijo Transmitim',
        broadcastUsing: 'Duke përdorur Transmitimin',
        selectCSVFile: 'Zgjidh Skedarin CSV',
        importContacts: 'Importo Kontaktet',
        beforeYouStartUpload:
          'Para se të filloni ngarkimin, ju lutemi sigurohuni',
        point1: '1. Shkarkoni skedarin shembull CSV.',
        point2:
          '2. Filloni të shkruani të dhënat tuaja nga rreshti i 2-të përpara.',
        point3: '3. Në çdo rresht, do të ketë të dhëna për një kontakt',
        point4: '4. Sigurohuni që të gjitha numrat e telefonit janë të unikë.',
        point5:
          '5. Kufiri maksimal i madhësisë së dosjes për ngarkim është 20MB',
        clickHere: 'Kliko këtu',
        toDownloadSampleFile: 'për të Shkarkuar Skedarin Shembull',
        placeholders: {
          enterBroadcastName: 'Vendos emrin e transmitimit',
          selectTemplate: 'Zgjidh Shabllonin',
          searchTemplateByName: 'Kërko shabllonin sipas emrit',
          selectSegments: 'Zgjidh Grupet',
          selectTimeSlot: 'Zgjidh Intervalin e Kohës',
          selectValueForThisVariable: 'Zgjidh vlerën për këtë variabël',
          searchHeaderByVariableName:
            'Kërko kryesoren sipas emrit të variablës',
          variableFallbackValue: 'Vlera e Zëvendësimit të Variablës',
          searchBodyVariableByName: 'Kërko variablën e trupit sipas emrit',
          searchSegmentByName: 'Kërko grupin sipas emrit',
          selectBroadcastUsing: 'Zgjidh transmitimin duke përdorur',
        },
        indexMergeDatePicker: {
          selectStartDate: 'Zgjidh datën e fillimit',
        },
        appTooltip: {
          importContactsForWhatsappBroadcast:
            'Importo kontaktet për transmetimin në WhatsApp',
        },
      },
      failedBroadcast: {
        whatsappNumber: 'Numri i WhatsApp-it',
        errorCode: 'Kodi i Gabimit',
        errorMessage: 'Mesazhi i Gabimit',
        nA: 'N/A',
      },
    },
    design: {
      customizeYourLandingPage: 'Rregullo Faqen Tënde Hyrëse',
      customizeYourConversationalBot: 'Rregullo Botin Tënd AI',
      customizeYourBot: 'Rregullo Botin Tënd',
      createHeadingTextAndTheme: `Krijo tekstin kryesor dhe temën që reflekton personalitetin e markës suaj`,
      content: 'Përmbajtja',
      theme: 'Tema',
      layout: 'Dizajni',
      landingPageName: 'Emri i Faqes Hyrëse',
      botName: 'Emri i Botit',
      charactersRemaining: ' karaktere mbetura',
      landingPageHeader: 'Koka e Faqes Hyrëse',
      landingPageDescription: 'Përshkrimi i Faqes Hyrëse',
      hideContent: 'Fshih Përmbajtjen',
      profilePic: 'Fotografia Profilit',
      selectFile: 'Zgjidh Skedarin',
      socialMediaLinks: 'Lidhjet e Mediave Sociale',
      initialMessage: 'Mesazhi fillestar i botit konversationa',
      flowTriggerDetail: 'Trigger për të mbledhur detajet e kontaktit',
      selectType: 'Zgjidh Llojin',
      url: 'URL',
      delete: 'Fshij',
      editLink: 'Redakto Lidhjen',
      addLink: 'Shto Lidhjen',
      callToAction: 'Thirrje për Veprim',
      liveChatWelcomeMessage:
        'Mesazhi i Mirëseardhjes së Bisedës Në Drejtpërdrejtë',
      liveChatTriggerMessage: 'Mesazhi i Trigger për Bisedë Në Drejtpërdrejtë',
      autoHideCallToAction: 'Auto Fshih Thirrjen për Veprim',
      maxDelayShouldBe300Seconds: 'Vonë maksimale duhet të jetë 300 sekonda',
      landingPageThemeColor: 'Ngjyra e Temës së Faqes Hyrëse',
      themeColor: 'Ngjyra e Temës',
      landingPageBackground: 'Fundi i Faqes Hyrëse',
      chatBackgroundColor: 'Ngjyra e Fushës së Bisedës',
      color: 'Ngjyra',
      gradient: 'Gradient',
      image: 'Imazhi',
      video: 'Video',
      gradientStart: 'Fillimi i Gradientit',
      gradientEnd: 'Përfundimi i Gradientit',
      positionOnWeb: 'Pozicioni në ueb',
      positionOnMobile: 'Pozicioni në celular',
      windowSize: 'Madhësia e Dritares',
      s: 'S',
      m: 'M',
      l: 'L',
      xl: 'XL',
      xxl: 'XXL',
      custom: 'I Përsonalizuar',
      height: 'Lartësia',
      minimum300HeightIsRequired: 'Kërkohet një lartësi minimale prej 300px',
      heightCannotExceed720: 'Lartësia nuk mund të tejkalohet 720px',
      width: 'Gjerësia',
      px: 'px',
      minimum200WidthIsRequired: 'Kërkohet një gjerësi minimale prej 200px',
      widthCannotExceed1050: 'Gjerësia nuk mund të tejkalohet 1050px',
      discard: 'Heq Dorë',
      saveChanges: 'Ruaj Ndryshimet',
      landingPageBot: 'Boti i Faqes Hyrëse',
      chatBot: 'Boti i Bisedës',
      preview: ' Pamje Paraprake',
      botIcon: 'Ikonë e Botit',
      websiteBot: 'Website Chatbot',
      selectFont: 'Zgjidh Fontin',
      fontLibrary: 'Biblioteka e Fonteve',
      uploadFont: 'Ngarko Fontin',
      selectFontForBot: 'Zgjidh fontin për botin',
      uploadedFont: 'Fonti i Ngarkuar',
      placeholders: {
        enterName: 'Vendos emrin',
        enterHeaderText: 'Vendos tekstin e kryesuesit',
        enterDescription: 'Vendos përshkrimin',
        enterUrl: 'Vendos URL',
        howCanIHelpYou: 'Si mund të ju ndihmoj?',
        enterYourWelcomeMessageHere:
          'Vendos mesazhin tënd të mirëseardhjes këtu',
        enterYourLiveChatMessageHere:
          'Vendos mesazhin tënd të bisedës së drejtpërdrejtë këtu',
        enterTimeInSeconds: 'Vendos kohën në sekonda',
        enterHeight: 'Vendos lartësinë',
        enterWidth: 'Vendos gjerësinë',
        flowInitialMessage: 'Vendos pyetjen fillestare',
      },
      appTooltip: {
        standardLayout: 'Dizajni standard',
        rightLayout: 'Dizajni i Djathtë',
        mergedLayout: 'Dizajni i Përzjerë',
        enterNameOfYourBot: 'Vendos emrin e botit tënd',
        enterNameOfYourLandingPageBot:
          'Vendos emrin e botit tënde të faqes hyrëse',
        headingTextThatAppearOnLandingPageBot:
          'Vendos tekstin kryesor që dëshiron të shfaqet në botin tënd të faqes hyrëse',
        descriptionTextThatAppearOnLandingPageBot:
          'Vendos tekstin e përshkrimit që dëshiron të shfaqet në botin tënd të faqes hyrëse.',
        addLinksAndSocialMediaIcons: 'Shto lidhje dhe ikona të mediave sociale',
        initialFlowMessage:
          'Vendos mesazhin e parë që boti do të dërgojë për të nisur bisedën me klientin',
        anInvitingCatchPhrase:
          'Një frazë ftuese që do të bëjë që përdoruesi të flasë me botin',
        setAWelcomeMessageForYourVisitors:
          'Vendos një mesazh mirëseardhjeje për vizitorët tuaj. Ky do të jetë mesazhi i parë në bisedën tuaj.',
        setAMessageToInitiateLiveChat: `Vendos një mesazh për të nisur bisedën në drejtpërdrejtë nga ana e vizitorit. Do të merrni një njoftim çdo herë që ky mesazh aktivizohet
        në ndonjë nga bisedat tuaja.`,
        autoHideCallToAction: `Fsheh automatikisht tekstin 'Thirrje për Veprim' pas një kohe të caktuar`,
        TOOLTIP_HIDE_LANDINGPAGE_INFO:
          'Mund të zgjidhni të fshehni logon dhe tekstin për të treguar vetëm dritaren e bisedës në ekran',
        TOOLTIP_LANDINGPAGE_PROFILE_ICON: 'Ngarko një logo për faqen e botit.',
        TOOLTIP_CHAT_THEME_COLOR:
          'Zgjidhni ngjyrën e dritares së bisedës së botit tuaj',
        TOOLTIP_CHAT_THEME_BACKGROUND_COLOR:
          'Zgjidhni ngjyrën e sfondit të dritares së Bots chat',
        TOOLTIP_WEB_1ST_POSITION:
          'Vendosni botin tuaj në fund të majtë të desktopit të përdoruesit të botit',
        TOOLTIP_WEB_2ND_POSITION:
          'Vendosni botin tuaj në këndin e djathtë të mesit të desktopit të përdoruesit të botit',
        TOOLTIP_WEB_3RD_POSITION:
          'Vendosni botin tuaj në këndin e djathtë të fundit të desktopit të përdoruesit të botit',
        TOOLTIP_MOBILE_1ST_POSITION:
          'Vendosni botin tuaj në këndin e majtë të fundit të celularit të përdoruesit të botit',
        TOOLTIP_MOBILE_2ND_POSITION:
          'Vendosni botin tuaj në këndin e djathtë të mesit të celularit të përdoruesit të botit',
        TOOLTIP_MOBILE_3RD_POSITION:
          'Vendosni botin tuaj në këndin e djathtë të fundit të celularit të përdoruesit të botit',
        TOOLTIP_WINDOW_HEIGHT:
          'Ndryshoni madhësinë e dritares së bisedës së botit',
        TOOLTIP_BOT_ICON:
          'Zgjidhni një ikonë ose ngarkoni logon/imazhin për botin tuaj',
        flowTriggerMessage:
          'Vendosni numrin e mesazheve që do të pyeten para se të mbledhen detajet e kontaktit si Emri, Email dhe Telefon',
      },
    },
    dripCampaigns: {
      createDripCampaignHeader: 'Krijo Fushatë të Rërës',
      youCanCreateMultipleCampaigns: 'Mund të krijoni shumë fushata',
      dripCampaignName: 'Emri i Fushatës së Rërës',
      dripCampaignNameIsReuired: 'Emri i Fushatës së Rërës është i detyrueshëm',
      continue: 'Vazhdo',
      manageDripCampaign: 'Menaxho Fushatën e Rërës',
      youCanCreateMultipleCampaignsWith:
        'Mund të krijoni shumë fushata të rërës me mesazhe të planifikuara,' +
        ' automatike për të nxitur reagime nga grupet e përdoruesve të caktuar.',
      createNewDripCampaign: 'Krijo Fushatë të Re të Rërës',
      campaignName: 'Emri i Fushatës',
      appliedOn: 'Aplikuar në',
      segment: 'Grup',
      template: 'Modeli',
      startDate: 'Data e Fillimit',
      action: 'Veprim',
      nA: 'N/A',
      seeHowToUse: 'Shiko si të përdoret',
      deleteDripCampaign: 'Fshij Fushatat e Rërës',
      wantToDeleteThisDripCampaign:
        'A jeni të sigurt se dëshironi të fshini këtë Fushatë të Rërës?',
      placeholders: {
        enterDripCampaignName: 'Vendos Emrin e Fushatës së Rërës',
        searchByName: 'Kërko sipas emrit',
      },
      appTooltip: {
        deleteMultipleDripCampaigns: 'Fshi shumë fushata të rërës',
        deleteDripCampaign: 'Fshi Fushatën e Rërës',
      },
      createDripCampaign: {
        dripCampaignName: 'Emri i Fushatës së Rërës',
        appliedOn: 'Aplikuar në',
        segments: 'Grupet',
        selectDate: 'Zgjidh Datën',
        scheduleYourTemplate: 'Orario Modelin Tënd',
        schedule: 'Orario',
        template: 'Modeli',
        sendAfter: 'Dërgo Pas',
        assignVariablesToTemplate: 'Cakto variablat për modelet',
        addHeaderMedia: 'Shto Media Kryesore',
        selectFile: 'Zgjidh Skedarin',
        createDripCampaign: 'Krijo Fushatë të Rërës',
        newSubscriber: 'Abonues i Ri',
        minutes: 'Minutat',
        hours: 'Orët',
        days: 'Ditët',
        placeholders: {
          enterDripName: 'Vendos Emrin e Rërës',
          selectAppliedOn: 'Zgjidh Aplikuar në',
          selectSegments: 'Zgjidh Grupet',
          searchByName: 'Kërko sipas emrit',
          selectTemplate: 'Zgjidh Modelin',
          searchTemplateByName: 'Kërko Modelin Sipas Emrit',
          enterSendAfter: 'Vendos Dërgo Pas',
          selectValueForThisVariable: 'Zgjidh vlerën për këtë variabël',
          searchHeaderVariableByName: 'Kërko Variablën e Kryesore Sipas Emrit',
          searchBodyVariableByName: 'Kërko Variablën e Trupit Sipas Emrit',
        },
        dateTimePicker: {
          selectStartDate: 'Zgjidh datën e fillimit',
        },
      },
    },
    general: {
      configureLandingPageGeneralSettings: `Konfiguro cilësimet e faqes së arritjes së përgjithshme `,
      configureBotsGeneralSettings: `Konfiguro cilësimet e përgjithshme të botit`,
      selectTheTimeZone:
        'Zgjidh zonën kohore, gjuhën dhe një shënim të vogël për klientët tuaj kur ',
      isNotAvailable: ` nuk është i disponueshëm`,
      landingPagesBot: `boti i faqes së arritjes`,
      bot: 'bot',
      waitingMessage: 'Mesazhi i pritjes',
      landingPageBotStatus: 'Statusi i Botit të Faqes së Arritjes',
      chatBotStatus: 'Statusi i Chatbotit',
      unavailabilityMessage: 'Mesazhi i padisponueshmërisë',
      sendIncompleteResponses: 'Dërgo Përgjigje të Pa Kompletuara',
      language: 'Gjuha',
      invalidateCache: 'Invalidezo Cache-in',
      timezone: 'Zona Kohore',
      chatWindowMessageHistory: 'Historia e Mesazheve në Dritaren e Bisedës',
      session: 'sesioni',
      forever: 'përjetësisht',
      english: 'Anglisht',
      spanish: 'Spanjisht',
      french: 'Frëngjisht',
      portuguese: 'Portugalisht',
      german: 'Gjermanisht',
      italian: 'Italisht',
      swedish: 'Suedisht',
      arabic: 'Arabisht',
      malay: 'Malajzisht',
      russian: 'Rusisht',
      discard: 'Hiqe',
      saveChanges: 'Ruaj Ndryshimet',
      seeHowToUse: 'Shiko si të përdoret',
      placeholders: {
        enterYourWaitingMessageHere: 'Vendos mesazhin tënd të pritjes këtu',
        // selectLanguage: '',
        searchTimeZone: 'Kërko zonën kohore',
        // selectChatRetentionPolicy: '',
      },
      appTooltip: {
        TOOLTIP_WAITING_MESSAGES:
          'Përsonalizo mesazhin siç dëshiron që të shfaqet në dritaren e bisedës menjëherë pasi një përdorues i botit kërkon bisedë live',
        TOOLTIP_CHATBOT_STATUS: 'Aktivizo/dezaktivizo botin',
        TOOLTIP_UNAVAILABILITY_MESSAGE:
          'Përsonalizo mesazhin siç dëshiron që të shfaqet në dritaren e bisedës kur asnjë nga agjentët tuaj nuk është i disponueshëm për bisedë live me përdoruesin e botit',
        TOOLTIP_SEND_INCOMPLETE_RESPONSES:
          'Dërgo njoftime me email edhe kur përdoruesi i botit nuk ka përfunduar bisedën.',
        TOOLTIP_LANGUAGE: 'Zgjidh gjuhën e botit',
        TOOLTIP_INVALIDATE_CACHE:
          'Kliko këtu për të pastruar cache-in kur redakton rrjedhën e bisedës së botit ose cilësimet, pasi ndryshimet reflektohen vetëm pas 15 minutash',
        TOOLTIP_TIME_ZONE: 'Zgjidh zonën kohore për botin tënd',
        TOOLTIP_CHAT_RETENTION:
          'Zgjidh nëse dëshiron të ruash bisedat e përdoruesit të botit përgjithmonë në dritaren e bisedës ose vetëm për një sesion shfletimi.',
      },
    },
    liveChat: {
      customizeYourChatWindow: 'Përsonalizo dritaren tënde të bisedës',
      controlAndCustomizeTheChatWindow:
        'Kontrollo dhe personalizo dritaren e bisedës me të cilën do të ndërveprojnë klientët tuaj.',
      allowVisitorsToTransferChatToWhatsapp:
        'Lejo vizitorët të transferojnë bisedën në WhatsApp',
      allowVisitorsToRefreshChat: 'Lejo vizitorët të rifreskojnë bisedën',
      displayNameForTransferringChatToWhatsapp:
        'Emri i shfaqur për transferimin e bisedës në WhatsApp',
      displayNameForTransferringToLiveChat:
        'Emri i shfaqur për transferimin në bisedë të drejtpërdrejtë/agenca',
      displayNameForTransferringAChatToBot:
        'Emri i shfaqur për transferimin e bisedës në bot',
      discard: 'Hiqe dorë',
      saveChanges: 'Ruaj Ndryshimet',
      allowVisitorsToTransferChatToBot:
        'Lejo vizitorët të transferojnë bisedën në bot.',
      allowVisitorsToRequestForLiveChat:
        'Lejo vizitorët të kërkojnë bisedë të drejtpërdrejtë.',
      indicativeTextForCustomersReply: `Tekst indikativ për përgjigjen e klientit`,
      displayNameForRestartingChatBot:
        'Emri i shfaqur për rifillimin e bisedës së Chatbot',
      seeHowToUse: 'Shiko si të përdoret',
      placeholders: {
        enterButtonNameForWhatsapp:
          'Vendos emrin e butonit për transferimin në WhatsApp',
        enterButtonNameForLiveChat:
          'Vendos emrin e butonit për transferimin në bisedë të drejtpërdrejtë ose agjent',
        enterButtonNameForBot: 'Vendos emrin e butonit për transferimin në bot',
        enterTextDisplayInEmptyReplyArea:
          'Vendos tekstin e shfaqur në zonën e përgjigjes së zbrazët',
        enterButtonForRestartingConversation:
          'Vendos emrin e butonit për rifillimin e bisedës',
      },
      appTooltip: {
        TOOLTIP_TRANSFER_CHAT_TO_WHATSAPP:
          'Lejo vizitorët e faqes të transferojnë bisedën në WhatsApp tek numri i agjentit të caktuar me të cilin janë të lidhur. Kjo funksionon vetëm nëse është aktivizuar veçoria e bisedës së drejtpërdrejtë.',
        TOOLTIP_ALLOW_VISITOR_TO_REFRESH_CHAT:
          'Lejo përdoruesit e botit të rifreskojnë bisedën për të filluar bisedën nga fillimi.',
        TOOLTIP_ALLOW_TRANSFER_CHAT_TO_BOT:
          'Lejo përdoruesit e botit të transferojnë bisedën në bot në çdo moment midis bisedës me agjentin e bisedës së drejtpërdrejtë.',
        TOOLTIP_ALLOW_REQUEST_FOR_CHAT:
          'Lejo përdoruesit e botit të kërkojnë bisedë të drejtpërdrejtë me agjentin kurdo që dëshirojnë.',
        ifYouHaveEnabledUserToTransferToWhatsapp:
          'Nëse keni aktivizuar mundësinë e transferimit të përdoruesit në WhatsApp, mbusheni si do të dëshironi të shfaqet kjo opsion',
        ifYouHaveEnabledUserToTransferToLiveChat:
          'Nëse keni aktivizuar mundësinë e transferimit të përdoruesit në bisedë të drejtpërdrejtë, mbusheni si do të dëshironi të shfaqet kjo opsion',
        ifYouHaveEnabledUserToTransferToWhatsapp2:
          'Nëse keni aktivizuar mundësinë e transferimit të përdoruesit në WhatsApp, mbusheni si do të dëshironi të transferohen përsëri te boti',
        howWouldYouLikeToDisplayReplySpaceForCustomers:
          'Mbusheni si do të dëshironi të shfaqet hapësira e përgjigjes për klientët',
        ifYouHaveEnabledUserToRestartChatBot:
          'Nëse keni aktivizuar mundësinë e përdoruesit për të rifilluar bisedën e chatbotit, mbusheni si do të dëshironi të shfaqet kjo opsion',
      },
    },
    socialPlatforms: {
      chatFlowsHeader: 'Fluksët e Bisedës',
      dripCampaignHeader: 'Fushata e Rërës',
      widgetsHeader: 'Widgets',
      broadcastHeader: 'Transmetim',
      ordersHeader: 'Porosi',
      manageHeader: 'Menaxho',
      inputHeader: 'Input',
      apiKeyHeader: 'Çelësi i API',
      appTooltip: {
        TOOLTIP_DRIP_CAMPAIGN_TITLE:
          'Krijo një udhëtim të onbordimit të klientit duke përdorur një fushatë të rërës me fluksë bisede të planifikuara.',
        TOOLTIP_CHAT_FLOW_TITLE:
          'Përshtatni shabllonet e fluksit të bisedës dhe krijoni shumë fluksa bisede për audiencat e ndryshme të synuara.',
        TOOLTIP_WIDGET_TITLE:
          'Krijo widget (faqe bisede) dhe vendosi ato në faqet promovuese për të drejtuar vizitorët te bota',
        TOOLTIP_BROADCAST_TITLE:
          'Dërgo mesazhe ose fluksa te kontaktet tuaja me një klikim në kohën e planifikuar paraprakisht',
        TOOLTIP_ORDERS_TITLE: 'Lista e porosive të bëra nga klienti',
        TOOLTIP_MANAGE_TITLE:
          'Menaxho funksionet e botit për kontakte/lead dhe fjalë kyçe',
        TOOLTIP_INPUT_TITLE:
          'Krijo shablone WhatsApp, imazhe dhe tekst si material përgjigje për kontakte/lead',
      },
      apiWrapper: {
        whatsappApiCredentials: 'Kredencialet e WhatsApp API',
        generateYourWhatsappApiKey:
          'Gjenero çelësin tënd të WhatsApp API për të integruar me aplikacionet e zhvilluara vet.',
        generateApiKey: 'Gjenero Çelësin API',
        webhookUrl: 'Webhook URL',
        addHeader: 'Shto Kryesoren',
        test: 'Testo',
        webhookNotSet: 'Webhook-i nuk është caktuar',
        webhookHeaders: 'Kryesoret e Webhook-it',
        setWebhookUrl: 'Cakto URL të Webhook',
        placeholders: {
          yourApiKey: 'Çelësi yt API',
          enterWebhookUrl: 'Vendos URL të Webhook-it',
          enterHeaderKey: 'Vendos Kryesoren',
          enterValue: 'Vendos Vlerën',
        },
      },
      broadcast: {
        createBroadcast: 'Krijo Transmetim',
        createMultipleBroadcasts:
          'Mund të krijojmë disa transmetime me shumë fluksa/shablone të planifikuara për grupe të ndryshme të klientëve.',
        broadcastName: 'Emri i Transmetimit',
        nameIsRequired: 'Emri është i detyrueshëm',
        selectType: 'Zgjidh Llojin',
        selectYourFlowType: 'Zgjidh llojin e fluksit tënd',
        segment: 'Grupi',
        selectYourSegmentType: 'Zgjidh llojin e grupit tënd',
        whenToSend: 'Kur të dërgohet',
        selectDate: 'Zgjidh Datën',
        messageTag: 'Etiketa e Mesazhit',
        selectMessageTag: 'Zgjidh etiketën e mesazhit',
        contentType: 'Lloji i Përmbajtjes',
        nonPromotional: 'Jo-promocionale (aplikohen etiketat e mesazhit)',
        tagEachMessgeThatComesBeforeAnyInteraction: `Etiketo çdo mesazh që vjen para çdo ndërveprimi ose pas hapat e vonuar që tejkalon 24 orë me etiketën e duhur. Mesazhi pa etiketë nuk do t'i arrijë abonentëve që kanë ndërvepruar me botin më shumë se 24 orë më parë`,
        promotional: 'Promocionale (Etiketat e mesazhit injorohen)',
        theseBroadcasts:
          'Këto transmetime mund të përmbajnë promocione, por audiencat janë të kufizuara te abonentët që kanë ndërvepruar me botin në 24 orët e fundit.',
        createNewBroadcast: 'Krijo Transmetim të Ri',
        sentMessages: 'Mesazhe të Dërguara',
        deliveredMessages: 'Mesazhe të Dorëzuara',
        readMessages: 'Mesazhe të Lexuara',
        failedMessages: 'Mesazhe të Dështuara',
        type: 'Lloji',
        template: 'Shabloni',
        sent: 'Dërguar',
        delivered: 'Dorëzuar',
        read: 'Lexuar',
        failed: 'Dështuar',
        broadcastAt: 'Transmetuar në',
        status: 'Statusi',
        shipmentUpdate: 'Përditësimi i dërgesës',
        goBack: 'Kthehu Prapa',
        number: 'Numri',
        errorCode: 'Kodi i Gabimit',
        failedAt: 'Dështuar në',
        badGateway: '502 portë e keqe',
        loadMore: 'Ngarko Më Shumë',
        placeholders: {
          enterBroadcastName: 'Vendos emrin e transmetimit',
          searchBroadcastByName: 'Kërko transmetime sipas emrit',
        },
        appTooltip: {
          totalBroadcastMessagesSent:
            'Totali i mesazheve të dërguara në transmetime',
          totalBroadcastMessagesDelivered:
            'Totali i mesazheve të dorëzuara në transmetime',
          totalBroadcastMessagesReadByContacts:
            'Totali i mesazheve të lexuara nga kontaktet',
          totalFailedBroadcastMessages:
            'Totali i mesazheve të dështuara në transmetime',
          clickToViewDetailedInformationOfFailedMessages:
            'kliko për të parë informacione të detajuara të mesazheve të dështuara',
          clickToCreateNewBroadcast: 'Kliko për të krijuar transmetim të ri',
          templateUsedInBroadcast: 'Shabloni i përdorur në transmetim',
          numberOfBroadcastMessagesSent:
            'Numri i mesazheve të dërguara në transmetim',
          numberOfBroadcastMessagesDelivered:
            'Numri i mesazheve të dorëzuara në transmetim',
          numberOfBroadcastMessagesReadByContacts:
            'Numri i mesazheve të lexuara nga kontaktet',
          numberOfTimesBroadcastMessagesHasFailed:
            'Numri i herëve kur transmetimi ka dështuar',
          contactNumberOnWhichMessageDeliveryFailed:
            'Numri i kontaktit ku dështoi dorëzimi i mesazhit',
          unDeliveredTemplate: 'Shabloni i pa-dorëzuar',
          errorReceivedForFailedMessage:
            'Gabimi i pranuar për mesazhin e dështuar',
          timeWhenMessageDeliveryFailed: 'Koha kur dështoi dorëzimi i mesazhit',
          TOOLTIP_ADD_BROADCAST_NAME: 'Vendos një emër të ri të transmetimit',
          TOOLTIP_BROADCAST_SELECT_TYPE:
            'Zgjidh nëse po transmeton një fluks ose një mesazh.',
          TOOLTIP_BROADCAST_FLOW:
            'Zgjidh fluksin e bisedës që dëshiron të transmetosh,',
          TOOLTIP_BROADCAST_SELECT_YOUR_SEGMENT:
            'Zgjidh grupin e kontakteve ku dëshiron të transmetosh',
          TOOLTIP_BROADCAST_NAME: 'Emri i transmetimit',
          TOOLTIP_BROADCAST_TYPE:
            'Fluksi ose mesazhi i zgjedhur për transmetim',
          TOOLTIP_BROADCAST_SEGMENT:
            'Grupi për të cilin është krijuar transmetimi',
          TOOLTIP_BROADCAST_AT: 'Data dhe ora e planifikuar për transmetim',
          TOOLTIP_BROADCAST_STATUS:
            'Statusi i transmetimit si i planifikuar, aktualisht duke u ekzekutuar ose i përfunduar',
        },
      },
      drip: {
        createDripCampaign: 'Krijo Fushatë të Rërës',
        youCanCreateMultipleCampaigns: 'Mund të krijojmë disa fushata',
        dripCampaignName: 'Emri i Fushatës së Rërës',
        dripCampaignNameIsRequired:
          'Emri i Fushatës së Rërës është i detyrueshëm',
        youCanCreateMultipleDripCampaigns:
          'Mund të krijojmë disa fushata të rërës me mesazhe të planifikuara dhe automatike për të shkaktuar përgjigje nga grupe specifike të përdoruesve.',
        campaignName: 'Emri i Fushatës',
        campaignNameIsRequired: 'Emri i fushatës është i detyrueshëm',
        after: 'Pas ',
        thisMessageWillBeSendAfter: 'Ky mesazh do të dërgohet pas',
        saveAndUpdate: 'Ruaj & Përditëso',
        schedule: ' Planifikim',
        select: 'Zgjidh',
        messages: 'Mesazhet',
        cancel: 'Anulo',
        createCampaign: 'Krijo Fushatë',
        updateCampaign: 'Përditëso Fushatën',
        createNewCampaign: 'Krijo Fushatë të Re',
        messagesSent: 'Mesazhet e Dërguara',
        createdAt: 'Krijuar në',
        updatedAt: 'Përditësuar në',
        action: 'Veprimi',
        placeholders: {
          nameYourDripCampaign: 'Jepni emër fushatës së rërës',
          enterCampaignName: 'Vendos emrin e fushatës',
          searchCampaignByName: 'Kërko fushatë sipas emrit',
        },
        appTooltip: {
          TOOLTIP_CREATE_CAMPAIGN: 'Kliko për të shtuar një fushatë të re',
          TOOLTIP_SCHEDULE:
            'Planifikoni kur dhe cilin fluks bisede të dërgoni fillimisht në këtë fushatë.',
          TOOLTIP_AFTER_DAYS:
            'Planifikoni kur të dërgoni fluksin e parë të fushatës në minuta, orë ose ditë.',
          TOOLTIP_ADD_MESSAGES:
            'Kliko për të shtuar një fluks të ri në fushatë',
          TOOLTIP_ADD_CAMPAIGN_NAME: 'Vendos një emër të ri fushatë',
          TOOLTIP_CAMPAIGN_NAME: 'Emri i fushatës',
          TOOLTIP_NO_MESSAGES_SENT: 'Nr. i mesazheve të dërguara nga fushata',
          TOOLTIP_CAMPAIGN_CREATED_AT: 'Data dhe ora e krijimit të fushatës',
          TOOLTIP_CAMPAIGN_UPDATED_AT:
            'Data dhe ora kur fushata është përditësuar për herë te fundit',
          TOOLTIP_CAMPAIGN_ACTION: 'Ndrysho ose fshij fushatën',
          TOOLTIP_UPDATE_CAMPAIGN:
            'Kliko për të ruajtur ndryshimet e bëra në konfigurimin e fushatës',
        },
      },
      flows: {
        createChatFlow: 'Krijo Fluksin e Bisedës',
        youCanCreateMultipleConversationsFlow:
          'Mund të krijojmë disa fluksa bisede nëpër kanale të ndryshme për testim A/B dhe transmetime.',
        flowName: 'Emri i Fluksit',
        nameIsRequired: 'Emri është i detyrueshëm',
        cancel: 'Anulo',
        createFlow: 'Krijo Fluks',
        createNewFlow: 'Krijo Fluks të Ri',
        ofMessages: 'nga mesazhet',
        triggered: 'Aktivizuar',
        stepsFinsished: 'Hapat e përfunduar',
        finished: 'Përfunduar',
        createdOn: 'Krijuar më',
        lastModified: 'Përditësuar për herë te fundit',
        defaultFlow: 'Fluksi i Paracaktuar',
        action: 'Veprimi',
        flowAnalytics: 'Analizat e Fluksit',
        placeholders: {
          enterFlowName: 'Vendos emrin e fluksit',
          searchFlowByName: 'Kërko fluksin sipas emrit',
        },
        appTooltip: {
          numberOfTimesChatFlowTriggered:
            'Nr. i herëve që fluksi i bisedës është aktivizuar',
          numberOfCompletedChatFlowStepsWhenTriggered:
            'Nr. i hapat e përfunduar të fluksit të bisedës kur është aktivizuar',
          numberOfTimesUsersCompletedChatFlowSteps:
            'Nr. i herëve që përdoruesit kanë përfunduar të gjithë hapat e fluksit të bisedës',
          dateAndTimeOfCreationOfChatFlow:
            'Data dhe ora e krijimit të fluksit të bisedës',
          dateAndTimeWhenChatFlowLastModified:
            'Data dhe ora kur fluksi i bisedës është përditësuar për herë te fundit',
          TOOLTIP_CREATE_FLOW: 'Kliko për të krijuar një fluks bisede të ri',
          TOOLTIP_FLOW_NAME: 'Vendos emrin e fluksit të bisedës',
          TOOLTIP_FLOW_TABLE_NAME: 'Emri i fluksit të bisedës',
          TOOLTIP_NO_OF_MESSAGES:
            'Nr. i komponenteve të mesazheve në fluksin e bisedës',
          TOOLTIP_DEFAULT_FLOW:
            'Përdor këtë çaktivizues për të caktuar një fluks bisede si i paracaktuar, që do shërbehet për të gjithë përdoruesit e rinj.',
          TOOLTIP_ACTION: 'Ndrysho ose fshij fluksin e bisedës',
        },
      },
      manage: {
        leads: 'Leads',
        manageBotsFunctionalityForContacts: `Menaxho funksionalitetin e botit për kontaktet/lead-et`,
        whenToSendLeadInfo: 'Kur të dërgohet Informacioni i Lead-it',
        smartFlow: 'Smart Flow',
        welcomeMessageWhenNoSearchKeywordIsMet:
          'Mesazhi i mirëseardhjes kur nuk plotesohet asnjë kërkesë për fjalë kyçe',
        selectTemplates: 'Zgjidh Shabllonet',
        selectFlows: 'Zgjidh Fluksat',
        selectText: 'Zgjidh Tekstin',
        selectImages: 'Zgjidh Imazhet',
        whenItAlmostReaches24HoursSinceMessage:
          'Kur po afrohet 24 orë që nga mesazhi i fundit',
        updateChanges: 'Përditëso Ndryshimet',
        manageBotsFunctionalityAccordingToKeywords: `Menaxho funksionalitetin e botit sipas fjalëve kyçe të futura nga përdoruesi i botit, në rast të smart flow`,
        addKeywordAction: 'Shto Veprim me Fjalë Kyçe',
        keywords: 'Fjalë Kyçe',
        matchingMethod: 'Metoda e Përputhjes',
        replyMaterial: 'Materiali i Përgjigjes',
        action: 'Veprimi',
        select: 'Zgjidh',
        placeholders: {
          keyword: 'fjalë kyçe',
        },
        appTooltip: {
          TOOLTIP_LEADS_WHEN_TO_SEND_LEAD:
            'Sugjero nëse boti duhet të dërgojë informacionin e kontaktit/lead-it menjëherë në CRM-integrim, ose pas 5 minutash, ose në fund të fluksit',
          TOOLTIP_LEAD_SMART_FLOW:
            'Zgjidh çdo fluks parazgjedhur për ta dërguar të gjithë përdoruesit e botit, ose smart flow (caktuar nga fjalët kyçe të futura nga përdoruesi i botit).',
          TOOLTIP_LEAD_WELCOME_MESSAGE:
            'Zgjidh materialin e përgjigjes (fluks, shabllon, tekst, imazh) për t\'u dërguar nëse boti nuk merr përputhje fjalë kyçe nga përgjigja e përdoruesit të botit',
          TOOLTIP_IT_ALMOST_REACHED:
            'Zgjidh materialin e përgjigjes për t\'u dërguar tek kontaktet/lead-et pak para se të kalojnë 24 orët e fundit të komunikimit',
          TOOLTIP_KEYWORD_ACTION_TITLE:
            'Menaxho funksionalitetin e botit sipas fjalëve kyçe të futura nga përdoruesi i botit, në rast të smart flow',
          TOOLTIP_ADD_KEYWORD_ACTIONS_HEADING:
            'Zgjidh përgjigjen e botit si shabllon, fluks, tekst ose imazh kundër fjalëve kyçe të caktuara nga përdoruesi',
          TOOLTIP_ADD_KEYWORD: 'Shto fjalët kyçe',
          TOOLTIP_MATCHING_METHOD:
            'Shto përputhjen e fjalëve kyçe si \'tik-tak\' ose \'përmban\'',
          TOOLTIP_REPLY_MATERIAL:
            'Zgjidh shabllonin, fluksin, tekst ose imazhin për të përgjigjur për fjalën kyçe të sugjeruar',
          TOOLTIP_KEYWORD_ACTIONS: 'Fshij veprimin e fjalës kyçe',
        },
        socialAlerts: {
          alerts: 'Lajmërimet',
          specifyHowYourBotWillNotify:
            'Specifikoni si do të lajmërohet boti për kontaktet e reja.',
        },
      },
      orders: {
        manageCustomersOrder: 'Menaxho Porositë e Klientëve',
        checkAndManageAllOfYourCustomerOrders:
          'Kontrollo dhe menaxho të gjitha porositë dhe përditësimet e klientëve të tu.',
        selectShipmentTemplate: 'Zgjidh Shabllonin e Transportit',
        send: 'Dërgo',
        export: 'Eksport',
        phoneNumber: 'Numri i Telefonit',
        numberOfItems: 'Numri i Artikujve',
        orderValue: 'Vlera e Porosisë',
        orderDate: 'Data e Porosisë',
        status: 'Statusi',
        chat: 'Biseda',
        item: 'Artikulli',
        quantity: 'Sasia',
        amount: 'Shuma',
        unitPrice: 'Çmimi për njësi',
        placeholders: {
          searchOrdersByPhoneNumber: 'Kërko porosi sipas numrit të telefonit',
        },
        appTooltip: {
          exportOrdersDataInCSVFile:
            'Eksporto të dhënat e porosive në skedarin CSV',
          TOOLTIP_ORDERS_PHONE_NO:
            'Numri i telefonit i klientit që ka bërë porosinë',
          TOOLTIP_NO_OF_ITEMS: 'Nr. i artikujve të porositur',
          TOOLTIP_ORDER_VALUE: 'Vlera e porosisë',
          TOOLTIP_ORDER_DATE: 'Porosia është bërë në këtë datë.',
          TOOLTIP_ORDER_STATUS:
            'Statusi i porosisë si i konfirmuar, në pritje, i refuzuar. ose i dërguar',
          TOOLTIP_ORDER_CHAT:
            'Të gjitha bisedat e mëparshme në lidhje me këtë porosi',
        },
      },
      widgets: {
        installWidgetHeader: 'Instalo Widget',
        createWidgetHeader: 'Krijo Widget',
        copyTheCodeAndPasteItWhereYouWant:
          'Kopjo kodin dhe ngjit atje ku të duash në HTML-in tënd, në faqen tënde internetare etj.',
        youCanCreateMultipleWidgets:
          'Mund të krijojmë disa widget-e për të dhënë një pamje të ndryshme të botit në faqet e ndryshme të internetit.',
        installWidget: {
          javascript: 'JavaScript',
          install: 'Instalo',
          onYourWebsite: ' në faqen tënde internetare',
          copyCode: 'Kopjo kodin',
          copyAndPaste: 'Kopjo dhe ngjit',
          copyThisCodeSnippet:
            'Kopjo këtë fragment kodit dhe ngjitje në HTML të çdo faqe interneti ku dëshiron të shfaqësh Widget-in. Për më shumë detaje',
          seeGuide: 'shiko udhëzuesin',
        },
        widgetList: {
          widgetName: 'Emri i Widget-it',
          nameIsRequired: 'Emri është i detyrueshëm',
          cancel: 'Anulo',
          createWidget: 'Krijo Widget',
          icon: 'Ikona',
          name: 'Emri',
          createdAt: 'Krijuar më',
          action: 'Veprimi',
          placeholders: {
            enterWidgetName: 'Vendos emrin e widget-it',
            searchWidgetByName: 'Kërko widget sipas emrit',
          },
          appTooltip: {
            widgetIcon: 'Ikona e widget-it',
            nameOfWidget: 'Emri i widget-it',
            dateAndTimeOfCreationOfWidget:
              'Data dhe ora e krijimit të widget-it',
            editOrDeleteWidget: 'Ndrysho ose fshij widget-in',
          },
        },
        widgetTemplates: {
          widgetName: 'Emri i Widget-it',
          nameIsRequired: 'Emri është i detyrueshëm',
          chooseTypeOfWidget: 'Zgjidh Llojin e Widget-it',
          bar: 'Bar',
          slideIn: 'Shlyerja',
          pageTakeOver: 'Merr Kontrollin e Faqes',
          button: 'Butoni',
          facebookModal: 'Modal në Facebook',
          comment: 'Komenti',
          direct: 'Direkt',
          whatsappIcon: 'Ikonë WhatsApp',
          refUrl: 'URL Referencë',
          qrCode: 'Kodi QR',
          backgroundColor: 'Ngjyra e Prapavijës',
          descriptionColor: 'Ngjyra e Përshkrimit',
          headlineColor: 'Ngjyra e Titullit',
          buttonBackgroundColor: 'Ngjyra e Prapavijës së Butonit',
          contactNumber: 'Numri i Telefonit',
          entryMessage: 'Mesazhi Hyrës',
          buttonText: 'Teksti i Butonit',
          selectButtonText: 'Zgjidh Tekstin e Butonit',
          buttonSize: 'Madhësia e Butonit',
          selectOne: 'Zgjidh një',
          placement: 'Vendosja',
          rightBottom: 'Djathtas-Fund',
          optInFlow: 'Opt-in Flow',
          selectFlow: 'Zgjidh Fluksin',
          addSubscriberToSequence: 'Shto Abonentin në Sekuencë',
          selectDrip: 'Zgjidh Drip',
          whenDoesItDisplay: 'Kur shfaqet (Sekonda)',
          showWidgetToSameUserAgainAfter:
            'Shfaq widget-in për të njëjtin përdorues përsëri pas',
          ifManuallyClosedByUser:
            'Nëse është mbyllur manualisht nga përdoruesi, shfaq pas',
          specificPosts: 'Postimet Specifike',
          allPosts: 'Të gjitha Postimet',
          postMessage: 'Mesazhi i Postës',
          postDate: 'Data e Postës',
          status: 'Statusi',
          action: 'Veprimi',
          discard: 'Hidh poshtë',
          saveChanges: 'Ruaj Ndryshimet',
          nextStep: 'Hapi Tjetër',
          widgetDescription: 'Përshkrimi i Widget-it',
          integrateTheBarWidget:
            `Integro Bar Widget-in në trupin e faqes tënde dhe rrit numrin e abonentëve të faqes sate` +
            ` duke dërguar atyre mesazhe të personalizuara të botit.`,
          hereIsYourWidgetHeadline:
            'Këtu është titulli i widget-it tënd, kliko këtu për ta ndryshuar atë.',
          sendUsMessage: 'Na Dërgo Mesazh',
          weAlsoPutDefaultTextHere:
            'Ne gjithashtu kemi vendosur tekstin parazgjedhës këtu. Sigurohuni që ta ktheni në një mesazh të vlefshëm',
          selectYourPagePost: 'Zgjidh Postën tënde në faqe',
          nA: 'N/A',
          saveRule: 'Ruaj Rregullin',
          placeholders: {
            enterWidgetName: 'Vendos emrin e widget-it',
            enterNumber: 'Vendos numrin',
            enterMessageHere: 'Vendos mesazhin këtu',
            enterTimeInSeconds: 'Vendos kohën në sekonda',
          },
        },
      },
    },
    triggers: {
      customizeYourBotsTriggerSettings: `Rregullo cilesimet e shpërthimit të botit tuaj`,
      makeYourBotsTimingPerfect: `Bëni kohën e botit tuaj të jetë plotësisht e përsosur.`,
      onDesktopTriggerTime: 'Në kohën e shpërthimit në desktop (sekonda)',
      onMobileTriggerTime: 'Në kohën e shpërthimit në celular (sekonda)',
      chatBubble: 'Hapja automatike e fletës së bisedës',
      seconds: 'Sekonda',
      discard: 'Hiqe Dorë',
      saveChanges: 'Ruaj Ndryshimet',
      autoTriggerOnOrOff: 'Çaktivizo Shpërthimin Automatik',
      seeHowToUse: 'Shiko si të përdoret',
      alwaysOpenAfter: 'Gjithmonë hapu pas shpërthimeve të përcaktuara më lart',
      automaticallyAfterSelectedNumberOfTime:
        'Automatikisht pas një periudhe të zgjedhur kohe',
      neverAutomaticallyOpenBot: 'Asnjëherë mos e hap botin automatikisht',
      placeholders: {
        enterTimeInSeconds: 'Vendosni kohën në sekonda',
      },
      appTooltip: {
        TOOLTIP_DESKTOP_TRIGGER_TIME:
          'Koha e pritjes në sekonda, në pajisjet desktop të vizitorit, para se boti juaj të shfaqet automatikisht',
        TOOLTIP_MOBILE_TRIGGER_TIME:
          'Koha e pritjes në sekonda, në celularin e vizitorit, para se boti juaj të shfaqet automatikisht',
        TOOLTIP_CHAT_BUBBLE_OPENING:
          'Kur vizitori mbyll dritaren e bisedës, zgjidhni si do të jetë sjellja automatike e hapjes së botit',
        customerWaitingTimeToOpenBubble:
          'Koha e pritjes e klientit për të hapur fletën e bisedës',
        wantToDisableAutoTriggering:
          'Aktivizo këtë nëse nuk dëshironi hapjen automatike të chatbot në faqen e internetit',
      },
    },
    userAccess: {
      customizeYourBotsSettings: `Rregullo cilesimet e përdoruesit të botit tuaj`,
      decideWhoCanAccessYourBot: 'Vendosni kush mund të hyjë në botin tuaj',
      deviceSupport: 'Mbështetje e Pajisjeve',
      blockIpAddresses: 'Blloko adresat e IP',
      hideChatBotOnSpecificPages: 'Fshih Chatbot në faqet e caktuara',
      selectCountriesToEnableBot: 'Zgjidhni vendet për të aktivizuar botin',
      discard: 'Hiqe Dorë',
      saveChanges: 'Ruaj Ndryshimet',
      seeHowToUse: 'Shiko si të përdoret',
      allDevices: 'Të Gjitha Pajisjet',
      mobileOnly: 'Vetëm Celulari',
      desktopOnly: 'Vetëm Desktopi',
      placeholders: {
        enterIpAddress: `Vendosni adresën IP (ipv4 ose ipv6) dhe shtypni 'Enter'`,
        enterUrl: `Vendosni URL-në e faqeve dhe shtypni 'Enter'`,
        searchCountry: 'Kërko shtetin',
      },
      appTooltip: {
        TOOLTIP_DEVICE_SUPPORT:
          'Zgjidhni në cilat pajisje do të duhej të shfaqet boti juaj',
        TOOLTIP_BLOCK_IP_ADDRESS:
          'Vendosni adresat e IP ku nuk dëshironi që boti juaj të shfaqet',
        TOOLTIP_HIDE_CHATBOT_SPECIFIC_PAGES:
          'Vendosni URL-në e faqeve tuaja ku nuk dëshironi që boti juaj të shfaqet',
        TOOLTIP_COUNTRIES_TO_ENABLE_BOT:
          'Zgjidhni vendndodhjet nga ku dëshironi që përdoruesit të kenë qasje në botin tuaj',
      },
    },
    facebook: {
      facebookBotSettings: 'Rregullime për Botin në Facebook',
      chatFlowsHeader: 'Rrymat e Bisedës',
      dripCampaignHeader: 'Kampanja e Pikimit',
      broadcastHeader: 'Transmetim',
      widgetsHeader: 'Widgets',
      autoReplyHeader: 'Auto-Përgjigje',
      generalHeader: 'Përgjithshme',
      facebookAutomation: 'Automatizimi në Facebook',
      appTooltip: {
        TOOLTIP_CHAT_FLOW_TITLE:
          'Përshtatni modelet e rrymave të bisedës dhe krijoni disa rryma të bisedës për audiencat e ndryshme të synuara.',
        TOOLTIP_DRIP_CAMPAIGN_TITLE:
          'Krijoni një rrugëtim të klientëve duke përdorur një kampanjë pikimi të planifikuar me rrymat e bisedave.',
      },
      broadcasts: {
        createBroadcast: 'Krijo Transmetim',
        youCanCreateMultipleBroadcasts: 'Mund të krijojësh disa transmetime',
        broadcastName: 'Emri i Transmetimit',
        broadcastNameIsRequired: 'Emri i transmetimit është i detyrueshëm',
        continue: 'Vazhdo',
        manageBroadcasts: 'Menaxho Transmetimet',
        youCanCreateMultipleBroadcastsWith:
          'Mund të krijojësh disa transmetime me shabllone të planifikuara për grupe të ndryshme të klientëve.',
        createNewBroadcast: 'Krijo Transmetim të Ri',
        name: 'Emri',
        segment: 'Grupi',
        template: 'Shablloni',
        contacts: 'Kontaktet',
        send: 'Dërgo',
        failed: 'Dështuar',
        broadcastAt: 'Transmetohet Në',
        status: 'Statusi',
        actions: 'Veprimet',
        nA: 'NA',
        deleteBroadcast: 'Fshi Transmetimin',
        wantToDeleteThisBroadcast:
          'A jeni të sigurt se doni të fshini këtë transmetim?',
        placeholders: {
          enterBroadcastName: 'Vendos emrin e transmetimit',
          searchHere: 'Kërko këtu',
        },
        appTooltip: {
          deleteMultipleBroadcasts: 'Fshi disa transmetime',
          deleteBroadcast: 'Fshi Transmetimin',
        },
      },
      createBroadcastFacebook: {
        braodcastName: 'Emri i Transmetimit',
        broadcastNameIsRequired: 'Emri i transmetimit është i detyrueshëm',
        flow: 'Rryma',
        segments: 'Grupet',
        whenToSend: 'Kur të dërgohet',
        selectDate: 'Zgjidh Datën',
        selectTimeSlot: 'Zgjidh Kohën',
        createBroadcast: 'Krijo Transmetim',
        cancel: 'Anulo',
        now: 'Tani',
        later: 'Më vonë',
        placeholders: {
          enterBroadcastName: 'Vendos emrin e transmetimit',
          selectFlow: 'Zgjidh Rrymën',
          searchFlowByName: 'Kërko rrymën sipas emrit',
          selectSegments: 'Zgjidh Grupet',
          searchSegmentByName: 'Kërko grupin sipas emrit',
          selectTimeSlot: 'Zgjidh Kohën',
        },
        indexMergeDatePicker: {
          selectStartDate: 'Zgjidh datën e fillimit',
        },
      },
      dripCampaigns: {
        createDripCampaign: 'Krijo Kampanjë Pikimi',
        youCanCreateMultipleCampaign: 'Mund të krijojësh disa kampanja',
        dripCampaignName: 'Emri i Kampanjës së Pikimit',
        dripCampaignNameIsRequired:
          'Emri i kampanjës së pikimit është i detyrueshëm',
        continue: 'Vazhdo',
        manageDripCampaign: 'Menaxho Kampanjën e Pikimit',
        youCanCreateMutlipleDripCampaign:
          'Mund të krijojësh disa kampanja të pikimit me mesazhe të planifikuara, automatike për të shkaktuar reagime nga grupet e përdoruesve specifike.',
        createNewDripCampaign: 'Krijo Kampanjë të Re Pikimi',
        campaignName: 'Emri i Kampanjës',
        appliedOn: 'Zbatuar Në',
        segment: 'Grupi',
        flow: 'Rryma',
        startDate: 'Data e Fillimit',
        action: 'Veprimi',
        nA: 'NA',
        deleteDripCampaign: 'Fshi Kampanjën e Pikimit',
        wantToDeleteThisDripCampaign:
          'A jeni të sigurt se doni ta fshini këtë kampanjë pikimi?',
        placeholders: {
          enterDripCampaignName: 'Vendos emrin e kampanjës së pikimit',
          searchByName: 'Kërko Sipas Emrit',
        },
        appTooltip: {
          deleteMultipleDripCampaigns: 'Fshi disa kampanja të pikimit',
          deleteDripCampaign: 'Fshi Kampanjën e Pikimit',
        },
        createDripCampaignFacebook: {
          dripCampaignName: 'Emri i Kampanjës së Pikimit',
          appliedOn: 'Zbatuar Në',
          segments: 'Grupet',
          selectDate: 'Zgjidh Datën',
          scheduleYourFlows: 'Planifikoni Rrymat Tuaja',
          schedule: 'Planifikoni',
          flow: 'Rryma',
          sendAfter: 'Dërgohet Pas',
          cancel: 'Anulo',
          newSubscriber: 'Abonues i Ri',
          days: 'Ditët',
          minutes: 'Minutat',
          hours: 'Orët',
          createDripCampaign: 'Krijo Kampanjë Pikimi',
          placeholders: {
            enterDripName: 'Vendos emrin e kampanjës së pikimit',
            selectAppliedOn: 'Zgjidh Zbatimin Në',
            selectSegment: 'Zgjidh Grupin',
            searchByName: 'Kërko Sipas Emrit',
            selectTemplate: 'Zgjidh Shabllonin',
            searchFlowByName: 'Kërko Rrymën Sipas Emrit',
            enterSendAfter: 'Vendos Dërgohet Pas',
          },
          dateTimePicker: {
            selectStartDate: 'Zgjidh datën e fillimit',
          },
        },
      },
      failedBroadcastFacebook: {
        chatId: 'ID e Bisedës',
        errorCode: 'Kodi i Gabimit',
        errorMessage: 'Mesazhi i Gabimit',
        nA: 'NA',
      },
      flows: {
        chatFlows: 'Rrymat e Bisedës',
        createChatFlow: 'Krijo Rrymën e Bisedës',
        youCanCreateMultipleChatFlows:
          'Mund të krijojësh disa rryma bisedash nëpër kanale të ndryshme për testim A/B dhe transmetime.',
        flowName: 'Emri i Rrymës',
        nameIsRequired: 'Emri është i detyrueshëm',
        cancel: 'Anulo',
        createFlow: 'Krijo Rrymë',
        importFlow: 'Importo Rrymën',
        createNewFlow: 'Krijo Rrymë të Re',
        ofMessages: 'mesazhe',
        createdOn: 'Krijuar më',
        lastModified: 'Modifikuar për herë te fundit më',
        defaultFlow: 'Rryma e Parazgjedhur',
        action: 'Veprimi',
        exportStatus: 'Statusi i Eksportit',
        flowExport: 'Eksporti i Rrymës ',
        download: 'Shkarko',
        beforeYouStartUploadPleaseMakeSure:
          'Para se të filloni ngarkimin, ju lutemi sigurohuni',
        point1:
          '1. Kufiri maksimal i madhësisë së dosjes për ngarkim është 20MB',
        point2: '2. Format i dosjes duhet të jetë JSON',
        selectFile: 'Zgjidh Dosjen',
        inProgress: 'në progres',
        available: 'E vlefshme',
        initiated: 'Nisur',
        placeholders: {
          enterFlowName: 'Vendos emrin e rrymës',
        },
        appTooltip: {
          importFlowForFacebookBot: 'Importo rrymën për botin në Facebook',
          dateAndTimeOfCreationOfChatFlow:
            'Data dhe ora e krijimit të rrymës së bisedës',
          dateAndTimeWhenChatFlowLastModified:
            'Data dhe ora kur rryma e bisedës është modifikuar për herë te fundit',
          TOOLTIP_CREATE_FLOW: 'Klikoni për të krijuar një rrymë bisede të re',
          TOOLTIP_FLOW_NAME: 'Vendos emrin e rrymës së bisedës',
          TOOLTIP_FLOW_TABLE_NAME: 'Emri i rrymës së bisedës',
          TOOLTIP_NO_OF_MESSAGES:
            'Numri i komponentëve të mesazhit në rrymën e bisedës',
          TOOLTIP_DEFAULT_FLOW:
            'Përdorni këtë kapak për të vendosur një rrymë bisede si parazgjedhje, që do shërbehet për të gjithë përdoruesit e rinj.',
          TOOLTIP_ACTION: 'Ndryshoni ose fshini rrymën e bisedës',
        },
        noDataFound: {
          flows: 'Rrymat',
          noFlowsAddedYet: 'Ende nuk janë shtuar rryma!',
        },
        modal: {
          deleteFlow: 'Fshi Rrymën',
          wantToDeleteThisFlow:
            'A jeni të sigurt se doni ta fshini këtë rrymë?',
        },
      },
      widgets: {
        manageWidgets: 'Menaxho Widgets',
        widgetsAreRoutingTools:
          'Widgets janë mjete drejtimi për të rritur përdorimin e botit',
        needHelp: 'Kërkoni Ndihmë?',
        wantToMakeChanges: 'Dëshironi të bëni ndryshime?',
        editIcon: 'Ndrysho Ikonën',
        discard: 'Hidh poshtë',
        updateWidget: 'Përditëso Widget',
        installChatBotIconOnYourWebsite:
          'Instalo ikonën e chatbot në faqen tënde',
        shareWhereEverYouWantToRedirectUsersTo:
          'Ndani kudo që dëshironi dhe ridrejtoni përdoruesit në botin tuaj në Facebook në një klikim',
        copyAndAddInYourWebsiteHeaderFile:
          'Kopjo dhe shto në dosjen e kokës së faqes tënde',
        copyLinkAndStartSharing: 'Kopjo lidhjen dhe fillo ndarjen!',
        downloadQrCodeAndStartSharing: 'Shkarko kodin QR dhe fillo ndarjen!',
        addCodeAndDeployNewCodeAndDone:
          'Shto kodin, deploy kodin e ri dhe Gati!',
        wantToLearnHowToUseIt: 'Dëshironi të mësoni se si ta përdorni?',
        copyChatBotCode: 'Kopjo Kodin e Chatbot',
        copyFacebookLink: 'Kopjo Lidhjen e Facebook',
        downloadQrCode: 'Shkarko Kodin QR',
        link: 'Lidhja',
        chatBotIcon: 'Ikonë Chatbot',
        qrcode: 'Kodi QR',
        small: 'I vogël',
        medium: 'Mesatar',
        large: 'I madh',
        leftMiddle: 'Majtas-Mesit',
        rightMiddle: 'Djathtas-Mesit',
        leftBottom: 'Majtas-Poshtë',
        rightBottom: 'Djathtas-Poshtë',
        bpDropDown: {
          selectIcons: 'Zgjidh Ikona',
          iconSize: 'Madhësia e Ikonës',
          iconPlacement: 'Vendosja e Ikonës',
        },
      },
      autoReply: {
        autoReplyTitle: 'Auto-Përgjigje',
        configureYour: 'Konfiguro ',
        message: ' mesazhin',
        customizeAutoReplyMessagesForYourPostsComments:
          'Rregullo mesazhet e përgjigjes automatike për komentet e postimeve tuaja',
        wouldYouLikeToApply: 'Dëshironi të aplikoni ',
        autoreply: 'Auto-Përgjigje',
        onAllPost: ' në të gjitha postimet',
        configureYourMessageForEachPost: 'Konfiguro mesazhin për çdo postim',
        configureFlowToTriggerAfterOnReply:
          'Konfiguro rrymën për të shkaktuar pas një përgjigje',
        whenUserLeavesACommentSendMessageAfter:
          'Kur përdoruesi lë një koment, dërgo mesazh pas',
        triggerFlowOnReply: 'Shkakto rrymën në përgjigje',
        add: 'Shto',
        update: 'Përditëso',
        save: 'Ruaj',
        cancel: 'Anulo',
        discard: 'Hidh poshtë',
        bpDropDown: {
          selectPost: 'Zgjidh postimin',
          triggerFlowOnReply: 'Shkakto rrymën në përgjigje',
          immendiately: 'Menjëherë',
          minutes: 'minuta',
        },
        bpTable: {
          message: 'Mesazhi',
          selectedPost: 'Postimi i Zgjedhur',
          triggerFlow: 'Shkakto Rrymën',
          actions: 'Veprimet',
        },
        placeholder: {
          configureYourMessage: 'Konfiguro mesazhin tënd',
        },
        deleteModel: {
          title: 'Fshi Auto-Përgjigjen e Postimit',
          description:
            'A jeni të sigurt se doni të fshini këtë Auto-Përgjigje të postimit?',
        },
      },
      generalSetting: {
        sendInactivityMessage: 'Mesazhi i Përdoruesit Pas Paaktivitetit',
        sessionTimeOutInHours: 'Koha e Skadimit të Sesionit',
        enterSessionTimeOutWindowInHours:
          'Vendos dritaren e kohës së skadimit të sesionit në orë',
        sessionTimeOutInHoursTooltip: `Vendosni kohën pas së cilës sesioni i bisedës do të skadojë automatikisht
          për shkak të paaktivitetit. Biseda do të rifillojë nëse përdoruesi dërgon ndonjë mesazh pas skadimit të sesionit`,
        restartChatFlowTriggers: 'Shkakto Triggers e Rifillimit të Bisedës',
        enterKeyWordsToRestartChatAndhitEnter:
          'Vendosni fjalë kyçe për të rifilluar bisedën dhe shtypni Enter',
        restartChatFlowTriggersTooltip: `Specifikoni këtu fjalë kyçe që, kur futën nga përdoruesi dhe paraqiten, do të shkaktojnë një rifillim të rrjedhës së bisedës. Kjo lejon përdoruesit të rifillojnë bisedën në çdo moment.
          Shtypni Enter pas çdo fjalë kyçe për të shtuar disa fjalë kyçe.`,
        liveChatTriggers: 'Shkakto Triggers e Bisedës Live',
        enterKeyWordsToTriggerLiveChatAndhitEnter:
          'Vendosni fjalë kyçe për të shkaktuar bisedën live dhe shtypni Enter',
        liveChatTriggersTooltip: `Përcaktoni fjalë kyçe që, kur futën nga përdoruesi dhe paraqiten, do të nisin një kalim nga biseda automatike në bisedë live. Kjo është e dobishme kur përdoruesit kanë nevojë për ndihmë nga një
          agjent live. Shtypni Enter pas çdo fjalë kyçe për të shtuar disa fjalë kyçe.`,
        messageAfterAutomatedFlowCompleted:
          'Mesazhi pas përfundimit të rrjedhës automatike',
        enterYourMessage: 'Vendosni mesazhin tuaj',
        messageAfterAutomatedFlowCompletedTooltip: `Vendosni një mesazh që do të shfaqet përdoruesit pasi ata kanë përfunduar rrjedhën automatike të bisedës, por sesioni nuk ka skaduar ende.`,
        restart: 'Rifillo',
        liveChat: 'Biseda Live',
        lineOneForDefaultMessage:
          'Nëse keni më shumë pyetje ose keni nevojë për ndihmë, këtu është çfarë mund të bëni më tej:',
        to: 'Te',
        restartTheChat: 'rifillo bisedën',
        simpleTypeRestartAndHitEnter: ` thjesht shkruani 'Rifillo' dhe shtypni Enter. Kjo do t'ju kthejë në fillim të rrjedhës së bisedës tonë.`,
        lineThreeForDefaultMessagePartOne: `Nëse dëshironi të flisni me një`,
        liveAgent: `agjent live,`,
        lineThreeForDefaultMessageLastPart: `shkruani 'Biseda Live' dhe shtypni Enter. Ekipi ynë është këtu për t'ju ndihmuar në kohë reale.`,
        saveChanges: 'Ruaj Ndryshimet',
        discard: 'Hidh poshtë',
        configureBotsGeneralSettings: `Konfiguro cilësimet e përgjithshme të botit tuaj`,
        minutes: 'Minuta',
        hours: 'Orë',
      },
    },
    instagram: {
      instagramBotSettings: 'Cilësimet e Botit të Instagram',
      chatFlowsHeader: 'Rrymët e Bisedës',
      broadcastHeader: 'Transmetim',
      dripCampaignHeader: 'Fushat e Pikëllimit',
      widgetsHeader: 'Widgets',
      alertsHeader: 'Sinjalizime',
      alerts: {
        configureYourBotsSettings: `Konfiguro cilësimet e sinjalizimeve të botit tënd`,
        specifyHowYourBotNotifyYou:
          'Specifiko se si boti yt do të të njoftojë për klientë të rinj.',
        subject: 'Subjekti',
        emailNotification: 'Njoftimi me Email',
        emailAddresses: 'Adresat e Email-it',
        leadRevisitNotifications: 'Njoftime për rikthim të klientit',
        whenToSendLeadInfo: 'Kur të dërguarit e informacionit të klientit',
        discard: 'Hidh poshtë',
        saveChanges: 'Ruaj Ndryshimet',
        placeholders: {
          enterSubjectForYourEmail: 'Vendos subjektin për emailin tënd',
          typeYourEmailAddressAndHitEnter:
            'Shkruaj adresën tënde të email-it dhe shtyp Enter',
        },
      },
      broadcasts: {
        createBroadcast: 'Krijo Transmetim',
        youCanCreateMultipleBroadcasts: 'Mund të krijojësh disa transmetime',
        broadcastName: 'Emri i Transmetimit',
        broadcastNameIsRequired: 'Kërkohet emri i transmetimit',
        continue: 'Vazhdo',
        manageBroadcasts: 'Menaxho Transmetimet',
        youCanCreateMultipleBroadcastsWithMultipleTemplatesAndDifferentSegments:
          'Mund të krijojësh disa transmetime me shabllone të ndryshme dhe segmente të ndryshme për grupe të ndryshme të klientëve.',
        createNewBroadcast: 'Krijo Transmetim të Ri',
        segment: 'Grupi',
        template: 'Shablloni',
        contacts: 'Kontaktet',
        send: 'Dërgo',
        failed: 'Dështoi',
        broadcastAt: 'Transmetimi Në',
        status: 'Statusi',
        actions: 'Veprimet',
        nA: 'NA',
        placeholders: {
          enterBroadcastName: 'Vendos emrin e transmetimit',
          searchHere: 'Kërko këtu',
        },
        appTooltip: {
          deleteMultipleBroadcasts: 'Fshi disa transmetime',
          deleteBroadcast: 'Fshi Transmetim',
        },
      },
      createBroadcast: {
        broadcastName: 'Emri i Transmetimit',
        broadcastNameIsRequired: 'Kërkohet emri i transmetimit',
        flow: 'Rryma',
        segments: 'Grupe',
        whenToSend: 'Kur të dërguarit',
        selectDate: 'Zgjidh Datën',
        selectTimeSlot: 'Zgjidh Orën',
        cancel: 'Anulo',
        createBroadcast: 'Krijo Transmetim',
        placeholders: {
          enterBroadcastName: 'Vendos emrin e transmetimit',
          selectFlow: 'Zgjidh Rrymën',
          searchFlowByName: 'Kërko sipas emrit të rrymës',
          selectSegments: 'Zgjidh Grupet',
          searchSegmentByName: 'Kërko sipas emrit të grupit',
          selectTimeSlot: 'Zgjidh Orën',
        },
        indexMergeDatePicker: {
          selectStartDate: 'Zgjidh datën e fillimit',
        },
      },
      dripCampaigns: {
        createDripCampaign: 'Krijo Fushat e Pikëllimit',
        youCanCreateMultipleCampaigns: 'Mund të krijojësh disa fushata',
        dripCampaignName: 'Emri i Fushat së Pikëllimit',
        dripCampaignNameIsRequired: 'Kërkohet emri i fushatës së pikëllimit',
        continue: 'Vazhdo',
        manageDripCampaign: 'Menaxho Fushat e Pikëllimit',
        youCanCreateMultipleCampaignsWith:
          'Mund të krijojësh disa fushata të pikëllimit me mesazhe të planifikuara dhe të automatizuara për të shkaktuar reagime nga grupet specifike të përdoruesve.',
        createNewDripCampaign: 'Krijo Fushat e Pikëllimit të Re',
        campaignName: 'Emri i Fushatës',
        appliedOn: 'Aplikuar në',
        segment: 'Grupi',
        flow: 'Rryma',
        startDate: 'Data e Fillimit',
        action: 'Veprimi',
        nA: 'NA',
        placeholders: {
          enterDripCampaignName: 'Vendos emrin e fushatës së pikëllimit',
          searchByName: 'Kërko Sipas Emrit',
        },
        appTooltip: {
          deleteMultipleDripCampaigns: 'Fshi disa fushata të pikëllimit',
          deleteDripCampaign: 'Fshi Fushat e Pikëllimit',
        },
        createDripCampaignInstagram: {
          dripCampaignName: 'Emri i Fushat së Pikëllimit',
          appliedOn: 'Aplikuar në',
          segments: 'Grupe',
          selectDate: 'Zgjidh Datën',
          scheduleYourFlows: 'Planifikoni Rrymat Tuaja',
          flow: 'Rryma',
          sendAfter: 'Dërgo Pas',
          cancel: 'Anulo',
          createDripCampaign: 'Krijo Fushat e Pikëllimit',
          placeholders: {
            enterDripName: 'Vendos emrin e fushatës së pikëllimit',
            selectAppliedOn: 'Zgjidh Aplikuar në',
            selectSegment: 'Zgjidh Grupin',
            searchByName: 'Kërko Sipas Emrit',
            selectTemplate: 'Zgjidh Shabllonin',
            searchFlowByName: 'Kërko sipas emrit të rrymës',
            enterSendAfter: 'Vendos dërguarin e pas',
          },
          dateTimePicker: {
            selectStartDate: 'Zgjidh datën e fillimit',
          },
        },
      },
      failedBroadcastInstagram: {
        chatId: 'ID e Bisedës',
        errorCode: 'Kodi i Gabimit',
        errorMessage: 'Mesazhi i Gabimit',
        nA: 'NA',
      },
      flows: {
        chatFlows: 'Rrymat e Bisedës',
        createChatFlow: 'Krijo Rrymën e Bisedës',
        youCanCreateMultipleChatFlows:
          'Mund të krijojësh disa rrjedha bisede nëpër kanale të ndryshme për provime A/B dhe transmetime.',
        flowName: 'Emri i Rrymës',
        nameIsRequired: 'Kërkohet emri',
        cancel: 'Anulo',
        createFlow: 'Krijo Rrymë',
        importFlow: 'Importo Rrymën',
        createNewFlow: 'Krijo Rrymë të Re',
        ofMessages: ' të mesazheve',
        createdOn: 'Krijuar më',
        lastModified: 'I fundit i ndryshuar',
        defaultFlow: 'Rryma parazgjedhur',
        action: 'Veprimi',
        exportStatus: 'Statusi i Eksportit',
        flowExport: 'Eksporti i Rrymës',
        download: 'Shkarko',
        beforeYouStartUploadPleaseMakeSure:
          'Para se të filloni ngarkimin, ju lutemi sigurohuni',
        point1: '1. Kufiri i madhësisë së skedarit të ngarkuar është 20MB',
        point2: '2. Formatit i skedarit duhet të jetë JSON',
        selectFile: 'Zgjidh Skedarin',
        placeholders: {
          enterFlowName: 'Vendos emrin e rrymës',
        },
        appTooltip: {
          importFlowForInstagramBot: 'Importo rrymën për botin e Instagram',
          dateAndTimeOfCreationOfChatFlow:
            'Data dhe ora e krijimit të rrjedhës së bisedës',
          dateAndTimeWhenChatFlowLastModified:
            'Data dhe ora kur rrjedha e bisedës është e fundit e ndryshuar',
        },
        noDataFound: {
          flows: 'Rrymat',
          noFlowsAddedYet: 'Ende nuk është shtuar asnjë rrjedhë!',
        },
        modal: {
          deleteFlow: 'Fshi Rrymën',
          wantToDeleteThisFlow:
            'A jeni të sigurtë që dëshironi të fshini këtë rrjedhë?',
        },
      },
      widgets: {
        manageWidgets: 'Menaxho Widgets',
        widgetsAreRoutingTools:
          'Widget-et janë mjetet e rrugëtimit për të rritur përdorimin e botit',
        needHelp: 'Ke nevojë për Ndihmë?',
        wantToMakeChanges: 'Dëshironi të bëni ndryshime?',
        editIcon: 'Ndrysho Ikonen',
        discard: 'Hidh poshtë',
        updateWidget: 'Rifresko Widget-in',
        bpDropDown: {
          selectIcons: 'Zgjidh Ikonat',
          iconSize: 'Madhsia e Ikonës',
          iconPlacement: 'Vendosja e Ikonës',
        },
      },
    },
    telegram: {
      telegramBotSettings: 'Cilësimet e Botit të Telegramit',
      chatFlowsHeader: 'Rrymat e Bisedës',
      telegramProfileHeader: 'Profili i Telegramit',
      widgetsHeader: 'Widgets',
      broadcastHeader: 'Transmetim',
      dripCampaignHeader: 'Fushat e Pikëllimit',
      generalHeader: 'Përgjithshme',
      telegramAutomation: 'Automatizimi i Telegramit',
      appTooltip: {
        TOOLTIP_DRIP_CAMPAIGN_TITLE:
          'Krijo një udhëtim të onbordimit të klientit duke përdorur një fushatë të pikëllimit të rrymave të planifikuara të bisedave.',
        TOOLTIP_CHAT_FLOW_TITLE:
          'Përsonalizoni shabllonet e rrjedhës së bisedës dhe krijo disa rrjedha bisede për audiencat e ndryshme të synuara.',
      },
      broadcasts: {
        createBroadcast: 'Krijo Transmetim',
        youCanCreateMutlipleBroadcasts: 'Mund të krijojësh disa transmetime',
        broadcastName: 'Emri i Transmetimit',
        broadcastNameIsRequired: 'Kërkohet emri i transmetimit',
        continue: 'Vazhdo',
        manageBroadcasts: 'Menaxho Transmetimet',
        youCanCreateMultipleBroadcastsWith:
          'Mund të krijojësh disa transmetime me shabllone të ndryshme të planifikuara për grupe të ndryshme të klientëve.',
        createNewBroadcast: 'Krijo Transmetim të Ri',
        name: 'Emri',
        segment: 'Grupi',
        template: 'Shablloni',
        contacts: 'Kontaktet',
        send: 'Dërgo',
        failed: 'Dështoi',
        broadcastAt: 'Transmetimi Në',
        status: 'Statusi',
        actions: 'Veprimet',
        nA: 'NA',
        deleteBroadcast: 'Fshi Transmetim',
        wantToDeleteThisBroadcast:
          'A jeni të sigurtë që dëshironi ta fshini këtë transmetim?',
        placeholders: {
          enterBroadcastName: 'Vendos emrin e transmetimit',
          searchHere: 'Kërko këtu',
        },
        appTooltip: {
          deleteMultipleBroadcasts: 'Fshi disa transmetime',
          deleteBroadcast: 'Fshi Transmetim',
        },
      },
      createBroadcastTelegram: {
        broadcastName: 'Emri i Transmetimit',
        broadcastNameIsRequired: 'Kërkohet emri i transmetimit',
        flow: 'Rryma',
        segments: 'Grupe',
        whenToSend: 'Kur të dërguarit',
        selectDate: 'Zgjidh Datën',
        selectTimeSlot: 'Zgjidh Orën',
        cancel: 'Anulo',
        createBroadcast: 'Krijo Transmetim',
        now: 'Tani',
        later: 'Më vonë',
        placeholders: {
          enterBroadcastName: 'Vendos emrin e transmetimit',
          selectFlow: 'Zgjidh Rrymën',
          searchFlowByName: 'Kërko sipas emrit të rrymës',
          selectSegments: 'Zgjidh Grupet',
          searchSegmentByName: 'Kërko sipas emrit të grupit',
          selectTimeSlot: 'Zgjidh Orën',
        },
        indexMergeDatePicker: {
          selectStartDate: 'Zgjidh datën e fillimit',
        },
      },
      dripCampaigns: {
        createDripCampaign: 'Krijo Fushat e Pikëllimit',
        youCanCreateMultipleCampaigns: 'Mund të krijojësh disa fushata',
        dripCampaignName: 'Emri i Fushatës së Pikëllimit',
        dripCampaignNameIsRequired: 'Kërkohet emri i fushatës së pikëllimit',
        continue: 'Vazhdo',
        manageDripCampaign: 'Menaxho Fushat e Pikëllimit',
        youCanCreateMultipleDripCampaignsWith:
          'Mund të krijojësh disa fushata të pikëllimit me mesazhe të planifikuara automatikisht' +
          ' për të shkaktuar reagime nga grupe specifike të përdoruesve.',
        createNewDripCampaign: 'Krijo Fushat e Pikëllimit të Reja',
        campaignName: 'Emri i Fushatës',
        appliedOn: 'Zbatuar në',
        segment: 'Grupi',
        flow: 'Rryma',
        startDate: 'Data e Fillimit',
        action: 'Veprimi',
        nA: 'NA',
        deleteDripCampaign: 'Fshi Fushat e Pikëllimit',
        wantToDeleteThisDripCampaign:
          'A jeni të sigurtë që dëshironi ta fshini këtë fushatë të pikëllimit?',
        placeholders: {
          enterDripCampaignName: 'Vendos emrin e fushatës së pikëllimit',
          searchByName: 'Kërko sipas emrit',
        },
        appTooltip: {
          deleteMultipleDripCampaigns: 'Fshi disa fushata të pikëllimit',
          deleteDripCampaign: 'Fshi Fushat e Pikëllimit',
        },
        createDripCampaignTelegram: {
          dripCampaignName: 'Emri i Fushatës së Pikëllimit',
          appliedOn: 'Zbatuar në',
          segments: 'Grupe',
          startDate: 'Zgjidh Datën',
          scheduleYourFlows: 'Planifikoni Rrymat Tuaja',
          schedule: 'Orari',
          flow: 'Rryma',
          sendAfter: 'Dërgo Pas',
          cancel: 'Anulo',
          createDripCampaign: 'Krijo Fushatë të Pikëllimit',
          newSubscriber: 'Abonent i Ri',
          days: 'Ditë',
          minutes: 'Minuta',
          hours: 'Orë',
          placeholders: {
            enterDripName: 'Vendos emrin e pikëllimit',
            selectAppliedOn: 'Zgjidh Zbatimin',
            selectSegment: 'Zgjidh Grupin',
            searchByName: 'Kërko sipas emrit',
            selectFlow: 'Zgjidh Rrymën',
            searchFlowByName: 'Kërko sipas emrit të rrymës',
          },
          dateTimePicker: {
            selectStartDate: 'Zgjidh datën e fillimit',
          },
        },
      },
      failedBroadcastTelegram: {
        name: 'Emri',
        email: 'Email',
        phone: 'Telefoni',
        errorCode: 'Kodi i Gabimit',
        errorMessage: 'Mesazhi i Gabimit',
        nA: 'NA',
      },
      flows: {
        chatFlows: 'Rrymat e Bisedës',
        createChatFlow: 'Krijo Rrymë Bisede',
        youCanCreateMultipleChatFlows:
          'Mund të krijojësh disa rrjedha bisede nëpër kanale të ndryshme për testim A/B dhe transmetime.',
        flowName: 'Emri i Rrymës',
        nameIsRequired: 'Kërkohet emri',
        cancel: 'Anulo',
        createFlow: 'Krijo Rrymë',
        importFlow: 'Importo Rrymën',
        createNewFlow: 'Krijo Rrymë të Re',
        ofMessages: ' nga mesazhet',
        createdOn: 'Krijuar më',
        lastModified: 'I ndryshuar për herë te fundit',
        defaultFlow: 'Rryma Parazgjedhur',
        action: 'Veprimi',
        exportStatus: 'Statusi i Eksportit',
        flowExport: 'Rryma - Eksport ',
        inProgress: 'në progres',
        available: 'I disponueshëm',
        initiated: 'Nisur',
        download: 'Shkarko',
        beforeYouStartUploadPleaseMakeSure:
          'Para se të filloni ngarkimin, ju lutemi sigurohuni që',
        point1: '1. Kufiri maksimal i madhësisë së ngarkimit është 20MB',
        point2: '2. Formati i skedarit duhet të jetë në JSON',
        selectFile: 'Zgjidh Skedarin',
        placeholders: {
          enterFlowName: 'Vendos emrin e rrjedhës',
        },
        appTooltip: {
          importFlowForTelegramBot: 'Importo rrjedhën për botin e Telegramit',
          dateAndTimeOfCreationOfChatFlow:
            'Data dhe ora e krijimit të rrjedhës së bisedës',
          dateAndTimeWhenChatFlowLastModified:
            'Data dhe ora kur rrjedha e bisedës është ndryshuar për herë te fundit',
          TOOLTIP_CREATE_FLOW: 'Klikoni për të krijuar një rrjedhë bisede të re',
          TOOLTIP_FLOW_NAME: 'Shkruani emrin e rrjedhës së bisedës',
          TOOLTIP_FLOW_TABLE_NAME: 'Emri i rrjedhës së bisedës',
          TOOLTIP_NO_OF_MESSAGES: 'Numri i komponenteve të mesazhit në rrjedhën e bisedës',
          TOOLTIP_DEFAULT_FLOW:
            'Përdorni këtë kapëse për të caktuar një rrjedhë bisede si parazgjedhur, e cila do shërbehet për të gjithë përdoruesit e rinj.',
          TOOLTIP_ACTION: 'Edito ose fshi rrjedhën e bisedës',
        },
        noDataFound: {
          flows: 'Rrymat',
          noFlowsAddedYet: 'Asnjë rrjedhë e bisedës ende!',
        },
        modal: {
          deleteFlow: 'Fshi Rrymën',
          wantToDeleteThisFlow: 'A jeni të sigurtë që dëshironi ta fshini këtë rrjedhë?',
        },
      },
      telegramProfile: {
        telegramProfile: 'Profili i Telegramit',
        manageYourBotProfile: 'Menaxho profilin tënd të botit sipas dëshirës.',
        allSetNoActionRequired: 'Gati, nuk kërkohet veprim!',
        congratulationYourAccountIsLive:
          'Urime! Llogaria juaj është aktive me qasje të plotë',
        botDetails: 'Detajet e Botit',
        name: 'Emri',
        nA: 'NA',
        b: 'B',
        botName: 'Emri i Botit',
        bot: 'Boti',
        info: 'Info',
        none: 'Asnjë',
        username: 'Emri i përdoruesit',
        notifications: 'Njoftimet',
        on: 'Në',
        addToGroupOrChannel: 'Shto në Grup ose Kanal',
        userName: 'Emri i përdoruesit',
        botToken: 'Tokeni i Botit',
      },
      widgets: {
        manageWidgets: 'Menaxho Widget-at',
        widgetsAreRoutingTools:
          'Widget-at janë mjetet e drejtimimit për të rritur përdorimin e botit',
        needHelp: 'Ke nevojë për Ndihmë?',
        wantToMakeChanges: 'Dëshiron të bësh ndryshime?',
        editIcon: 'Edito Ikonen',
        discard: 'Hidh Poshtë',
        updateWidget: 'Përditëso Widget-in',
        installChatBotIconOnYourWebsite: 'Instalo ikonën e chatbot-it në faqen tënde',
        shareWhereEverYouWantRedirectUsersTo:
          'Ndaje kudo që të dëshirosh dhe ridrejto përdoruesit tek boti yt në një klikim',
        copyAndAddInYourWebsiteHeaderFile: 'Kopjo dhe shto në skedarin e kryebqesës të faqes tënde',
        copyLinkAndStartSharing: 'Kopjo lidhjen dhe fillo ndarjen!',
        downloadQrCodeAndStartSharing: 'Shkarko kodin QR dhe fillo ndarjen!',
        addCodeAndDeployNewCodeAndDone: 'Shto kodin, shpërndaj kodin e ri dhe gati!',
        wantToLearnHowToUseIt: 'Dëshiron të mësosh se si ta përdorësh?',
        copyChatBotCode: 'Kopjo Kodin e Chatbot-it',
        downloadQrCode: 'Shkarko Kodin QR',
        copyTelegramLink: 'Kopjo Lidhjen e Telegramit',
        link: 'Lidhja',
        chatBotIcon: 'Ikonë Chatbot',
        qrcode: 'Kodi QR',
        small: 'Vogël',
        medium: 'Mesatare',
        large: 'E madhe',
        leftMiddle: 'Majtas-Mesit',
        rightMiddle: 'Djathtas-Mesit',
        leftBottom: 'Majtas-Fundit',
        rightBottom: 'Djathtas-Fundit',
        bpDropDown: {
          selectIcons: 'Zgjidh Ikonat',
          iconSize: 'Madhësia e Ikonës',
          iconPlacement: 'Vendosja e Ikonës',
        },
      },
      generalSetting: {
        sendInactivityMessage: 'Mesazhi i Padukshëm i Përdoruesit',
        sessionTimeOutInHours: 'Kohëzgjatja e Sesionit',
        enterSessionTimeOutWindowInHours:
          'Vendos dritaren e kohës së skadimit të sesionit në orë',
        sessionTimeOutInHoursTooltip: `Vendos kohën pas së cilës sesioni i bisedës do të skadojë automatikisht
           për shkak të padukshëm. Fluturimi i bisedës do rifillojë nëse përdoruesi dërgon ndonjë mesazh pas skadimit të sesionit`,
        restartChatFlowTriggers: 'Triggers për Rifillim të Bisedës',
        enterKeyWordsToRestartChatAndhitEnter:
          'Vendos fjalë kyçe për rifillimin e bisedës dhe shtyp Enter',
        restartChatFlowTriggersTooltip: `Specifikoni këtu fjalë kyçe që, kur shtypen nga përdoruesi dhe paraqiten, do të nisin një
        rifillim të rrjedhës së bisedës. Kjo lejon përdoruesit të rifillojnë bisedën në çdo moment.
          Shtyp Enter pasi të shtosh çdo fjalë kyçe për të shtuar disa fjalë kyçe.`,
        liveChatTriggers: 'Live Chat Triggers',
        enterKeyWordsToTriggerLiveChatAndhitEnter:
          'Vendos fjalë kyçe për të nisur bisedën live dhe shtyp Enter',
        liveChatTriggersTooltip: `Përcakto fjalë kyçe që, kur shtypen nga përdoruesi dhe paraqiten, do të iniciojnë një kalim nga biseda
         automatike në bisedë live. Kjo është e dobishme kur përdoruesit kanë nevojë për ndihmë nga një agjent i drejtpërdrejt.
          Shtyp Enter pasi të shtosh çdo fjalë kyçe për të shtuar disa fjalë kyçe.`,
        messageAfterAutomatedFlowCompleted:
          'Mesazhi pas përfundimit të rrjedhës automatike',
        enterYourMessage: 'Vendos mesazhin tënd',
        messageAfterAutomatedFlowCompletedTooltip: `Vendos një mesazh që do t'i shfaqet përdoruesit pasi kanë përfunduar rrjedhën e bisedës
         automatike, por sesioni nuk ka skaduar ende.`,
        restart: 'Rifillo',
        liveChat: 'Bisedë Live',
        lineOneForDefaultMessage:
          'Nëse keni pyetje të tjera ose nevojë për ndihmë, këtu është çfarë mund të bëni më tej:',
        to: 'Për',
        restartTheChat: 'rifillo bisedën',
        simpleTypeRestartAndHitEnter: ` thjesht shtyp 'Rifillo' dhe shtyp Enter. Kjo do të të kthejë në fillim të
         rrjedhës së bisedës tonë.`,
        lineThreeForDefaultMessagePartOne: `Nëse dëshironi të flisni me një`,
        liveAgent: `agjent të drejtpërdrejtë,`,
        lineThreeForDefaultMessageLastPart: `shtypni 'Bisedë Live' dhe shtypni Enter. Ekipi ynë
         është këtu për t'ju ndihmuar në kohë reale.`,
        saveChanges: 'Ruaj Ndryshimet',
        discard: 'Hidh Poshtë',
        configureBotsGeneralSettings: `Konfiguro cilësimet e përgjithshme të botit tuaj`,
        minutes: 'Minuta',
        hours: 'Orë',
      },
    },
    whatsapp: {
      whatsappAutomation: 'Automatizimi i WhatsApp',
      whatsappBotSettings: 'Cilësimet e WhatsApp Bot',
      generalHeader: 'Përgjithshme',
      chatFlowsHeader: 'Fluturat e Bisedës',
      whatsappProfileHeader: 'Profili i WhatsApp',
      broadcastHeader: 'Transmetim',
      dripCampaignHeader: 'Fushata e Drip',
      widgetHeader: 'Widget',
      templatesHeader: 'Modelet',
      alertsHeader: 'Njoftimet',
      apiKeyHeader: 'Çelësi API',
      catalogHeader: 'Katalogu',
      otherConfiguration: 'Cilësimet e tjera',
      appTooltip: {
        TOOLTIP_CHAT_FLOW_TITLE:
          'Përsonalizoni modelet e rrjedhës së bisedës dhe krijoni disa rrjedha të bisedës për audiencat e ndryshme të synuara.',
      },
      alerts: {
        configureYourBotsAlertSettings: `Konfiguro cilësimet e njoftimeve të botit tuaj`,
        specifyHowYouBotWillNotify:
          'Specifikoni se si do të ju njoftojë boti juaj për lead-e të reja.',
        subject: 'Subjekti',
        emailNotification: 'Njoftimi me Email',
        emailAddresses: 'Adresat e Email-it',
        leadRevisitNotifications: 'Njoftimet e Rikthimit të Lead-it',
        whenToSendLeadInfo: 'Kur të dërgohet informacioni për lead-in',
        discard: 'Hidh Poshtë',
        saveChanges: 'Ruaj Ndryshimet',
        seeHowToUse: 'Shiko se si të përdoret',
        beginningTheFlow: 'Fillimi i Fluturimit',
        fiveMinutesLater: '5 Minuta më vonë',
        endOfFlow: 'Fundi i Fluturimit',
        placeholders: {
          enterSubjectForYourEmail: 'Vendosni Subjektin për emailin tuaj',
          typeEmailAndHitEnter: 'Shtyp emailin tuaj dhe shtyp Enter',
        },
        appTooltip: {
          TOOLTIP_SUBJECTS:
            'Përsonalizoni subjektin e njoftimeve të emailit nga boti',
          TOOLTIP_EMAIL_NOTIFICATION:
            'Aktivizo/fik njoftimin e botit në emailin tuaj për lead-et e reja',
          TOOLTIP_EMAIL_ADDRESS:
            'Jepni adresën e emailit të llogarisë ku dëshironi të merrni njoftimet me email. Mund të shtoni disa adresa email duke shtypur një dhe shtypur enter për të shtuar një tjetër.',
          TOOLTIP_LEAD_REVISIT_NOTIFICATION:
            'Aktivizo/fik njoftimin e botit në emailin tuaj nëse një përdorues i mëparshëm i identifikuar si lead ndërvepron me botin përsëri.',
        },
      },
      editProfile: {
        updateWhatsappChatBot: 'Përditëso WhatsApp Chatbot',
        businessNameIsRequired: 'Emri i Biznesit është i detyrueshëm.',
        maxLengthForBusinessName40Characters:
          'Gjatësia maksimale për Emrin e Biznesit është 40 karaktere.',
        categoryIsRequired: 'Kategoria është e detyrueshme.',
        descriptionIsRequired: 'Përshkrimi është i detyrueshëm.',
        maxLengthForDescription200Characters:
          'Gjatësia maksimale për përshkrim është 200 karaktere.',
        aboutIsRequired: 'Për biznesin është e detyrueshme.',
        maxLengthForAbout139Characters:
          'Gjatësia maksimale për rreth është 139 karaktere.',
        pleaseFillAValidBusinessEmail: 'Ju lutemi plotësoni një email të vlefshëm të biznesit.',
        businessEmailIsRequired: 'Emaili i Biznesit është i detyrueshëm.',
        websiteIsRequired: 'Website është i detyrueshëm.',
        maxLengthForWebsite40Characters:
          'Gjatësia maksimale për Website është 40 karaktere.',
        maxLengthForAddress150Characters:
          'Gjatësia maksimale për adresën është 150 karaktere.',
        cancel: 'Anulo',
        update: 'Përditëso',
        businessCategory: 'Kategoria e Biznesit',
        placeholders: {
          yourBusinessName: 'Emri i Biznesit Tuaj',
          businessDescription: 'Përshkrimi i Biznesit',
          about: 'Rreth',
          businessEmail: 'Emaili i Biznesit',
          website: 'Website (p.sh. www.shembull.com)',
          address: 'Adresa',
        },
      },
      flows: {
        chatFlows: 'Fluxet e Bisedës',
        createChatFlow: 'Krijo Flux Bisede',
        youCanCreateMultipleChatFlows:
          'Mund të krijojmë shumë fluxe bisedash nëpër kanale të ndryshme për testim A/B dhe transmetime.',
        flowName: 'Emri i Fluksit',
        nameIsRequired: 'Emri është i detyrueshëm',
        cancel: 'Anulo',
        createFlow: 'Krijo Fluks',
        importFlow: 'Importo Fluks',
        createNewFlow: 'Krijo Fluks të Ri',
        ofMessages: ' nga mesazhet',
        createdOn: 'Krijuar më',
        lastModified: 'Modifikuar për herë te fundit',
        defaultFlow: 'Fluks i Parazgjedhur',
        revisitFlow: 'Fluks për ribisedim',
        action: 'Veprimi',
        exportStatus: 'Statusi i Eksportit',
        flowExport: 'Eksporto Fluksin ',
        beforeYouStartUploadPleaseMakeSure:
          'Para se të filloni ngarkimin, sigurohuni që',
        point1: '1. Kufiri maksimal për madhësinë e skedarit është 20MB',
        point2: '2. Formati i skedarit duhet të jetë JSON',
        selectFile: 'Zgjidh Skedarin',
        seeHowToUse: 'Shiko se si të përdoret',
        download: 'Shkarko',
        available: 'I disponueshëm',
        initiated: 'Nisur',
        inProgress: 'në vijim',
        placeholders: {
          enterFlowName: 'Vendos emrin e fluksit',
        },
        appTooltip: {
          importFlowForWhatsappBot: 'Importo fluksin për botin në WhatsApp',
          dateAndTimeOfCreationOfChatFlow:
            'Data dhe ora e krijimit të fluksit të bisedës',
          dateAndTimeWhenChatFlowLastModified:
            'Data dhe ora kur u modifikua për herë te fundit fluksi i bisedës',
          TOOLTIP_CREATE_FLOW: 'Kliko për të krijuar një fluks bisede të ri',
          TOOLTIP_FLOW_NAME: 'Vendos emrin e fluksit të bisedës',
          TOOLTIP_FLOW_TABLE_NAME: 'Emri i fluksit të bisedës',
          TOOLTIP_NO_OF_MESSAGES: 'Nr. i komponenteve të mesazheve në fluksin e bisedës',
          TOOLTIP_DEFAULT_FLOW:
            'Përdor këtë kyç për të caktuar një fluks bisede si parazgjedhur, që do shërbehet për të gjithë përdoruesit e rinj.',
          TOOLTIP_REVISIT_FLOW:
            'Përdor këtë kyç për të zgjedhur një fluks bisede që do shërbehet përdoruesve kur ata ribëhen te boti yt i bisedës.',
          TOOLTIP_ACTION: 'Ndrysho ose fshij fluksin e bisedës',
        },
        modal: {
          deleteFlow: 'Fshij Fluksin',
          wantToDeleteThisFlow: 'A je i sigurt që dëshiron ta fshish këtë Fluks?',
        },
        noDataFound: {
          flows: 'Flukset',
          noFlowsAddedYet: 'Ende nuk janë shtuar fluksa!',
        },
      },
      input: {
        manageTemplates: 'Menaxho Shabllonet',
        manageYourTemplatesForMarketingAutomation:
          'Menaxho shabllonet për automatizimin e marketingut',
        syncTemplates: 'Sinkronizo Shabllonet',
        createTemplateHeader: 'Krijo Shabllon',
        title: 'Titulli',
        info: 'Informata',
        category: 'Kategoria',
        status: 'Statusi',
        action: 'Veprimi',
        shipmentUpdate: 'Përditësimi i Transportit',
        name: 'Emri',
        headerOptional: 'Koka (e dobishme)',
        bodyRequired: 'Trupi (i detyrueshëm)',
        footerOptional: 'Fundi (i dobishëm)',
        buttonsOptional: 'Butonat (e dobishëm)',
        makeUpto3Buttons: 'Krijo deri në 3 butona',
        makeUpto2ButtonsToRedirect:
          'Krijo deri në 2 butona për të ridrejtuar klientin në faqen tënde internetare',
        placeholders: {
          nameYourTemplate:
            'Emëro shabllonin tënd (përdor vijën nëntritur për të ndarë fjalët)',
          enterText: 'Vendos tekst (maksimumi 60 karaktere)',
          enterImageUrl: 'Vendos URL të imazhit',
          enterVideoUrl: 'Vendos URL të videove',
          templateMessage: 'Mesazhi i Shabllonit',
          smallFooterAtBottom: 'Fundi i vogël në fund',
          buttons: 'Butonat',
          text: 'Teksti',
          numberWithCountryCode: 'Numri me kodin e vendit',
          enterButtonText: 'Vendos tekstin e butonit (maksimumi 20 karaktere)',
        },
        appTooltip: {
          TOOLTIP_INPUT_TABLE_TITLE: 'Titulli i shabllonit në WhatsApp',
          TOOLTIP_INPUT_TABLE_INFO:
            'Informacion i detajuar i mesazheve të nisura nga biznesi',
          TOOLTIP_INPUT_TABLE_CATEGORY:
            `Lloji i mesazheve të nisura nga biznesi si takimet, kujtesat, mesazhet e kujdesit të klientit, përditësimet
             e transportit, lajmerime dhe më shumë`,
          TOOLTIP_INPUT_TABLE_STATUS:
            `Statusi i shabllonit është refuzuar ose miratuar nga WhatsApp. Shabllonet e WhatsApp duhet të miratohen
            fillimisht nga WhatsApp dhe kjo është një shërbim i pagesës.`,
          TOOLTIP_INPUT_TABLE_ACTIONS: 'Fshij shabllonin',
        },
        noDataFound: {
          templates: 'Shabllonet',
          noTemplatesCreatedYet: 'Ende nuk janë krijuar shabllone!',
        },
        modal: {
          deleteTemplate: 'Fshij Shabllonin',
          wantToDeleteThisTemplate: 'A je i sigurt që dëshiron ta fshish këtë Shabllon?',
        },
        createTemplate: {
          createTemplates: 'Krijo Shabllonet',
          createTemplatesForMarketingAutomation:
            'Krijo shabllonet tënde për automatizimin e marketingut',
          templateMeta: 'Meta e Shabllonit',
          selectLanguage: 'Zgjidh gjuhën',
          header: 'Koka',
          optional: 'E dobishme',
          samplesForHeaderContent: 'Shembuj për përmbajtjen e kokës',
          toHelpMetaReviewYourContent:
            `Për të ndihmuar në shqyrtimin e meta të përmbajtjes suaj, sigurohuni që të jepni shembuj të variablave ose medias në krye.
            Mos përfshini asnjë informacion mbi klientin.`,
          body: 'Trupi',
          addVariable: 'Shto një variabël',
          samplesForBodyContent: 'Shembuj për përmbajtjen e trupit',
          toHelpUsReviewYourContent:
            `Për të na ndihmuar në shqyrtimin e përmbajtjes suaj, sigurohuni që të jepni shembuj të variablave në trup.
            Mos përfshini asnjë informacion mbi klientin.`,
          footer: 'Fundi',
          buttons: 'Butonat',
          typeOfAction: 'Lloji i Veprimit',
          call: 'Thirje',
          phone: 'Telefoni',
          website: 'Faqja internetare',
          static: 'Statike',
          urlType: 'Lloji i URL-së',
          type: 'Lloji',
          customButton: 'Butoni i personalizuar',
          addAnotherButton: 'Shto një buton tjetër',
          preview: 'Parashiko',
          test: 'Testo',
          create: 'Krijo',
          addSampleUrl: 'Shto URL shembulli',
          toHelpMetaReviewYourMessage:
            `Për të ndihmuar në shqyrtimin e shabllonit të mesazhit tuaj, ju lutemi shtoni një shembull
             të URL-së së faqes së internetit. Mos përdorni informacionin real të klientit.`,
          placeholders: {
            enterMessageTemplateName: 'Vendos emrin e shabllonit të mesazhit',
            searchTemplateByName: 'Kërko shabllon sipas emrit',
            selectTemplate: 'Zgjidh Shabllonin',
            enterText: 'Vendos Tekstin',
            enterBody: 'Vendos Trupin',
            enterContentForVariable: 'Vendos përmbajtjen për variabël',
            enterFooter: 'Vendos Fundin',
            phone: 'Telefoni*',
            enterWebsiteUrl: 'Vendos URL-në e faqes së internetit',
          },
          bpInput: {
            name: 'Emri',
            buttonText: 'Teksti i Butonit',
            websiteUrl: 'URL-i i Faqes së Internetit',
          },
          bpDropDown: {
            selectCategory: 'Zgjidh Kategorinë',
          },
        },
        templatePreview: {
          preview: 'Parashiko',
          test: 'Testo',
        },
        templateConfig: {
          saveChanges: 'Ruaj Ndryshimet',
          discard: 'Hidh Poshtë',
          triggerChatFlowOnTemplateReply: 'Aktivizo Fluksin e Bisedës në Përgjigjen e Shabllonit',
          templateDetails: 'Detajet e Shabllonit',
          configureFlows: 'Konfiguro Fluksat',
          selectFlow: 'Zgjidh Fluksin',
          name: 'Emri',
        },
      },
      shopManagement: {
        shopManagement: 'Menaxhimi i Dyqaneve',
        manageECommerceShopFromBotPenguin: 'Menaxhoni dyqanet e tregtisë elektronike të lidhura me BotPenguin',
        comingSoon: '(Së shpejti)',
        wooCommerce: {
          createConfiguration: 'Krijo Konfigurim',
          eventConfiguration: {
            createConfiguration: 'Krijo Konfigurim',
            templateHeader: 'Header i Modeles',
            selectFile: 'Zgjidhni Skedarin',
            templateMessage: 'Mesazhi i Modeles',
            saveChanges: 'Ruaj Ndryshimet',
            bpDropDown: {
              selectEvent: 'Zgjidh Ngjarjen',
              selectTemplate: 'Zgjidh Modelet',
            },
          },
        },
      },
      whatsappProfile: {
        whatsappProfile: 'Profili i WhatsApp',
        manageYourBotProfile: 'Menaxhoni profilin tuaj të botit kur të doni.',
        allSetNoActionRequired: 'Te gjitha gati, nuk ka veprim të kërkuar!',
        congratulationsYourAccountIsLive: 'Urime! Llogaria juaj është aktive me akses të plotë',
        somethingIsWrongReactivateYourBot: 'Diçka është gabim, riaktivizoni botën tuaj!',
        itSeemsLikeYourBotIsNotWorkingProperly: 'Duket se boti juaj nuk po funksionon si duhet. Ju lutemi rivendosni botën tuaj',
        reConfigureYourBot: 'Rikonfiguroni botën tuaj',
        phoneNumberDetails: 'Detajet e Numrit të Telefonit',
        phoneNumber: 'Numri i Telefonit',
        nA: 'E Paimplementuar',
        phoneNumberId: 'ID e Numrit të Telefonit',
        wabaId: 'WABA ID',
        change: 'Ndrysho',
        accessToken: 'Access Token',
        messagingLimit: 'Kufiri i Mesazheve',
        qualityRating: 'Vlerësimi i Cilësisë',
        whatsappBusinessAccountName: 'Emri i Llogarisë së Biznesit në WhatsApp',
        whatsappPublicProfile: 'Profili Publik i WhatsApp',
        profilePicture: 'Fotografia Profil',
        aboutText: 'Rreth Teksti',
        address: 'Adresa',
        description: 'Përshkrimi',
        email: 'Email',
        websitePrimary: 'Website (Primar)',
        websiteSecondary: 'Website (Sekondar)',
        businessVertical: 'Lloji i Biznesit',
        editProfile: 'Ndrysho Profilin',
        thisIsABusinessAccount: 'Ky është një llogari biznesi',
        aboutAndPhoneNumber: 'Rreth dhe Numri i Telefonit',
        yourTrialAccountIsLive: 'Urime! Llogaria juaj e provës është aktive me akses të plotë në numrin tuaj të verifikuar',
        updateWithNewAccessToken: 'Përditëso me AccessToken e ri',
      },
      widgets: {
        manageWidgets: 'Menaxho Widgets',
        widgetsAreRoutingTools: 'Widgets janë mjetet e drejtuara për të shtuar përdorimin e botit',
        needHelp: 'Nevojë për Ndihmë?',
        wantToMakeChanges: 'Dëshironi të bëni ndryshime?',
        prePopulatedMessage: 'Mesazhi i parapërcaktuar',
        discard: 'Hidh Poshtë',
        updateWidget: 'Përditëso Widgetin',
        hiThere: 'Tungjatjeta ',
        seeHowToUse: 'Shiko si të përdoret',
        editIcon: 'Ndrysho Ikonen',
        editPrePopulatedMessage: 'Ndrysho Mesazhin e parapërcaktuar',
        small: 'Vogël',
        medium: 'Mesatare',
        large: 'E madhe',
        leftMiddle: 'Majtas-Mes',
        rightMiddle: 'Djathtas-Mes',
        leftBottom: 'Majtas-Fund',
        rightBottom: 'Djathtas-Fund',
        chatBotIcon: 'Ikonë ChatBot',
        link: 'Link',
        qrcode: 'Kodi QR',
        copyChatBotCode: 'Kopjo Kodin e ChatBot',
        copyWALink: 'Kopjo WA Linkun',
        downloadQrCode: 'Shkarko Kodin QR',
        installChatBotIconOnYourWebsite: 'Instalo ikonën e chatbot në faqen tënde',
        shareWhereEverYouWantRedirectUsersTo: 'Ndaje kudo që dëshiron dhe ridrejto përdoruesit te boti yt në WhatsApp me një klikim',
        copyAndAddInYourWebsiteHeaderFile: 'Kopjo dhe shto në skedarin header të faqes tuaj',
        copyLinkAndStartSharing: 'Kopjo linkun dhe fillo ndarjen!',
        downloadQrCodeAndStartSharing: 'Shkarko kodin QR dhe fillo ndarjen!',
        addCodeAndDeployNewCodeAndDone: 'Shto kodin, zbatoni kodin e ri dhe e keni përfunduar!',
        wantToLearnHowToUseIt: 'Dëshiron të mësosh se si ta përdorësh?',
        placeholders: {
          enterWhatsappNumber: 'Vendosni numrin e WhatsApp',
          updateYourMessageHere: 'Përditësoni mesazhin tuaj këtu...',
        },
        bpDropDown: {
          selectIcons: 'Zgjidh Ikona',
          iconSize: 'Madhësia e Ikonës',
          iconPlacement: 'Vendosja e Ikonës',
        },
        bpInput: {
          whatsappNumber: 'Numri i WhatsApp',
        },
      },
      catalog: {
        createCatalog: 'Krijo Katalog',
        createProductCatalogOnTheMetaCommerceManagerOrLinkItWithShopify:
          'Krijo katalog produktet në Meta Commerce Manager ose lidhe ato me Shopify',
        useYourMetaCommerceManagertoManageCatalogs:
          'Përdor Meta Commerce Manager-in tënd për të menaxhuar katalogjet',
        connectCatalogToWhatsAppAccount:
          'Lidhni Katalogun me llogarinë WhatsApp',
        connectYourCatalogsToWhatsAppAccountUsingYourWhatsAppManager:
          'Lidhni katalogjet tuaja me llogarinë WhatsApp duke përdorur Menaxherin tuaj të WhatsApp',
        useYourMetaWhatsAppManagerToConnectCatalogsAndUsethemWithBotPenguin:
          'Përdor Menaxherin tënd të Meta WhatsApp për të lidhur katalogjet dhe përdorini ato me BotPenguin',
        goToMeta: 'Shko në Meta',
        goToShopify: 'Shko në Shopify',
        next: 'Pasues',
        back: 'Prapa',
        setupCatalog: 'Rregullo Katalogun',
        completeAllTheStepsToEnableCatalogMessages:
          'Plotësoni të gjitha hapat për të aktivizuar mesazhet e katalogut',
      },
      generalSetting: {
        sendInactivityMessage: 'Mesazh për mosaktivitetin e përdoruesit',
        sessionTimeOutInHours: 'Timeout i seancës në orë',
        enterSessionTimeOutWindowInHours:
          'Vendosni dritaren e timeout të seancës në orë',
        sessionTimeOutInHoursTooltip: `Vendosni kohën pas së cilës biseda do të ketë timeout automatik për shkak të mosaktivitetit.
         Chatflow do të rinisë nëse përdoruesi dërgon ndonjë mesazh pas timeout të seancës`,
        restartChatFlowTriggers: 'Rihap Fluturat e Bisedës',
        enterKeyWordsToRestartChatAndhitEnter:
          'Vendosni fjalë kyçe për të rihapur bisedën dhe shtypni Enter',
        restartChatFlowTriggersTooltip: `Specifikoni këtu fjalë kyçe që, kur vendosen nga përdoruesi dhe dërgohen, do të nisin një
         rihapje të rrjedhës së bisedës. Kjo lejon përdoruesit të rihapin rrjedhën e bisedës në çdo moment.
          Shtypni Enter pasi të shtoni çdo fjalë kyçe për të shtuar disa fjalë kyçe.`,
        liveChatTriggers: 'Përforcuesit e Bisedës Live ',
        enterKeyWordsToTriggerLiveChatAndhitEnter:
          'Vendosni fjalë kyçe për të nxitur bisedën live dhe shtypni Enter',
        liveChatTriggersTooltip: `Përcaktoni fjalë kyçe që, kur vendosen nga përdoruesi dhe dërgohen, do të iniciojnë një kalim nga
        biseda automatike në bisedë live. Kjo është e dobishme kur përdoruesit kanë nevojë për ndihmë nga një
          agent live. Shtypni Enter pasi të shtoni çdo fjalë kyçe për të shtuar disa fjalë kyçe.`,
        messageAfterAutomatedFlowCompleted:
          'Mesazhi pas përfundimit të rrjedhës automatike',
        enterYourMessage: 'Vendosni mesazhin tuaj',
        messageAfterAutomatedFlowCompletedTooltip: `Vendosni një mesazh që do të shfaqet përdoruesit pasi ata kanë përfunduar rrjedhën
         e bisedës automatike, por seanca nuk ka skaduar.`,
        restart: 'Rihap',
        liveChat: 'Bisedë Live',
        lineOneForDefaultMessage:
          'Nëse keni më shumë pyetje ose nevojë për ndihmë, këtu është çfarë mund të bëni më tej:',
        to: 'Te',
        restartTheChat: 'rihap bisedën',
        simpleTypeRestartAndHitEnter: `thjesht shkruani 'Rihap' dhe shtypni Enter. Kjo do t'ju kthejë në fillim të rrjedhës së bisedës sonë.`,
        lineThreeForDefaultMessagePartOne: `Nëse dëshironi të flisni me një`,
        liveAgent: `agjent live,`,
        lineThreeForDefaultMessageLastPart: `shkruani 'Bisedë Live' dhe shtypni Enter. Ekipi ynë është këtu për t'ju ndihmuar në kohë reale.`,
        saveChanges: 'Ruaj Ndryshimet',
        discard: 'Hidh Poshtë',
        configureBotsGeneralSettings: `Konfiguroni parametrat e përgjithshëm të botit tuaj`,
        minutes: 'Minuta',
        hours: 'Orë',
      },

    },
    activateWhatsAppBot: {
      justAStepAway: 'Vetëm një hap larg',
      seeHowToUse: 'Shiko se si të përdoret',
      testWhatsAppTrialBot: 'Testo botën tënde provë në WhatsApp',
      sendMessage: 'Dërgo Mesazh',
      sendWhatsAppMessageOn: 'Dërgo një mesazh në WhatsApp në ',
      bySavingInYourContact: 'duke e ruajtur në kontaktet tuaja dhe mesazhi duhet të fillojë me ',
      connect: 'Lidhu',
      or: 'OSE',
      scanQRCode: 'Skano kodin QR',
      yourPhoneWillOpen: `Telefoni juaj do të hapë një mesazh paraprak për tu dërguar tek numri ynë i provës.
      Shtypni \'Dërgo\' në WhatsApp`,
      sendVerificationCode: 'Dërgo kodin e verifikimit',
      copyAndEnterCode: 'Kopjo dhe fut kodin e 6 shifrorëve',
      shareWhereYouWant: 'Ndani kudo që dëshironi dhe ridrejtoni përdoruesit tuaj te boti në WhatsApp në një klikim',
      youShouldHaveReceived: 'Duhet të keni marrë një kod me 6 shifra në numrin tuaj WhatsApp',
      EnterYourPhoneNumber: 'Vendosni numrin tuaj të telefonit',
      send: 'Dërgo',
      sixDigitCode: 'Vendosni kodin me 6 shifra',
      pleaseNote: `Ju lutemi vini re: Kodi i verifikimit me 6 shifra mund të zgjasë deri në 3 minuta.
      Ju lutemi prisni para se ta dërgoni përsëri.`,
      resendVerificationCode: 'Ridërgo kodin e verifikimit',
      verify: 'Verifikoni',
      providePhoneNumber: 'Ju lutemi sigurohuni që keni dhënë numrin që dëshironi të përdorni për testim',
      demoBotisReady: 'Super! Boti juaj demo është gati për përdorim',
      placeHolder: {
        phone: 'Vendosni numrin tuaj të telefonit',
        code: 'Vendosni kodin e verifikimit',
      },
    },
  },
  integrations: {
    thirdPartyAppsIntegration: 'Integrimi i Aplikacioneve të Partive të Treta',
    thirdPartyApps: 'Aplikacionet e Partive të Treta',
    customApps: 'Aplikacionet e Personalizuara',
    preview: 'Parashiko',
    test: 'Testo',
    install: 'Instalo',
    appTooltip: {
      clickToInstallYourBotToSelectedPlatform:
        'Kliko për të instaluar botin tënd në platformën e zgjedhur',
      TOOLTIP_MY_INTEGRATION_TITLE:
        'Integro aplikacionet e tua të krijuara me botin tënd',
      TOOLTIP_ALL_INTEGRATION_TITLE:
        'Lidh botin tënd me aplikacionet/CRM-të e disponueshëm të partive të treta',
    },
    allIntegration: {
      list: {
        thirdPartyAppsIntegrations: 'Integrime të Aplikacioneve të Palëve të Treta',
        integrateYourBotWithListedCrms: 'Integroni botin tuaj me një nga Aplikacionet/CRMs e listuara.',
        help: 'Ndihmë',
        name: 'Emri',
        status: 'Statusi',
        action: 'Veprimi',
        chatGpt: 'ChatGPT',
        addOn: 'Shtesë',
        purchased: 'Blerë',
        readyToRideGptWave: 'Gati për të shfrytëzuar valuën GPT? Integro tani.',
        purchase: 'Blerje',
        notConnected: 'S\'është i Lidhur',
        integrated: 'I Integruar',
        configure: 'Konfiguro',
        connected: 'I Lidhur',
        edit: 'Ndrysho',
        connect: 'Lidhu',
        requestYourIntegration: 'Kërko integrimin tënd',
        toRequestNewIntegration: `Për të kërkuar një integrim të ri, ju lutemi vendosni detajet e mëposhtme dhe më
        pas ne do të kthehemi te ju.`,
        emailId: 'Email ID',
        integrationName: 'Emri i Integrimi',
        contactNumber: 'Numri i Kontaktit',
        howSoonYouWantToAddThisIntegration: 'Sa shpejt dëshironi të shtoni këtë Integrim',
        sendRequest: 'Dërgo Kërkesën',
        cancel: 'Anulo',
        requestSent: 'Kërkesa është Dërguar!',
        yourRequestSuccessfullySent: 'Kërkesa juaj për integrim të ri është dërguar me sukses.',
        goBack: 'Kthehu Prapa',
        disconnect: 'Ç\'lidhje',
        OopsIntegrationAreNotAvailable: 'Oops! Integrimet nuk janë në dispozicion në ',
        pleaseUpgradeTo: ' Ju lutemi të azhurnoni në ',
        planForIntegration: ' për integrimet.',

        placeholders: {
          searchIntegrationByName: 'Kërko integrim sipas emrit',
          enterTeamMemberName: 'Vendos emrin e anëtarit të grupit',
          enterEmailId: 'Vendos ID-në e Email-it',
          enterIntegrationName: 'Vendos një emër integrimi',
          searchCountry: 'Kërko Shtetin',
          enterContactNumber: 'Vendos Numrin e Kontaktit',
          addComment: 'Shto Koment',
        },
        noDataFound: {
          integrations: 'Integrimet',
          noIntegrationsFound: 'Nuk u gjet asnjë integrim!',
        },
        appTooltip: {
          nameOfAppOrCrm: 'Emri i Aplikacionit/CRM',
          statusAsConnectedOrNotConnected: 'Statusi si i lidhur / s\'është i lidhur',
          clickToConnectToAppOrCrm: 'Klikoni për të lidhur Aplikacionin/CRM',
        },
        feedbackModal: {
          submit: 'Dorëzo',
        },
      },
      providers: {
        pabbly: {
          newLeadHooks: 'Nyje të Reja të Kreut',
          newMessageHooks: 'Nyje të Reja të Mesazhit',
          addParameters: '',
          update: 'Përditëso',
          connect: 'Lidhu',
          botId: 'Id e Bots',
          toolTip: {
            copyBotId: `Merr id-në e botit tuaj për të integruar përsosmërisht Pabbly me ${brand} për veprimet automatike në Pabbly`,
          },
          placeholders: {
            enterYourPabblyWebhookUrl: 'Vendos URL-në tënde të Pabbly Webhook',
          },
        },
        agileCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses Integrimin. Tani, mund ta konfiguroni atë.`,
          agileCrmDomain: 'Domeni i Agile CRM',
          nameIsRequired: 'Emri është i detyrueshëm',
          emailAddress: 'Adresa e Email-it',
          apiToken: 'API Token',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameter: ' Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidhje',
          placeholders: {
            exampleSite: 'https://kompania.agilecrm.com',
            exampleEmail: 'shembull@kompania.zgjatje',
            enterTokenHere: 'Vendos token këtu',
          },
        },
        appTivo: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses Integrimin. Tani, mund ta konfiguroni atë.`,
          apiKey: 'Çelësi i API-së',
          accessKey: 'Çelësi i Hyrjes',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: ' Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidhje',
          placeholders: {
            enterApiKeyHere: 'Vendos Çelësin e API-së Këtu',
            enterAccessKeyHere: 'Vendos Çelësin e Hyrjes Këtu',
          },
        },
        autoPilot: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses Integrimin. Tani, mund ta konfiguroni atë.`,
          apiToken: 'Token i API-së',
          nameIsRequired: 'Emri është i detyrueshëm',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: ' Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidhje',
          placeholders: {
            enterApiToken: 'Vendos Tokenin e API-së Këtu',
          },
        },
        bitrixCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses Integrimin. Tani, mund ta konfiguroni atë.`,
          nameColon: 'Emri:',
          inboundWebhookUrl: 'URL hyrës i Webhook',
          nameIsRequired: 'Emri është i detyrueshëm',
          leadTitle: 'Titulli i Drejtpërdrejtë',
          source: 'Burimi',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: ' Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidhje',
          placeholders: {
            enterInboundWebhookUrl: 'Vendos URL-in hyrës të webhook...',
            enterTitle: 'Vendos titullin',
            enterSource: 'Vendos burimin',
          },
        },
        calendarHeroCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses Integrimin. Tani, mund ta konfiguroni atë.`,
          apiToken: 'Token i API-së',
          connect: 'Lidhu',
          questionColon: 'Pyetje:',
          addParameters: ' Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidhje',
          placeholders: {
            enterTokenHere: 'Vendos Tokenin Këtu',
          },
        },
        capsuleCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiToken: 'API Token',
          nameIsRequired: 'Emri është i detyrueshëm',
          testLead: 'Testo Drejtimin',
          connect: 'Lidhu',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterApiToken: 'Vendosni API Token',
          },
        },
        chakraCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiToken: 'API Token',
          testLead: 'Testo Drejtimin',
          connect: 'Lidhu',
          selectTheQuestion: 'Zgjidhni pyetjen për të cilën dëshironi të dërgoni përgjigjen e përdoruesit si vlerë',
          mapWith: 'lidh me',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterApiToken: 'Vendosni API Token',
            attributes: 'Atribute (çelës)',
            vlerat: 'vlerat',
          },
        },
        chatGpt: {
          chatGptApiKey: 'ChatGPT (Open AI) Çelësi i API',
          chatGpt: 'ChatGPT (Open AI)',
          gpt3: 'GPT-3.5 (Çmim më i ulët, Saktësi mesatare)',
          gpt4: 'GPT-4 (Çmim më i lartë, Saktësi më e lartë)',
          gptAssistant: 'Asistentët Beta* (Çmim Premium, Saktësi e Lartë)',
          readyToRideWave: 'Gati për të udhëtuar në valu GPT? Integro tani.',
          doNotHaveAnyApiKeyNeedHelp: `Nuk keni asnjë çelë API, Nevojë për Ndihmë?`,
          authenticate: 'Autentikimi',
          nowYouCanAccessChatGpt: 'Tani mund të hyni në komponentin Chat GPT në ndërtuesin e rrjedhës së bisedës',
          paymentSuccessful: 'Pagesa e suksesshme!',
          paymentHasBeenCompletedSuccessfully: 'Pagesa është kryer me sukses. Jeni gati të trajtoni botin tuaj',
          cancel: 'Anulo',
          trainNow: 'Trajno Tani',
          paymentInProgress: 'Pagesa në Progres...',
          apiKey: 'Çelësi i API për ChatGPT',
          model: 'Modeli',
          integrateWithChatGPT: 'Integro me ChatGPT',
          updateKey: 'Përditëso Çelësin',
          connect: 'Lidhu',
          update: 'Përditëso',
          placeholders: {
            chatGptApiKey: 'ChatGPT (Open AI) Çelësi i API',
          },
        },
        closeCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiToken: 'API Token',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          leadId: 'ID e Drejtimi',
          selectLeadId: 'Zgjidhni ID e Drejtimi',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterTokenHere: 'Vendosni këtu një fjalëkalim',
          },
        },
        copperCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          emailAddress: 'Adresa e Email-it',
          leadTitle: 'Titulli i Drejtimin',
          apiToken: 'API Token',
          nameIsRequired: 'Emri është i detyrueshëm',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            exampleEmail: 'shembull@kompania.shprehje',
            enterYourLeadTitle: 'Vendosni Titullin e Drejtimin tuaj',
            enterTokenHere: 'Vendosni një fjalëkalim këtu',
          },
        },
        dripCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          dripCrmAccountId: 'ID e Llogarisë Drip CRM',
          apiToken: 'API Token',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterAccountIdHere: 'Vendosni ID e Llogarisë këtu',
            enterYourTokenHere: 'Vendosni fjalëkalimin tuaj këtu',
          },
        },
        elevioCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apikey: 'Çelësi i API',
          accessToken: 'Fjalëkalimi i Aksesit',
          connect: 'Lidhu',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          selectParameter: 'Zgjidh Parametrin',
          disconnect: 'Ç\'lidh',
          update: 'Përditëso',
          save: 'Ruaj',
          placeholders: {
            enterApiKeyHere: 'Vendosni Çelësin e API këtu',
            enterTokenHere: 'Vendosni Fjalëkalimin e Aksesit këtu',
          },
        },
        engageBay: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiKey: 'Çelësi i API',
          nameIsRequired: 'Emri është i detyrueshëm',
          connect: 'Lidhu',
          questionColon: 'Pyetje:',
          testLead: 'Testo Drejtimin',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterApiToken: 'Vendosni Çelësin e API këtu',
          },
        },
        extraEdge: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          authToken: 'Çelësi i Auth',
          source: 'Burimi',
          connect: 'Lidhu',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterAuthTokenHere: 'Vendosni Çelësin e Auth këtu',
            enterSourceHere: 'Vendosni Burimin këtu',
          },
        },
        facebookPixel: {
          facebookPixel: 'Facebook Pixel',
          getInsight: `Merrni shkëlqimin që kthen biznesin tuaj në një ndërmarrje me integrimin e Google Analytics të BotPenguin`,
          pixelId: 'Id e Facebook Pixel',
          connect: 'Lidhu',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterYourId: 'Vendosni Id e Facebook Pixel',
          },
        },
        firmao: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          companyName: 'Emri i Kompanisë',
          emailAddress: 'Adresa e Email-it',
          password: 'Fjalëkalimi',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapsWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterCompanyName: 'Vendosni Emrin e Kompanisë',
            enterEmailAddress: 'Vendosni adresën e email-it',
            enterPassword: 'Vendosni Fjalëkalimin',
          },
        },
        firstPromoterCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiKey: 'Çelësi i API',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterApiKeyHere: 'Vendosni Çelësin e API këtu',
          },
        },
        flowlu: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          flowluDomain: 'Domeni i Flowlu',
          apiToken: 'API Token',
          title: 'Titulli',
          connect: 'Lidhu',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            exampleDomain: 'https://kompania.juaj.flowlu.com',
            enterTokenHere: 'Vendosni Token këtu',
            enterYourLeadTitle: 'Vendosni Titullin e Drejtimin tuaj',
          },
        },
        freshdeskCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          freshdeskDomain: 'Domeni i Freshdesk',
          apiToken: 'API Token',
          nameIsRequired: 'Emri është i detyrueshëm',
          connect: 'Lidhu',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            exampleDomain: 'https://nëndomena.juaj.freshdesk.com',
            enterTokenHere: 'Vendosni Token këtu',
          },
        },
        freshworksCrm: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          freshworkCrmDomain: 'Domeni i Freshwork CRM',
          apiToken: 'API Token',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            exampleDomain: 'https://kompania.juaj.myfreshworks.com',
            enterToken: 'Vendosni Token këtu',
          },
        },
        frontApp: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiToken: 'API Token',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          mapWith: 'lidh me',
          select: 'Zgjidh',
          update: 'Përditëso',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterApiToken: 'Vendosni API Token këtu',
          },
        },
        getResponseCrm: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiKey: 'Çelësi i API',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          campaignList: 'Lista e Fushatave',
          selectCampaign: 'Zgjidh Fushatën',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterTokenHere: 'Vendosni Token këtu',
          },
        },
        googleAnalytics: {
          googleAnalytics: 'Google Analytics',
          getInsights: `Merrni shkëlqimin që kthen biznesin tuaj në një ndërmarrje me integrimin e Google Analytics të BotPenguin`,
          measurementId: 'Id e Matjes',
          connect: 'Lidhu',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterYourId: 'Vendosni Id tuaj',
          },
        },
        googleCalendar: {
          testLead: 'Testo Drejtimin',
          name: 'Emri:',
          email: 'Email:',
          appointmentSummary: 'Pasqyra e Takimit',
          appointmentDescription: 'Përshkrimi i Takimit',
          addParameters: 'Shto Parametrat',
          questionColon: 'Pyetje:',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          pause: 'Ndal',
          resume: 'Vazhdo',
          disconnect: 'Ç\'lidh',
          reconnect: 'Rilidhu',
        },
        googleContacts: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          name: 'Emri :',
          email: 'Email : ',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
        },
        googleRedirect: {},
        googleSheet: {
          testLead: 'Testo Drejtimin',
          title: 'Titulli',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          update: 'Përditëso',
          save: 'Ruaj',
          pause: 'Ndal',
          resume: 'Vazhdo',
          disconnect: 'Ç\'lidh',
          reconnect: 'Rilidhu',
          placeholders: {
            mappingValues: 'Vlerat e Mapimit',
          },
        },
        googleTask: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          name: 'Emri:',
          email: 'Email:',
          taskList: 'Lista e Detyrave',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          pause: 'Ndal',
          resume: 'Vazhdo',
          disconnect: 'Ç\'lidh',
          reconnect: 'Rilidhu',
        },
        grooveHq: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiToken: 'API Token',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          select: 'Zgjidh',
          addParameters: 'Shto Parametrat',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterTokenHere: 'Vendosni Token këtu',
          },
        },
        helpCrunchCrm: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiKey: 'Çelësi i API',
          connect: 'Lidhu',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterApiHere: 'Vendosni API këtu',
          },
        },
        helpDeskCrm: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          testLead: 'Testo Drejtimin',
          accountId: 'Id e Llogarisë',
          accessToken: 'Access Token',
          connect: 'Lidhu',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterAccountIdHere: 'Vendosni Id e Llogarisë këtu',
            enterAccessTokenHere: 'Vendosni Access Token këtu',
          },
        },
        helpDocsCrm: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiToken: 'Çelësi i API',
          connect: 'Lidhu',
          questionColon: 'Pyetje:',
          testLead: 'Testo Drejtimin',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterTokenHere: 'Vendosni Token këtu',
          },
        },
        helpLink: {
          help: 'Ndihmë',
        },
        helpRaceCrm: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          helpRaceCrmDomain: 'Domeni i Helprace CRM',
          emailAddress: 'Adresa e Email-it',
          apiToken: 'Çelësi i API',
          connect: 'Lidhu',
          update: 'Përditëso',
          placeholders: {
            exampleDomain: 'https://kompania.helprace.com',
            exampleEmail: 'shembull@kompania.extension',
            token: 'Token',
          },
        },
        helpShiftCrm: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          domainName: 'Emri i Domenit',
          apiKey: 'Çelësi i API',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterTokenHere: 'Vendosni Token këtu',
          },
        },
        hubspotCrm: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiToken: 'Çelësi i API',
          nameIsRequired: 'Emri është i detyrueshëm',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          selectTheQuestion: 'Zgjidhni pyetjen për të cilën doni të dërgoni përgjigjen e përdoruesit si vlerë',
          placeholders: {
            enterApiToken: 'Vendosni API Token këtu',
            values: 'vlera',
          },
        },
        infobipCrm: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiKey: 'Çelësi i API',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterApiHere: 'Vendosni API këtu',
          },
        },
        insightlyCrm: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiToken: 'Çelësi i API',
          nameIsRequired: 'Emri është i detyrueshëm',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterApiToken: 'Vendosni API Token këtu',
          },
        },
        jiraCrm: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiToken: 'Çelësi i API',
          emailAddress: 'Adresa e Email-it',
          apiUrl: 'URL e API',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          selectProjectName: 'Zgjidh Emrin e Projektit',
          selectIssueType: 'Zgjidh Tipin e Çështjes',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapsWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterTokenHere: 'Vendosni Token këtu',
            enterEmailAddress: 'Vendosni adresën e email-it',
            exampleUrl: 'https://shembull.atlassian.net',
          },
        },
        jogetCrm: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiUrl: 'URL e API',
          nameIsRequired: 'Emri është i detyrueshëm',
          apiKey: 'Çelësi i API',
          apiId: 'ID e API',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          mapWith: 'lidh me',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          selectTheQuestion: 'Zgjidhni pyetjen për të cilën doni të dërgoni përgjigjen e përdoruesit si vlerë',
          placeholders: {
            enterApiUrl: 'Vendosni URL e API këtu',
            enterApiKey: 'Vendosni Çelësin e API këtu',
            enterApiId: 'Vendosni ID e API këtu',
            attributes: 'Atribute (çelës)',
            values: 'vlera',
          },
        },
        karmaCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses Integrimin. Tani, mund ta konfiguroni atë.`,
          apiKey: 'Çelësi i API-së',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: ' Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidhje',
          placeholders: {
            enterTokenHere: 'Vendos Tokenin Këtu',
          },
        },
        kylasCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses Integrimin. Tani, mund ta konfiguroni atë.`,
          apiToken: 'Token i API-së',
          nameIsRequired: 'Emri është i detyrueshëm',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: ' Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidhje',
          placeholders: {
            enterApiToken: 'Vendos Tokenin e API-së Këtu',
          },
        },
        leadSquared: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses Integrimin. Tani, mund ta konfiguroni atë.`,
          accessKey: 'Çelësi i Hyrjes',
          secretKey: 'Çelësi Sekret',
          connect: 'Lidhu',
          apiLogs: 'API Log',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: ' Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          udpate: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidhje',
          filterApplied: 'filtruar',
          retry: 'Përsërit',
          back: 'Mbrapa',
          filterYourLeads: 'Filtro drejtimet tuaja',
          filterOn: 'Filtro në',
          filterBy: 'Filtro sipas ',
          discard: 'Heq dorë',
          applyFilter: 'Apliko Filtrin',
          loadMore: 'Ngarko më shumë',
          placeholders: {
            enterAccessKeyHere: 'Vendos Çelësin e Hyrjes Këtu',
            enterSecretKeyHere: 'Vendos Çelësin Sekret Këtu',
            attributes: 'Atribute (çelës)',
            values: 'vlerat',
          },
          appTooltip: {
            filterDataBasedOnResponse: 'Filtro të dhënat bazuar në përgjigjen',
          },
        },
        liveAgentCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses Integrimin. Tani, mund ta konfiguroni atë.`,
          apiKey: 'Çelësi i API-së',
          apiUrl: 'URL-i i API-së',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: ' Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidhje',
          placeholders: {
            enterApiHere: 'Vendos API këtu',
            exampleUrl: 'https://emriiKompanise.ladesk.com',
          },
        },
        microsoftTeams: {
          downloadPackage: 'Shkarko paketën e aplikacionit Microsoft Teams',
          downloadApp: 'Shkarko Aplikacionin',
          wantToLearnHowToUploadIt: 'Dëshironi të mësoni si ta ngarkoni atë?',
          needHelp: 'Keni nevojë për Ndihmë?',
        },
        moengageUser: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses Integrimin. Tani, mund ta konfiguroni atë.`,
          apiUrl: 'URL-i i API-së',
          appId: 'ID e Aplikacionit',
          nameIsRequired: 'ID e Aplikacionit është e detyrueshme',
          dataApiKey: 'Çelësi i API-së për të dhënat',
          dataApiKeyIsRequired: 'Çelësi i API-së për të dhënat është i detyrueshëm',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          addParameters: ' Shto Parametrat',
          mapWith: 'lidh me',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidhje',
          selectTheQuestion: 'Zgjidhni pyetjen për të cilën dëshironi të dërgoni përgjigjen e përdoruesit si vlerë',
          placeholders: {
            enterApiUrl: 'Vendos URL-in e API-së këtu',
            enterAppId: 'Vendos ID e Aplikacionit këtu',
            enterDataApiKey: 'Vendos Çelësin e API-së për të dhënat këtu',
            attributes: 'Atribute (çelës)',
            pressForMappingQuestion: 'Shtypni / Për Pyetje Lidhëse',
          },
        },
        nethuntCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses Integrimin. Tani, mund ta konfiguroni atë.`,
          emailAddress: 'Adresa e Email-it',
          apiKey: 'Çelësi i API-së',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          leadId: 'ID e Drejtpërdrejtë',
          selectLeadId: 'Zgjidh ID e Drejtpërdrejtë',
          questionColon: 'Pyetje:',
          addParameters: ' Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidhje',
          placeholders: {
            enterEmailHere: 'Vendos Email-in Këtu',
            enterApiKeyHere: 'Vendos Çelësin e API-së Këtu',
          },
        },
        nimbleCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses Integrimin. Tani, mund ta konfiguroni atë.`,
          apiKey: 'Çelësi i API-së',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: ' Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidhje',
          placeholders: {
            enterApiToken: 'Vendos Tokenin e API-së Këtu',
          },
        },
        noCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          noCrmDomain: 'Domeni NoCRM',
          leadTitle: 'Titulli i Drejtorit',
          titleIsRequired: 'Titulli është i detyrueshëm',
          token: 'Token',
          tokenIsRequired: 'Token është i detyrueshëm',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            exampleDomain: 'https://DOMAIN_YOU.ndocrm.io',
            enterYourLeadTitle: 'Vendosni titullin tuaj të drejtorit',
            enterYourToken: 'Vendosni tokenin tuaj',
          },
        },
        nutshellCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          emailAddress: 'Adresa e Email-it',
          apiKey: 'Çelësi i API',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterApiToken: 'Vendosni Çelësin e API këtu',
          },
        },
        onpipelineCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          secretToken: 'Token Sekret',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterTokenHere: 'Vendosni Token këtu',
          },
        },
        ontraportCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          appId: 'ID e Aplikacionit',
          appIdIsRequired: 'ID e Aplikacionit është e detyrueshme',
          apiKey: 'Çelësi i API',
          apiKeyIsRequired: 'Çelësi i API është i detyrueshëm',
          connect: 'Lidhu',
          update: 'Përditëso',
          disconnect: 'Ç\'lidh',
          placeholders: {
            appId: 'ID e Aplikacionit',
            apiKey: 'Çelësi i API',
          },
        },
        outlook: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          clientId: 'ID e Klientit',
          connect: 'Lidhu',
          clientSecret: 'Sekreti i Klientit',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          save: 'Ruaj',
          update: 'Përditëso',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterClientIdHere: 'Vendosni ID e Klientit këtu',
            enterClientSecretHere: 'Vendosni Sekretin e Klientit këtu',
          },
        },
        pipedriverCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          pipedriverDomain: 'Domeni i Pipedriver',
          domainIsRequired: 'Domeni është i detyrueshëm',
          apiToken: 'Token i API',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            exampleDomain: 'https://kompania.pipedrive.com',
            enterTokenHere: 'Vendosni token këtu',
          },
        },
        pipeline: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiKey: 'Çelësi i API',
          apiKeyIsRequired: 'Çelësi i API është i detyrueshëm',
          appKey: 'Çelësi i Aplikacionit',
          appKeyIsRequired: 'Çelësi i Aplikacionit është i detyrueshëm',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterApiKey: 'Vendosni Çelësin e API këtu',
            enterAppKey: 'Vendosni Çelësin e Aplikacionit këtu',
          },
        },
        plivoSmsBot: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          authId: 'ID e Autorizimit',
          authToken: 'Tokeni i Autorizimit',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterTokenHere: 'Vendosni Token këtu',
          },
        },
        recurlyCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiKey: 'Çelësi i API',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterApiHere: 'Vendosni API këtu',
          },
        },
        salesfareCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiKey: 'Çelësi i API',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterApiKey: 'Vendosni çelësin e API këtu',
          },
        },
        salesforce: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          domain: 'Domeni',
          clientId: 'ID e Klientit',
          clientSecret: 'Sekreti i Klientit',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterDomainHere: 'Vendosni Domenin këtu',
            enterClientIdHere: 'Vendosni ID e Klientit këtu',
            enterClientSecretHere: 'Vendosni Sekretin e Klientit këtu',
          },
        },
        sendInBlueCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiKey: 'Çelësi i API',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          addEventsAndTemplates: 'Shto Evente dhe Shabllone:',
          add: 'Shto',
          question: 'Pyetje',
          reply: 'Përgjigjje',
          requestBody: 'Trupi i Kërkesës',
          validateJson: 'Valido JSON',
          emailAddress: 'Adresa e Email-it',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          selectTheQuestion: 'Zgjidhni pyetjen për të cilën doni të dërgoni përgjigjen e përdoruesit si vlerë',
          placeholders: {
            enterApiHere: 'Vendosni API këtu',
            enterTemplateId: 'Vendosni ID e Shabllonit',
            typeYourJsonCodeHere: 'Shkruani kodin tuaj JSON këtu',
          },
          appTooltip: {
            typeYourJsonCode: 'Shkruani kodin tuaj JSON',
            clickToValidateJsonCode: 'Klikoni për të validuar kodin JSON',
          },
        },
        shipwayCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          userName: 'Emri i Përdoruesit',
          licenseKey: 'Çelësi i Licencës',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterNameHere: 'Vendosni emrin këtu',
            enterKeyHere: 'Vendosni çelësin këtu',
          },
        },
        supportBeeCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiToken: 'Tokeni i API',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterTokenHere: 'Vendosni Tokenin këtu',
          },
        },
        simplybook: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          company: 'Kompania',
          loginId: 'ID e Hyrjes',
          password: 'Fjalëkalimi',
          testLead: 'Testo Drejtimin',
          connect: 'Lidhu',
          selectTheQuestion: 'Zgjidhni pyetjen për të cilën doni të dërgoni përgjigjen e përdoruesit si vlerë',
          mapWith: 'lidh me',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          selectParameter: 'Zgjidh Parametrin',
          placeholders: {
            enterCompanyHere: 'Vendosni Emrin e Kompanisë këtu',
            enterLoginIdHere: 'Vendosni ID e Hyrjes këtu',
            enterPasswordHere: 'Vendosni Fjalëkalimin këtu',
            values: 'vlerat',
          },
        },
        twilio: {
          description: 'Përdorni Twilio për të bërë thirrje zë të qarta klientëve tuaj në çdo kohë.',
          accountSid: 'SID i Llogarisë',
          phoneNumber: 'Numri i Telefonit',
          twiMlSid: 'SID i Aplikacionit TwiML',
          apiKey: 'Çelësi i API ',
          apiSecret: 'Sekreti i API ',
          apiUrl: 'URL i Aplikacionit (POST)',
          required: 'i nevojshëm',
          accountSidRequired: 'SID i Llogarisë është ',
          phoneNumberRequired: 'Numri i Telefonit është ',
          sidRequired: 'SID i Aplikacionit TwiML është ',
          apiKeyRequired: 'Çelësi i API është ',
          apiSecretRequired: 'Sekreti i API është ',
          update: 'Përditëso',
          connect: 'Lidhu',
          disconnect: 'Shkëput',
        },
        teamGate: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          applicationKey: 'Çelësi i Aplikacionit',
          authToken: 'Tokeni i Autorizimit',
          connect: 'Lidhu',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterApplicationKeyHere: 'Vendosni çelësin e aplikacionit këtu',
            enterTokenHere: 'Vendosni Tokenin këtu',
          },
        },
        wealthboxCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          accessToken: 'Tokeni i Qasjes',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          question: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterTokenHere: 'Vendosni Tokenin këtu',
          },
        },
        webhopersCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          webhoperDomain: 'Webhoper Domain',
          domainIsRequired: 'Domeni është i detyrueshëm',
          companyName: 'Emri i Kompanisë',
          companyIsRequired: 'Kompania është e detyrueshme',
          leadSource: 'Burimi i Drejtimin',
          leadSourceIsRequired: 'Burimi i Drejtimin është i detyrueshëm',
          division: 'Divizioni',
          divisionIsRequired: 'Divizioni është i detyrueshëm',
          enterPassword: 'Vendosni Fjalëkalimin',
          passwordIsRequired: 'Fjalëkalimi është i detyrueshëm',
          disconnect: 'Ç\'lidh',
          update: 'Përditëso',
          connect: 'Lidhu',
          placeholders: {
            exampleDomain: 'http://domenijuanëkompanisëtuaj',
            enterYourCompanyName: 'Vendosni Emrin e Kompanisë tuaj',
            enterLeadSource: 'Vendosni Burimin e Drejtimin',
            enterDivision: 'Vendosni Divizionin',
            enterPassword: 'Vendosni fjalëkalimin',
          },
        },
        zapierCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          name: 'Emri:',
          zapier: 'Zapier',
          inboundWebhookUrl: 'URL e Inbound Webhook',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterWebhookUrl: 'Vendosni URL e webhook',
          },
        },
        zendeskCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiToken: 'Tokeni i API',
          emailAddress: 'Adresa e Email-it',
          apiUrl: 'URL e API',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterEmailAddress: 'Vendosni adresën e email-it',
            enterUrlHere: 'Vendosni URL këtu',
            enterTokenHere: 'Vendosni Tokenin këtu',
          },
        },
        zingtreeCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiKey: 'Çelësi i API',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterApiHere: 'Vendosni API këtu',
          },
        },
        zohoCrm: {
          youHaveSuccessfullyCreatedIntegration: `Keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          connect: 'Lidhu',
          update: 'Përditëso',
          disconnect: 'Ç\'lidh',
          companyName: 'Emri i Kompanisë',
          emailAddress: 'Adresa e Email-it',
          phone: 'Telefoni',
          countryCode: 'Kodi i Shtetit',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          save: 'Ruaj',
          testLead: 'Testo Drejtimin',
          crmExtensionUrl: 'URL e zgjerimit të CRM',
          installExtension: 'Instalo Zgjerimin',
          toolTip: {
            crmExtensionUrl: 'Ekzekutoni këtë URL për të shtuar zgjerimin Zoho & mesazhe leads në WhatsApp nga Zoho CRM.',
          },
        },
        zohoDesk: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          connect: 'Lidhu',
          disconnect: 'Ç\'lidh',
          testLead: 'Testo Drejtimin',
          emailAddress: 'Adresa e Email-it',
          selectOrganizationName: 'Zgjidh Emrin e Organizatës',
          selectDepartmentName: 'Zgjidh Emrin e Departamentit',
          addParameters: 'Shto Parametrat',
          questionColon: 'Pyetje:',
          select: 'Zgjidh',
          mapsWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
        },
        zohoProject: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          testLead: 'Testo Drejtimin',
          connect: 'Lidhu',
          disconnect: 'Ç\'lidh',
          projectsList: 'Lista e Projekteve',
          selectProjectsName: 'Zgjidh Emrin e Projektit',
          projectsTaskList: 'Lista e Detyrave të Projektit',
          selectTaskListName: 'Zgjidh Emrin e Listës së Detyrave',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
        },
        wooCommerce: {
          configure: 'Konfiguro',
          automatedMessage: 'Mesazh i Automatizuar',
          configureTab: {
            wooCommercePluginApiKey: 'Çelësi i API të Shtojcës WooCommerce',
            downloadWooCommercePlugin: 'Shkarko Shtojcën WooCommerce',
          },
          automatedMessageTab: {
            abandonedRecoveryMessage: 'Mesazhi i Rikuperimit të Braktisur',
            configureAutomatedRecoveryMessagesToWinBackCustomerWhoAbandonedTheirCarts:
              'Konfiguro mesazhet e rikuperimit automatik për të rikthyer klientët që lanë shportën e tyre',
            enableAbandonedCartRecoveryMessaegs: 'Aktivizo mesazhet e rikuperimit të shportës së lënë',
            selectTemplate: 'Zgjidh Shabllonin',
            sendMessageAfter: 'Dërgo Mesazhin Pas',
            templateMessage: 'Mesazhi i Shabllonit',
            saveChanges: 'Ruaj Ndryshimet',
            selectFile: 'Zgjidh Skedarin',
            orderCompleted: 'Porosia e Plotësuar',
            templateHeader: 'Koka e Shabllonit',
            orderFulfillMent: 'Plotesimi i Porosisë',
            enableOrderConfirmationMessages:
              'Aktivizo mesazhet e konfirmimit të porosisë',
            sendAnOrderConfirmationMessageAsSoonAsACustomerPlacesAnOrder:
              'Dërgo një mesazh konfirmimi porosie sapo një klient vendos një porosi.',
            orderShipmentMessageIsSentWhenYouFulfillAnOrder:
              'Mesazhi i dërguar për dërgesën e porosisë kur e plotesoni një porosi.',
            enableOrderFulfillmentMessages: 'Aktivizo mesazhet e plotesimit të porosisë',
            returnExchangeRequest: 'Kërkesa për Kthim/ndërrim',
            theMessageIsSentAfterARefundIsRequested:
              'Mesazhi dërgohet pasi kërkohej një rimbursim',
            enableOrderRefundMessages: 'Aktivizo mesazhet e rimbursimit të porosisë',
          },
        },
        shopify: {
          configure: 'Konfiguro',
          automatedMessage: 'Mesazh i Automatizuar',
          configureTab: {
            enterYourShopifyDomain: 'Vendosni domainin tuaj të Shopify',
            disconnect: 'Shkëput',
            integrated: 'Integruar',
            install: 'Instalo',
          },
          automatedMessageTab: {
            shopifyAutomatedMessage: 'Mesazh i Automatizuar për Shopify',
            viewYourCashOnDeliveryInsights: 'Shikoni analizat tuaja të pagesës në dorëzim në para.',
            noTemplateFound: 'Nuk u gjet asnjë shabllon',
            hours: 'Orë',
            minutes: 'Minuta',
            saveChanges: 'Ruaj Ndryshimet',
            selectTemplate: 'Zgjidh Shabllonin',
            templateMessage: 'Mesazhi i Shabllonit',
            selectFile: 'Zgjidh Skedarin',
            templateHeader: 'Koka e Shabllonit',
            sendMessageAfter: 'Dërgo Mesazh Pas',
            select: 'Zgjidh',
            abandonedCartRecovery: 'Rikuperim i Shportës së braktisur',
            abandonedCartDescription: 'Njoftoni përdoruesit për shportat e braktisura për ndjekje nëpërmjet bisedës në WhatsApp.',
            enableAbandonedCartRecoveryMessages: 'Aktivizo Mesazhet e Rikuperimit të Shportës së Braktisur',
            orderCreated: 'Porosia është Krijuar',
            orderCreatedDescription: 'Dërgoni alerta të menjëhershme për vendosjet e reja të porosisë për klientët tuaj.',
            enableOrderCreatedMessages: 'Aktivizo Mesazhet e Krijuara të Porosisë',
            codOrderTracking: 'Ndjekja e Porosisë COD',
            codOrderTrackingDescription: 'Jepni një lidhje ndjekjeje në bisedën në WhatsApp për të lejuar përdoruesit të ndjekin porositë në dorëzim në kohë reale.',
            enableCodOrderTrackingMessages: 'Aktivizo Mesazhet e Ndjekjes së Porosisë COD',
            orderFulfilled: 'Porosia është Plotësuar',
            orderFulfilledDescription: 'Dërgoni njoftime klientëve tuaj kur porosia bëhet me sukses.',
            enableOrderFulfilledMessages: 'Aktivizo Mesazhet e Plotësuara të Porosisë',
            orderCancelled: 'Porosia është Anuluar',
            orderCancelledDescription: 'Shfaqni dhe konfirmoni porositë e anuluara në mënyrë efikase në WhatsApp.',
            enableOrderCancelledMessages: 'Aktivizo Mesazhet e Anuluara të Porosisë',
            orderReturnRequestPlaced: 'Kërkesa për Kthim të Porosisë është Vendosur',
            orderReturnRequestPlacedDescription: 'Njoftoni klientët kur vendosin një kërkesë për kthim në dyqanin tuaj Shopify.',
            enableOrderReturnRequestPlacedMessages: 'Aktivizo Mesazhet e Vendosura për Kthimin e Porosisë',
            orderReturned: 'Porosia është Kthyer (Rimbursuar)',
            orderReturnedDescription: 'Dërgo përditësime klientëve kur porosia e tyre e kthyer është plotësuar.',
            enableOrderRefundMessages: 'Aktivizo Mesazhet e Rimbursimit të Porosisë',
          }
        },
        goHighLevel: {
          youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
          apiToken: 'Tokeni i API',
          nameIsRequired: 'Emri është i detyrueshëm',
          connect: 'Lidhu',
          testLead: 'Testo Drejtimin',
          questionColon: 'Pyetje:',
          addParameters: 'Shto Parametrat',
          select: 'Zgjidh',
          mapWith: 'lidh me',
          selectParameter: 'Zgjidh Parametrin',
          update: 'Përditëso',
          save: 'Ruaj',
          disconnect: 'Ç\'lidh',
          placeholders: {
            enterApiToken: 'Vendosni Tokenin e API',
          },
        },
      },
    },
    createIntegration: {
      createNewIntegration: 'Krijo Integrim të Ri',
      youDoNotHaveAnyIntegrationSetupAsOfNow:
        'Nuk keni konfiguruar asnjë integrim deri më tani.',
      pleaseCreateOneToIntegrateYourFavourite:
        'Ju lutemi krijoni një për të integruar aplikacionet tuaja të preferuara',
      appsWith: 'aplikacionet me ',
      integrationName: 'Emri i Integrimi',
      integrationNameIsRequired: 'Emri i integrimi është i detyrueshëm',
      continue: 'Vazhdo',
      addAnImageToRepresentYourIntegration:
        'Shtoni një imazh për të paraqitur integrimin tuaj.',
      description: 'Përshkrim',
      submit: 'Dërgo',
      youHaveSuccessfullyCreatedIntegration: `Ju keni krijuar me sukses integrimin. Tani, mund ta konfiguroni.`,
      apiUrl: 'URL e API-së',
      pleaseEnterAValidApiUrl: 'Ju lutemi vendosni një URL të vlefshëm të API-së',
      requestMethod: 'Metoda e Kërkesës',
      get: 'Merr',
      post: 'Posto',
      put: 'Vendos',
      patch: 'Patch',
      queryParameter: 'Parametri i Kërkesës',
      addParameter: ' Shto Parametrin',
      mapsWith: ' lidh me',
      question: 'Pyetje',
      addQuestion: ' Shto Pyetje',
      select: 'Zgjidh',
      selectParameter: ' Zgjidh Parametrin',
      header: 'Header ',
      addHeader: ' Shto Header',
      value: 'Vlera',
      connect: 'Lidhu',
      requestBody: 'Trupi i Kërkesës',
      validate: 'Valido',
      key: 'Çelësi',
    },
    myIntegrations: {
      integrationDetails: {
        canAlsoBeIntegratedWith: 'mund të integrohet gjithashtu me këtë CRM falas.',
        apiUrl: 'URL e API-së',
        pleaseEnterAValidApiUrl: 'Ju lutemi vendosni një URL të vlefshëm të API-së',
        requestMethod: 'Metoda e Kërkesës:',
        get: 'Merr',
        post: 'Posto',
        put: 'Vendos',
        patch: 'Patch',
        queryParameter: 'Parametri i Kërkesës',
        addParameter: ' Shto Parametrin',
        header: 'Header ',
        addHeader: ' Shto Header',
        requestBody: 'Trupi i Kërkesës',
        validateJson: 'Valido JSON',
        connect: 'Lidhu',
        update: 'Përditëso',
        delete: 'Fshij',
        selectTheQuestion:
          'Zgjidhni pyetjen për të cilën dëshironi të dërgoni përgjigjen e përdoruesit si vlerë',
        appTooltip: {
          typeYourJsonCode: 'Shkruani kodin tuaj JSON',
          clickToValidateJsonCode: 'Kliko për të validuar kodin JSON',
        },
      },
      list: {
        customAppsIntegrations: 'Integrimet e Aplikacioneve të Personalizuara',
        integrateYourAppsWith: 'Integroni aplikacionet tuaja me ',
        help: 'Ndihmë',
        addIntegration: ' Shto Integrim',
        name: 'Emri',
        status: 'Statusi',
        action: 'Veprim',
        insatlled: 'I instaluar',
        edit: 'Ndrysho',
        connect: 'Lidhu',
        requestYourIntegration: 'Kërko integrimin tënd',
        toRequestNewIntegration:
          'Për të kërkuar një integrim të ri, ju lutemi vendosni detajet e mëposhtme dhe pastaj ne do të kthehemi te ju.',
        // name: 'Emri'
        emailId: 'ID e Email-it',
        integrationName: 'Emri i Integrimi',
        contactNumber: 'Numri i Kontaktit',
        howSoonYouWantToAddThisIntegration:
          'Sa shpejt dëshironi të shtoni këtë Integrim',
        sendRequest: 'Dërgo Kërkesën',
        cancel: 'Anulo',
        delete: 'Fshij',
        oopsOwnIntegrationsAreSupportedOnlyIn:
          'Ooops! Integrimet tuaja janë të mbështetura vetëm në',
        plan: 'Plan',
        pleaseUpgradeTo: 'Ju lutemi përmirësohuni në',
        toCreateOwnIntegrations: 'për të krijuar Integrimet e Veta',
        appTooltip: {
          integrations: 'Integrimet',
          noIntegrationsFound: 'Nuk u gjetën Integrimet!',
          nameOfYourApp: 'Emri i aplikacionit tuaj',
          clickToConnectApp: 'Kliko për të lidhur Aplikacionin',
          statusAsConnectedOrNotConnected:
            'Statusi si i lidhur / jo i lidhur',
        },
      },
    },
  },
};
